import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import SignatureCanvas from "react-signature-canvas";
import { Row, Col, Container } from "react-bootstrap";
import $ from "jquery";
import {
  TextField,
  Checkbox,
  Radio,
  FormControlLabel,
  FormGroup,
  FormControl,
  Button,
  FormHelperText,
} from "@material-ui/core";
import { APP_LIVE_URL, ADMIN_URL } from "../../config/config";
import {
  DateTimePicker,
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import axios from "axios";
import DateFnsUtils from "@date-io/date-fns";
import { CopyToClipboard } from "react-copy-to-clipboard";
import html2canvas from "html2canvas";

import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Select from "react-select";
import countryList from "react-select-country-list";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Tooltip from "@material-ui/core/Tooltip";
import { diffWords } from "diff";
import { marked } from "marked";
import DOMPurify from "dompurify";
import ReCAPTCHA from "react-google-recaptcha";

const populatedynamicValues = (clientsData, value_name) => {
  if (clientsData && clientsData.length > 0) {
    const valueMap = {
      fullname: clientsData[0].name,
      company: clientsData[0].comp_name,
      email: clientsData[0].email,
      phone: clientsData[0].phone,
      address: clientsData[0].address,
      appartment: clientsData[0].address2,
      city: clientsData[0].city,
      state: clientsData[0].state,
      zip: clientsData[0].zip,
      country: clientsData[0].country,
    };

    if (value_name === "full_address") {
      return [
        clientsData[0].address,
        clientsData[0].address2,
        clientsData[0].city,
        clientsData[0].state,
        clientsData[0].zip,
        clientsData[0].country,
      ]
        .filter(Boolean)
        .join(", ");
    }

    return valueMap[value_name] || "";
  } else {
    return "";
  }
};

const loadFonts = () => {
  const link = document.createElement("link");
  link.href =
    "https://fonts.googleapis.com/css2?family=Amita&family=Bad+Script&family=Damion&family=Dancing+Script&family=Felipa&family=Julee&family=Kaushan+Script&family=Lugrasimo&family=Pacifico&family=Sofia&family=Yellowtail&display=swap";
  link.rel = "stylesheet";
  document.head.appendChild(link);
};

const cursiveFonts = [
  { name: "Your Signature", value: "'Amita', cursive" },
  { name: "Your Signature", value: "'Bad Script', cursive" },
  { name: "Your Signature", value: "'Damion', cursive" },
  { name: "Your Signature", value: "'Dancing Script', cursive" },
  { name: "Your Signature", value: "'Felipa', cursive" },
  { name: "Your Signature", value: "'Julee', cursive" },
  { name: "Your Signature", value: "'Kaushan Script', cursive" },
  { name: "Your Signature", value: "'Lugrasimo', cursive" },
  { name: "Your Signature", value: "'Pacifico', cursive" },
  { name: "Your Signature", value: "'Sofia', cursive" },
  { name: "Your Signature", value: "'Yellowtail', cursive" },
  // Add more cursive fonts here
];

const FormRendererAgent = ({
  formData,
  formTitle,
  formDescription,
  onSubmit,
  onToast,
  groups,
  responseMessage,
  clientData,
  chatgpt_intergation,
  chatgpt_api_key,
  allow_submit,
  draftData,
  saveDraft,
  progressStep,
  viewFrom,
  allow_agent_name,
  isFormInReviewMode,
  isCurrentStepFilled,
  isOnboarding,
  partnerAccountNo,
  formAccountNo,
  formToken,
  stepTitle,
  partnerData,
  allowSkip,
  onSkipStep,
  stepsData,
  isFilled = 0,
  isSkipped = 0,
  onNextStep = () => {},
  captcha_enabled = 0,
  link_form = 0,
}) => {
  // console.log("chatgpt_intergation: ", chatgpt_intergation);
  // console.log("chatgpt_api_key: ", chatgpt_api_key);

  const [formState, setFormState] = useState({});

  const isLeadFormEnabled = formState["__user_form__"] === "Yes";
  const [formErrors, setFormErrors] = useState({});
  const [validationSummary, setValidationSummary] = useState(null); // { count, firstId } | null
  const [errorMessage, setErrorMessage] = useState("");
  const [currentStep, setCurrentStep] = useState(progressStep);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [signatureType, setSignatureType] = useState("draw");
  const [signatureText, setSignatureText] = useState("");
  const [signatureClass, setSignatureClass] = useState("'Amita', cursive");
  const sigPadRefs = useRef([]);

  const [country, setCountry] = useState("");
  const [Address, setAddress] = useState("");
  const [submission, setSubmission] = useState("");

  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [currentAIQuestion, setCurrentAIQuestion] = useState(null);
  const [generatedText, setGeneratedText] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);
  const [chatgptEnabled, setChatgptEnabled] = useState(false);
  const [isFollowUp, setIsFollowUp] = useState(false);
  const [modalError, setModalError] = useState("");
  const [diffOutput, setDiffOutput] = useState(null);
  const [originalAnswer, setOriginalAnswer] = useState("");
  const [abortController, setAbortController] = useState(null);
  const [streamingLineIndex, setStreamingLineIndex] = useState(null);

  const [previewAgentName, setPreviewAgentName] = useState("");
  const DEFAULT_THEME_COLOR = "#d4af37";

  const [selectedThemeColor, setSelectedThemeColor] = useState(() => {
    // initialize once — not every re-render
    return localStorage.getItem("selectedThemeColor") || DEFAULT_THEME_COLOR;
  });

  const [previewThemeColor, setPreviewThemeColor] =
    useState(selectedThemeColor);

  // CAPTCHA state
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);

  // Single-page layout state
  const [hoveredId, setHoveredId] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [showFloatingNav, setShowFloatingNav] = useState(false);
  const [mobileNavVisible, setMobileNavVisible] = useState(false);

  // Single-page layout refs
  const sectionRefs = useRef([]);
  const tabsContainerRef = useRef(null);
  const heroRef = useRef(null);
  const mobileNavTimerRef = useRef(null);
  const isScrollingRef = useRef(false);
  const isSPLayout = viewFrom === "agent-logged-in" || viewFrom === "agent-not-logged-in";

  // Determine if CAPTCHA should be shown
  // CAPTCHA is shown when:
  // 1. captcha_enabled === 1
  // 2. NOT a link form (link_form !== 1)
  // 3. For multi-step forms: only on the last step
  // 4. For single-step forms: always if captcha_enabled
  const isLastStep = groups && groups.length > 0 ? currentStep === groups.length - 1 : true;
  const isMultiStepForm = groups && groups.length > 1;
  const formDataKey = JSON.stringify(formData || []);
  const shouldShowCaptcha = 
    captcha_enabled === 1 && 
    link_form !== 1 && 
    (isMultiStepForm ? isLastStep : true);

  const showToastError = (message, title = "Error") => {
    const cleanedMessage = String(message || "There is some error while processing your request.")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (typeof onToast === "function") {
      onToast(cleanedMessage, "error", title);
    }
  };

  const showToastSuccess = (message, title = "Success") => {
    const cleanedMessage = String(message || "Action completed successfully.")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (typeof onToast === "function") {
      onToast(cleanedMessage, "success", title);
    }
  };

  const showToastWarning = (message, title = "Missing Fields") => {
    const cleanedMessage = String(message || "Please review the highlighted field.")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (typeof onToast === "function") {
      onToast(cleanedMessage, "warning", title);
    }
  };

  const hasUserEnteredData = (stateObj) => {
    if (!stateObj) return false;

    return Object.values(stateObj).some((value) => {
      if (value === undefined || value === null) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (Array.isArray(value)) return value.length > 0;
      return true;
    });
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleCaptchaExpired = () => {
    setCaptchaToken(null);
  };

  // 🔥 Ensures a NEW form entry always loads defaults
  useEffect(() => {
    if (!sessionStorage.getItem("formInitialized")) {
      sessionStorage.setItem("skipResetDefaults", "false");
      sessionStorage.setItem("formInitialized", "true");
    }
  }, []);

  // persist color in localStorage
  useEffect(() => {
    localStorage.setItem("selectedThemeColor", selectedThemeColor);
  }, [selectedThemeColor]);

  const modalRef = useRef(null);

  const countryOptions = countryList().getData();

  // KEEP THIS - it's for chatgpt only
  useEffect(() => {
    if (chatgpt_intergation === "Yes") {
      setChatgptEnabled(true);
    } else {
      setChatgptEnabled(false);
    }
  }, [chatgpt_intergation]);

  // KEEP THIS - it's for scrolling only
  useEffect(() => {
    if (!diffPreviewRef.current) return;
    const container = diffPreviewRef.current;
    // ... keep the scrolling logic
    setCurrentStep(progressStep || 0);
  }, [diffOutput, isGenerating, formDataKey, groups, progressStep]);

  // ADD THIS SINGLE FORM INITIALIZATION EFFECT
  useEffect(() => {
    if (sessionStorage.getItem("skipResetDefaults") === "true") {
      return;
    }
    if (!formData?.length) return;


    const initialState = {};
    let assistantName = "Maya";
    let agentId = generateUUIDv4();
    let userFormValue = "No";
    let agentRoom = generateAgentRoom();

    // Check for existing values in draft data
    if (draftData && draftData.length > 0) {
      // Extract special fields from draft
      const draftName = draftData[0].questions.find(
        (q) => q.id === "__assistant_name__",
      );
      const draftId = draftData[0].questions.find(
        (q) => q.id === "__agent_id__",
      );
      const draftForm = draftData[0].questions.find(
        (q) => q.id === "__user_form__",
      );

      if (draftName?.answer) assistantName = draftName.answer;
      if (draftId?.answer) agentId = draftId.answer;
      if (draftForm?.answer) userFormValue = draftForm.answer;

      // Create a map of all draft answers for easy lookup
      const draftAnswersMap = {};
      draftData[0].questions.forEach((draftQuestion) => {
        if (draftQuestion.answer !== undefined && draftQuestion.answer !== "") {
          draftAnswersMap[draftQuestion.id] = draftQuestion.answer;
        } else {
          // No answer in draft, check for dynamic value
          const formQuestion = formData[0]?.questions.find(
            (q) => q.id === draftQuestion.id,
          );
          if (formQuestion?.dynamicValue) {
            initialState[draftQuestion.id] = populatedynamicValues(
              clientData,
              formQuestion.dynamicValue,
            );
          } else if (formQuestion?.defaultValue) {
            initialState[draftQuestion.id] = formQuestion.defaultValue;
          } else {
            initialState[draftQuestion.id] = "";
          }
        }
      });


      // Process ALL form questions (not just draft questions)
      formData.forEach((section) => {
        section.questions.forEach((question) => {
          // If we have a draft answer, use it (highest priority)
          if (draftAnswersMap.hasOwnProperty(question.id)) {
            initialState[question.id] = draftAnswersMap[question.id];
            
          }
          // No draft answer, check for dynamic value
          else if (question.dynamicValue) {
            initialState[question.id] = populatedynamicValues(
              clientData,
              question.dynamicValue,
            );
          }
          // No draft, no dynamic value, use defaultValue with placeholders
          else if (question.defaultValue) {
            initialState[question.id] = replaceNamePlaceholders(
              question.defaultValue,
              assistantName,
              agentId,
              userFormValue,
              agentRoom,
            );
          }
          // Fallback to empty string
          else {
            initialState[question.id] = "";
          }
        });
      });
    } else {
      // No draft data - initialize with defaults
      formData.forEach((section) => {
        section.questions.forEach((question) => {
          if (question.dynamicValue) {
            initialState[question.id] = populatedynamicValues(
              clientData,
              question.dynamicValue,
            );
          } else if (question.defaultValue) {
            initialState[question.id] = replaceNamePlaceholders(
              question.defaultValue,
              assistantName,
              agentId,
              userFormValue,
              agentRoom,
            );
          } else {
            initialState[question.id] = "";
          }
        });
      });
    }

    // Always set the special fields
    initialState["__assistant_name__"] = assistantName;
    initialState["__agent_id__"] = agentId;
    initialState["__user_form__"] = userFormValue;
    initialState["__agent_room__"] = agentRoom;

    if (formState && formState.__theme_color__) {
      initialState.__theme_color__ = formState.__theme_color__;
    }
    setFormState((prevState) => {
      if (!prevState || Object.keys(prevState).length === 0) {
        return initialState;
      }

      if (hasUserEnteredData(prevState)) {
        return {
          ...initialState,
          ...prevState,
        };
      }

      return initialState;
    });
  }, [clientData, formDataKey, draftData]); // Only these dependencies

  const hasUngroupedQuestions = formData.some((form) =>
    form.questions.some((q) => !groups?.flat().includes(q.id)),
  );

  const ungroupedQuestions = formData
    .flatMap((form) => form.questions)
    .filter((question) => !groups.flat().includes(question.id));

  const handleChange = (questionId, value, inputFormat) => {
    if (inputFormat === "number_only") {
      value = value.replace(/[^0-9]/g, "");
    } else if (inputFormat === "alphabet_only") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (inputFormat === "alphanumeric") {
      value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    }

    setFormState((prev) => ({
      ...prev,
      [questionId]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [questionId]: "",
    }));
  };

  const handleChangeSignature = (questionId, value) => {
    setSignatureText(value);
  };

  const handleChangeFixed = (questionId, value) => {
    setFormState({
      ...formState,
    });
  };

  function replaceNamePlaceholders(
    text,
    name,
    agentId,
    formValue = "No",
    agentRoom,
  ) {
    if (!text) return text;
    return text
      .replace(/\{name\}/g, name || "")
      .replace(/\{agentId\}/g, agentId || "")
      .replace(/\{form_value\}/g, formValue || "No")
      .replace(/\{agent_room\}/g, agentRoom || ""); // ✅ Added
  }

  // Generate UUID for agentId
  const generateUUIDv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  // ✅ Generate base room with 6-char alphanumeric suffix
  function generateAgentRoom() {
    const suffix = Math.random().toString(36).substring(2, 8).toUpperCase();
    return `obs_room_${suffix}`;
  }

  const handleAssistantNameChange = (newName) => {
    const currentTheme = selectedThemeColor;

    const previousName = formState["__assistant_name__"] || "";

    const updatedFields = {
      __assistant_name__: newName,
    };

    // 1️⃣ If user fully removed agent name -> restore placeholder everywhere
    const nameIsEmpty = newName.trim() === "";

    formData.forEach((section) => {
      section.questions.forEach((question) => {
        const hasPlaceholders =
          question.defaultValue &&
          typeof question.defaultValue === "string" &&
          (question.defaultValue.includes("{name}") ||
            question.defaultValue.includes("{agentId}") ||
            question.defaultValue.includes("{form_value}") ||
            question.defaultValue.includes("{agent_room}"));

        if (!hasPlaceholders) return;

        const fieldId = question.id;
        const currentValue = formState[fieldId] || "";


        let updatedValue = currentValue;

        // -------------------------------------------------------------------
        // CASE A — Name removed completely → restore placeholder `{name}`
        // -------------------------------------------------------------------
        if (nameIsEmpty) {

          // Replace old name with placeholder ONLY in the expected location
          if (previousName.trim().length > 0) {
            const nameRegex = new RegExp(`\\b${previousName}\\b`, "g");
            updatedValue = updatedValue.replace(nameRegex, "{name}");
          }

          // If the placeholder doesn't exist, but field originally had it
          if (
            !updatedValue.includes("{name}") &&
            question.defaultValue.includes("{name}")
          ) {
            // Insert placeholder at the earliest old name position
            updatedValue = question.defaultValue.replace(/\{name\}/g, "{name}");
          }

          updatedFields[fieldId] = updatedValue;
          return; // Stop further processing for this field
        }

        // -------------------------------------------------------------------
        // CASE B — Normal name syncing
        // -------------------------------------------------------------------

        // 1️⃣ Replace `{name}` placeholder
        if (updatedValue.includes("{name}")) {
          
          updatedValue = updatedValue.replace(/\{name\}/g, newName);
        } else {
        }

        // 2️⃣ Replace previousName if exists as standalone
        if (previousName.trim().length > 0) {
          const escaped = previousName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

          // match previous name even when followed by space or punctuation
          const safeRegex = new RegExp(escaped + "(?=\\b|\\s|$)", "g");

          if (safeRegex.test(updatedValue)) {
            
            updatedValue = updatedValue.replace(safeRegex, newName);
          } else {
          }
        }

        updatedFields[fieldId] = updatedValue;
      });
    });


    setFormState((prev) => ({
      ...prev,
      ...updatedFields,
      __theme_color__: currentTheme,
    }));

    requestAnimationFrame(() => {
      setSelectedThemeColor(currentTheme);
      setPreviewThemeColor(currentTheme);
    });
  };

  // const handleCheckboxChange = (questionId, option, isChecked) => {
  //   const currentOptions = formState[questionId] || [];
  //   if (isChecked) {
  //     setFormState({
  //       ...formState,
  //       [questionId]: [...currentOptions, option],
  //     });
  //   } else {
  //     setFormState({
  //       ...formState,
  //       [questionId]: currentOptions.filter((opt) => opt !== option),
  //     });
  //   }
  //   setFormErrors({
  //     ...formErrors,
  //     [questionId]: "",
  //   });
  // };

  const handleCheckboxChange = (questionId, option, isChecked) => {
    setFormState((prevState) => {
      const currentOptions = prevState[questionId] || [];

      let updatedOptions;
      if (isChecked) {
        updatedOptions = [...currentOptions, option];
      } else {
        updatedOptions = currentOptions.filter((opt) => opt !== option);
      }
      return {
        ...prevState,
        [questionId]: updatedOptions,
      };
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [questionId]: "",
    }));
  };

  const handleFileChange = (questionId, event) => {
    if (event.target && event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        axios
          .post(
            `${process.env.REACT_APP_API_URL}forms/form_image_response`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          )
          .then((response) => {
            // console.log("handleFileChange: ", response);
            const imageUrl = response.data.default;
            setFormState((prevFormState) => ({
              ...prevFormState,
              [questionId]: imageUrl,
            }));
            setFormErrors((prevFormErrors) => ({
              ...prevFormErrors,
              [questionId]: "",
            }));
          })
          .catch((error) => {
            console.error("There was an error uploading the image!", error);
          });
      }
    } else {
      console.error("No file selected or event target is undefined.");
    }
  };

  const removeUploadedFile = (questionId) => {
    if (questionId && questionId !== "") {
      const formData = new FormData();
      setFormState((prevFormState) => ({
        ...prevFormState,
        [questionId]: "",
      }));
    }
  };

  const isPhoneValid = (value) => {
    if (!value) return false;
    try {
      const parsed = parsePhoneNumberFromString("+" + value.replace(/^\+/, ""));
      return parsed ? parsed.isValid() : false;
    } catch {
      return false;
    }
  };

  // A phone control seeded with only a dial code has no national number;
  // treat that as empty so optional phones pass and required ones report "required".
  const isPhoneEmpty = (value) => {
    if (!value || !String(value).trim()) return true;
    try {
      const parsed = parsePhoneNumberFromString("+" + String(value).replace(/^\+/, "").trim());
      const nsn = parsed?.nationalNumber;
      return !nsn || nsn === "0";
    } catch {
      return true;
    }
  };

  const handleChangeCountry = (questionId, selectedOption) => {
    const selectedLabel = selectedOption ? selectedOption.label : "";

    setFormState((prevState) => ({
      ...prevState,
      [questionId]: selectedLabel,
    }));

    setFormErrors((prevState) => ({
      ...prevState,
      [questionId]: "",
    }));

    setCountry(selectedOption);

    //console.log("Selected Country Label:", selectedLabel);
  };

  const handleAddressSelect = async (questionId, place) => {
    // console.log("place", place);

    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const formattedAddress = data.results[0].formatted_address;
        const addressComponents = data.results[0].address_components;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        let zip = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        let full_address =
          streetAddress +
          address2 +
          ", " +
          city +
          ", " +
          state +
          ", " +
          zipCode +
          ", " +
          country;

        setFormState((prevState) => ({
          ...prevState,
          [questionId]: full_address || "",
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          [questionId]: "",
        }));

        // Store the formatted address
        setAddress(full_address || "");
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  const handleChangePhone = (questionId, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [questionId]: value,
    }));

    setFormErrors((prevState) => ({
      ...prevState,
      [questionId]: "",
    }));

    //console.log("Phone Number:", value);
  };

  // Add this new function after your other handler functions (around line 450)
  const resetFormToDefaults = () => {
    const initialState = {};
    formData.forEach((section) => {
      section.questions.forEach((question) => {
        if (question.dynamicValue) {
          initialState[question.id] = populatedynamicValues(
            clientData,
            question.dynamicValue,
          );
        } else {
          initialState[question.id] = question.defaultValue || "";
        }
      });
    });
    setFormState(initialState);
    setFormErrors({});
    setErrorMessage("");
  };

  useEffect(() => {
    if (!diffPreviewRef.current) return;

    const container = diffPreviewRef.current;

    if (isGenerating && diffOutput) {
      // ✅ During generation: scroll to active line within container
      requestAnimationFrame(() => {
        const activeLine = container.querySelector("#active-streaming-line");
        if (activeLine) {
          // Calculate position relative to container
          const containerTop = container.scrollTop;
          const containerHeight = container.clientHeight;
          const lineTop = activeLine.offsetTop;
          const lineHeight = activeLine.clientHeight;

          // Calculate center position
          const centerPosition = lineTop - containerHeight / 2 + lineHeight / 2;

          // Only scroll if needed
          const isVisible =
            lineTop >= containerTop &&
            lineTop + lineHeight <= containerTop + containerHeight;

          if (!isVisible) {
            container.scrollTo({
              top: Math.max(0, centerPosition),
              behavior: "smooth",
            });
          }
        }
      });
    } else if (!isGenerating && diffOutput) {
      // ✅ After generation: scroll to top within container
      setTimeout(() => {
        container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 300);
    }
  }, [diffOutput, isGenerating]);

  const handleSubmit = async () => {
    // Prevent form submission if in review mode
    if (isFormInReviewMode) {
      // console.log("📋 Form is in review mode - submission disabled");
      setErrorMessage(
        "This form is in review mode. You cannot submit changes.",
      );
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    sessionStorage.setItem("skipResetDefaults", "true");
    const requiredQuestions = formData.flatMap((form) =>
      form.questions.filter((question) => question.required),
    );

    const currentGroup = groups[currentStep];

    const validationQuestions = formData.flatMap((form) =>
      form.questions.filter(
        (question) =>
          question.validationValue &&
          currentGroup.questions.includes(question.id),
      ),
    );

    let hasErrors = false;
    let emptyFieldMessages = [];
    let validationMessages = [];
    let filerId = null; // Initialize variable to store filer_id
    let fullAddress = null; // Initialize variable to store full_address

    requiredQuestions.forEach((question) => {
      const value = String(
        formState[question.id] ?? question.defaultValue ?? "",
      );
      const requiredEmpty =
        question.validationValue === "validation_phone"
          ? isPhoneEmpty(value)
          : value.trim() === "";
      if (question.required && requiredEmpty) {
        hasErrors = true;
      }
    });

    const { isValid, missingFields } = validateCurrentGroup();

    if (!isValid) {
      const fieldsList = missingFields.join(", ");
      emptyFieldMessages.push(
        `Please fill out all required fields: ${fieldsList}`,
      );
      hasErrors = true;
    }

    validationQuestions.forEach((question) => {
      const value = formState[question.id]?.trim();
      // console.log("value", value);

      if (value && value !== "") {
        // Perform various validations based on question validation value
        if (question.validationValue === "validation_email") {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid email address.");
          }
        }

        if (question.validationValue === "validation_phone") {
          if (!isPhoneEmpty(value) && !isPhoneValid(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid phone number.");
          }
        }

        if (question.validationValue === "validation_zip") {
          const zipRegex = /^[A-Za-z0-9\s\-]{4,10}$/;
          if (!zipRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid postal code.");
          }
        }

        if (question.validationValue === "validation_address") {
          const addressRegex = /^[0-9a-zA-Z\s,.'\-#()]+$/;
          const wordCount = value.trim().split(/\s+/).length;

          if (!addressRegex.test(value) || wordCount < 5) {
            hasErrors = true;
            validationMessages.push(
              "Please enter a complete address containing at least 5 words.",
            );
          }
        }

        if (question.validationValue === "validation_city") {
          const cityRegex = /^[a-zA-Z\s.'\-áéíóúÁÉÍÓÚñÑüÜ]+$/;
          if (!cityRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "City must contain only letters, spaces, hyphens, or valid special characters.",
            );
          }
        }

        if (question.validationValue === "validation_state") {
          const stateRegex = /^[a-zA-Z\s]+$/;
          if (!stateRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "State should contain only letters and spaces.",
            );
          }
        }

        if (question.validationValue === "validation_ip") {
          // IPv4 regex - no leading zeros allowed
          const ipv4Regex =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

          // IPv6 regex - supports shorthand (::) and expanded addresses
          const ipv6Regex =
            /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|::(?:[a-fA-F0-9]{1,4}:){0,5}(?:[a-fA-F0-9]{1,4})$/;

          if (!ipv4Regex.test(value) && !ipv6Regex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Please enter a valid IP address (IPv4 or IPv6).",
            );
          }
        }

        if (question.validationValue === "validation_filerId") {
          const filerIdRegex = /^[A-Z0-9]{0,10}$/;
          if (!filerIdRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Filer ID should be exactly 6 alphanumeric characters.",
            );
          }
          if (value) {
            filerId = value;
          }
        }

        if (question.validationValue === "validation_fulladdress") {
          if (value) {
            fullAddress = value;
          }
        }
      }
    });

    if (hasErrors) {
      let finalErrorMessage = "";

      if (emptyFieldMessages.length > 0) {
        finalErrorMessage += emptyFieldMessages.join("<br />") + "<br />";
      }

      if (validationMessages.length > 0) {
        finalErrorMessage += validationMessages.join("<br />");
      }

      setErrorMessage(finalErrorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return;
    }

    // CAPTCHA validation
    if (shouldShowCaptcha && (!captchaToken || captchaToken === "")) {
      setErrorMessage("Please complete the CAPTCHA.");
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return;
    }

    setLoading(true);
    //console.log("formData Before: ", formData);
    try {
      // Only verify if both filerId and fullAddress are present
      if (filerId && fullAddress) {
        await verifyInfoSubmit(filerId, fullAddress);
      }

      const assistantName = formState["__assistant_name__"] || "Maya";

      // Prepare form data to send
      const formDataToSend = formData.map((form) => ({
        title: form.title,
        id: form.id,
        questions: [
          ...form.questions.map((question) => ({
            ...question,
            answer:
              question.answerType === "fixed"
                ? question.answer
                : formState[question.id],
          })),
          // ✅ Add agent name field as hidden meta entry
          {
            id: "__assistant_name__",
            questionText: "Agent / Assistant Name",
            answerType: "text",
            answer: assistantName,
            required: true,
          },
          {
            id: "__agent_id__", // ✅ Add this
            questionText: "Agent ID",
            answerType: "input",
            answer: formState["__agent_id__"] || generateUUIDv4(),
            required: true,
          },
          {
            id: "__user_form__",
            questionText: "User Form Enabled",
            answerType: "dropdown",
            answer: formState["__user_form__"] || "No",
            required: false,
          },
        ],
        errorMessage: form.errorMessage,
      }));

      // Submit form data only after the verification is complete (if needed)
      await onSubmit(formDataToSend);
      setTimeout(() => {
        setLoading(false);
      }, 4500);
    } catch (error) {
      console.error("Error submitting the form:", error);
      setLoading(false);
    }
  };

  /*const handleSubmit = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const requiredQuestions = formData.flatMap((form) =>
      form.questions.filter((question) => question.required)
    );
    let hasErrors = false;

    requiredQuestions.forEach((question) => {
      if (!formState[question.id]) {
        hasErrors = true;
      }
    });

    if (hasErrors) {
      setErrorMessage("Please fill out all required fields.");
      setTimeout(() => {
        setErrorMessage("");
      }, 2500);
      return;
    }
    setLoading(true);
    //console.log("formData Before: ", formData);
    const formDataToSend = formData.map((form) => ({
      title: form.title,
      id: form.id,
      questions: form.questions.map((question) => ({
        ...question,
        //answer: formState[question.id],
        answer:
          question.answerType === "fixed"
            ? question.answer
            : formState[question.id],
      })),
      errorMessage: form.errorMessage,
    }));
    //console.log("formDataToSend: ", formDataToSend);
    onSubmit(formDataToSend);
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  };*/

  /*const validateCurrentGroup = () => {
    const currentGroup = groups[currentStep];
    if (!currentGroup) return false;

    const hasEmptyRequiredFields = currentGroup.questions.some((questionId) => {
      const question = formData[0].questions.find((q) => q.id === questionId);
      
      if (question) {
        //return question.required && !formState[question.id];
        return question;
      }
    });

    return !hasEmptyRequiredFields;
  };*/

  /*const handleNextStep = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const { isValid, missingFields } = validateCurrentGroup();

    if (isValid) {
      setCurrentStep(currentStep + 1);
    } else {
      const fieldsList = missingFields.join(", ");
      setErrorMessage(`Please fill out all required fields: ${fieldsList}`);
      setTimeout(() => {
        setErrorMessage("");
      }, 4500);
    }
  };*/

  const handleNextStep = async () => {
    sessionStorage.setItem("skipResetDefaults", "true");
    setErrorMessage("");
    const { isValid, missingFields } = validateCurrentGroup();
    window.scrollTo({ top: 0, behavior: "smooth" });
    let hasErrors = false;
    let emptyFieldMessages = [];
    let validationMessages = [];
    let filerId = null; // Initialize variable to store filer_id
    let fullAddress = null; // Initialize variable to store full_address

    const assistantName = formState["__assistant_name__"]?.trim() || "";
    if (allow_agent_name) {
      if (!assistantName) {
        hasErrors = true;
        validationMessages.push("Please enter the Agent/Assistant Name.");
      }
    }

    if (!isValid) {
      const fieldsList = missingFields.join(", ");
      emptyFieldMessages.push(
        `Please fill out all required fields: ${fieldsList}`,
      );
      hasErrors = true;
    }

    const currentGroup = groups[currentStep];

    const validationQuestions = formData.flatMap((form) =>
      form.questions.filter(
        (question) =>
          question.validationValue &&
          currentGroup.questions.includes(question.id),
      ),
    );

    validationQuestions.forEach((question) => {
      const value = formState[question.id]?.trim();

      if (value && value !== "") {
        if (question.validationValue === "validation_email") {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid email address.");
          }
        }

        if (question.validationValue === "validation_phone") {
          if (!isPhoneEmpty(value) && !isPhoneValid(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid phone number.");
          }
        }

        if (question.validationValue === "validation_zip") {
          const zipRegex = /^[A-Za-z0-9\s\-]{4,10}$/;
          if (!zipRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid postal code.");
          }
        }

        if (question.validationValue === "validation_address") {
          const addressRegex = /^[0-9a-zA-Z\s,.'\-#()]+$/;
          if (!addressRegex.test(value) || value.length < 5) {
            hasErrors = true;
            validationMessages.push(
              "Address should be at least 5 characters long and contain valid characters.",
            );
          }
        }

        if (question.validationValue === "validation_city") {
          const cityRegex = /^[a-zA-Z\s.'\-áéíóúÁÉÍÓÚñÑüÜ]+$/;
          if (!cityRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "City must contain only letters, spaces, hyphens, or valid special characters.",
            );
          }
        }

        if (question.validationValue === "validation_state") {
          const stateRegex = /^[a-zA-Z\s]+$/;
          if (!stateRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "State should contain only letters and spaces.",
            );
          }
        }

        if (question.validationValue === "validation_ip") {
          // IPv4 regex - no leading zeros allowed
          const ipv4Regex =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

          // IPv6 regex - supports shorthand (::) and expanded addresses
          const ipv6Regex =
            /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|::(?:[a-fA-F0-9]{1,4}:){0,5}(?:[a-fA-F0-9]{1,4})$/;

          if (!ipv4Regex.test(value) && !ipv6Regex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Please enter a valid IP address (IPv4 or IPv6).",
            );
          }
        }

        if (question.validationValue === "validation_filerId") {
          const filerIdRegex = /^[A-Z0-9]{0,10}$/;
          if (!filerIdRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Filer ID should be exactly 6 alphanumeric characters.",
            );
          }
        }
        if (question.validationValue === "validation_filerId") {
          if (value) {
            filerId = value;
          }
        }

        if (question.validationValue === "validation_fulladdress") {
          if (value) {
            fullAddress = value;
          }
        }
      }
    });

    if (hasErrors) {
      let finalErrorMessage = "";

      if (emptyFieldMessages.length > 0) {
        finalErrorMessage += emptyFieldMessages.join("<br />") + "<br />";
      }

      if (validationMessages.length > 0) {
        finalErrorMessage += validationMessages.join("<br />");
      }

      setErrorMessage(finalErrorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return;
    }

    if (filerId) {
      // console.log("Filer ID:", filerId);
    }

    if (fullAddress) {
      // console.log("Full Address:", fullAddress);
    }

    let isFilerVerified = true;
    setLoading(true);
    if (!filerId || !fullAddress) {
      isFilerVerified = await verifyInfo(filerId, fullAddress);
    }
    if (isFilerVerified) {
      const formDataToSend = formData.map((form) => ({
        title: form.title,
        id: form.id,
        questions: [
          ...form.questions.map((question) => ({
            ...question,
            answer:
              question.answerType === "fixed"
                ? question.answer
                : formState[question.id],
          })),
          {
            id: "__assistant_name__",
            questionText: "Agent / Assistant Name",
            answerType: "text",
            answer: assistantName,
            required: true,
          },
          {
            id: "__agent_id__", // ✅ Add this
            questionText: "Agent ID",
            answerType: "input",
            answer: formState["__agent_id__"] || generateUUIDv4(),
            required: true,
          },
          {
            id: "__user_form__",
            questionText: "User Form Enabled",
            answerType: "dropdown",
            answer: formState["__user_form__"] || "No",
            required: false,
          },
        ],
        errorMessage: form.errorMessage,
      }));
      const isSaved = await saveDraft(formDataToSend, currentStep + 1);
      if (isSaved) {
        setCurrentStep(currentStep + 1);
      }
    }

    setLoading(false);

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  // const validateCurrentGroup = () => {
  //   const currentGroup = groups[currentStep];
  //   if (!currentGroup) return { isValid: false, missingFields: [] };

  //   const missingFields = currentGroup.questions
  //     .map((questionId) => {
  //       const question = formData[0].questions.find((q) => q.id === questionId);

  //       // ✅ Check if question exists before accessing its properties
  //       if (!question) {
  //         console.warn(`Question with id ${questionId} not found`);
  //         return null;
  //       }

  //       // Get the actual value from formState, fallback to defaultValue only if formState value is undefined
  //       const value =
  //         formState[question.id] !== undefined
  //           ? formState[question.id]
  //           : question.defaultValue || "";

  //       if (question.required && (!value || value.trim() === "")) {
  //         return question.questionText;
  //       }

  //       return null;
  //     })
  //     .filter(Boolean);

  //   return {
  //     isValid: missingFields.length === 0,
  //     missingFields,
  //   };
  // };

  const validateCurrentGroup = () => {
    const currentGroup = groups[currentStep];
    if (!currentGroup) return { isValid: false, missingFields: [] };

    const missingFields = currentGroup.questions
      .map((questionId) => {
        const question = formData[0].questions.find((q) => q.id === questionId);
        if (!question) {
          console.warn(`Question with id ${questionId} not found`);
          return null;
        }

        // ✅ Get value with defaultValue fallback
        const value =
          formState[question.id] !== undefined
            ? formState[question.id]
            : question.defaultValue || "";

        // ✅ Properly handle various value types
        const isEmpty =
          question?.validationValue === "validation_phone"
            ? isPhoneEmpty(value)
            : value === undefined ||
              value === null ||
              (typeof value === "string" && value.trim() === "") ||
              (Array.isArray(value) && value.length === 0);

        if (question.required && isEmpty) {
          return question.questionText; // Return field name if required and empty
        }

        return null;
      })
      .filter(Boolean); // remove nulls

    return {
      isValid: missingFields.length === 0,
      missingFields,
    };
  };

  const verifyInfo = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    const TIMEOUT_MS = 6000; // 6 seconds timeout

    const verificationRequest = axios.post(
      `${process.env.REACT_APP_API_URL}forms/verify_info`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT_MS),
    );

    try {
      const response = await Promise.race([verificationRequest, timeout]);
      // console.log("Verification response: ", response);
      setCurrentStep((prevStep) => prevStep + 1);

      // Return the response data for further use if needed
      return true;
    } catch (error) {
      let errorMessage = "";

      if (error.message === "Request timed out") {
        errorMessage =
          "Your FCC Filer verification or Address validation request is taking longer than expected. Please try again.";
      } else if (error.response) {
        const { status, data } = error.response;
        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }
      } else {
        errorMessage = "There was an error verifying the information!";
      }

      setErrorMessage(errorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return false;
    } finally {
      // Reset the loading state after the request completes
      setLoading(false);
    }
  };

  /*const verifyInfo = (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}forms/verify_info`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Verification response: ", response);
        setCurrentStep(currentStep + 1);
      })
      .catch((error) => {
        if (error.response) {
          const { status, data } = error.response;
          let errorMessage;

          window.scrollTo({ top: 0, behavior: "smooth" });

          const formattedErrorMessage = data.errors
            ? String(data.errors).replace(/,/g, "<br />")
            : null;

          switch (status) {
            case 411:
              errorMessage = `Invalid Filer ID<br />${
                formattedErrorMessage ||
                "Both Filer ID and address validation failed."
              }`;
              break;
            case 410:
              errorMessage = "Invalid FCC Filer ID.";
              break;
            case 409:
              errorMessage =
                formattedErrorMessage || "Address validation failed";
              break;
            default:
              errorMessage = "An unexpected error occurred.";
          }

          setErrorMessage(errorMessage);
          setTimeout(() => {
            setErrorMessage("");
          }, 4500);

          return;
        } else {
          setErrorMessage("There was an error verifying the information!");
          setTimeout(() => {
            setErrorMessage("");
          }, 4500);
        }
      });
  };*/

  const verifyInfoSubmit = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    const TIMEOUT_MS = 6000; // 6 seconds timeout

    // Create a timeout promise
    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT_MS),
    );

    try {
      // Use Promise.race to handle both the request and the timeout
      const response = await Promise.race([
        axios.post(
          `${process.env.REACT_APP_API_URL}forms/verify_info`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        ),
        timeout,
      ]);

      // console.log("Verification response: ", response);
      setSubmission(true);
      return response;
    } catch (error) {
      setSubmission(false);

      let errorMessage = "";

      if (error.message === "Request timed out") {
        errorMessage =
          "Your FCC Filer verification or Address validation request is taking longer than expected. Please try again.";
      } else if (error.response) {
        const { status, data } = error.response;

        window.scrollTo({ top: 0, behavior: "smooth" });

        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }
      } else {
        errorMessage = "There was an error verifying the information!";
      }

      setErrorMessage(errorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);

      throw error;
    }
  };

  /*const verifyInfoSubmit = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}forms/verify_info`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Verification response: ", response);
      setSubmission(true); // Set submission success state
      return response; // Return response so that it can be used elsewhere if needed
    } catch (error) {
      setSubmission(false); // Set submission failure state

      if (error.response) {
        const { status, data } = error.response;
        let errorMessage;

        window.scrollTo({ top: 0, behavior: "smooth" });

        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }

        setErrorMessage(errorMessage);
        setTimeout(() => {
          setErrorMessage("");
        }, 4500);
      } else {
        setErrorMessage("There was an error verifying the information!");
        setTimeout(() => {
          setErrorMessage("");
        }, 4500);
      }

      throw error; // Ensure errors propagate so the caller knows about the failure
    }
  };*/

  const clearSignature = (index) => {
    if (sigPadRefs.current[index]) {
      sigPadRefs.current[index].clear();
      $("#divSig" + index).hide();
      $(".clsimgSig").attr("src", "");
      $(".clsimgSig").hide();
    }
  };

  const previewSignature = (index) => {
    if (sigPadRefs.current[index]) {
      const dataUrl = sigPadRefs.current[index].toDataURL();
      var data = sigPadRefs.current[index]
        .getTrimmedCanvas()
        .toDataURL("image/svg+xml");
      $("#divSig" + index).show();
      $(".clsimgSig").show();
      $(".clsimgSig").attr("src", data);
      // console.log("Signature Preview:", dataUrl);
      // You can do something with the dataUrl, like displaying it or saving it
    }
  };

  const saveSignature = async (index) => {
    const signaturePad = sigPadRefs.current[index];

    if (signaturePad && !signaturePad.isEmpty()) {
      try {
        // Generate the trimmed signature as a base64 string
        const trimmedDataUrl = signaturePad
          .getTrimmedCanvas()
          .toDataURL("image/svg+xml");

        // Prepare the JSON payload
        const payload = {
          signature: trimmedDataUrl,
        };

        // Send the signature data as JSON to the server
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}forms/form_signature_response`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        // Check if response status is 200 and contains the expected data
        if (response.status === 200 && response.data.default) {
          // Extract the image URL from the response
          const imageUrl = response.data.default;

          // Update the form state with the new image URL
          setFormState((prevFormState) => ({
            ...prevFormState,
            [index]: imageUrl,
          }));

          // Clear any previous errors related to this signature
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            [index]: "",
          }));

          showToastSuccess("Signature saved successfully.", "Saved");
          setErrorMessage("");

          // console.log(`Signature ${index + 1} saved successfully:`, imageUrl);
        } else {
          throw new Error(
            `Unexpected response format or status: ${response.status}`,
          );
        }
      } catch (error) {
        // Handle errors and update state
        console.error(
          `Error uploading the signature for index ${index + 1}:`,
          error.message,
        );

        // Optionally, update form errors state to show the error message
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: error.message || "Failed to save signature",
        }));
        showToastError("Failed to save signature. Please try again.");
        setErrorMessage("");
      }
    } else {
      showToastError("Signature is empty.");
      setErrorMessage("");
      // console.log(`Signature ${index + 1} is empty or does not exist.`);
    }
  };

  const saveChooseImage = async (index) => {
    const element = document.getElementById("styled-text-container" + index);
    if (element) {
      if (signatureText.trim() === "") {
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: "Please enter the signature text before saving.",
        }));
        showToastError("Signature text is empty.");
        setErrorMessage("");
        return;
      }

      try {
        const canvas = await html2canvas(element, {
          scale: 2,
          backgroundColor: null,
        });
        const imgData = canvas.toDataURL("image/png");
        const payload = {
          signature: imgData,
        };

        // Send the signature data as JSON to the server
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}forms/form_signature_choose_response`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (response.status === 200 && response.data.default) {
          // Extract the image URL from the response
          const imageUrl = response.data.default;

          // Update the form state with the new image URL
          setFormState((prevFormState) => ({
            ...prevFormState,
            [index]: imageUrl,
          }));

          // Clear any previous errors related to this signature
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            [index]: "",
          }));

          showToastSuccess("Signature saved successfully.", "Saved");
          setErrorMessage("");
          // console.log(`Signature ${index + 1} saved successfully:`, imageUrl);
        } else {
          throw new Error(
            `Unexpected response format or status: ${response.status}`,
          );
        }
      } catch (error) {
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: error.message || "Failed to save signature",
        }));
        showToastError("Failed to save signature. Please try again.");
        setErrorMessage("");
      }
    } else {
      showToastError("Signature is empty.");
      setErrorMessage("");
      // console.log(`Signature ${index + 1} is empty or does not exist.`);
    }
  };

  const downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url = ADMIN_URL + "files_data/form_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "File not found.",
      });
      /*setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);*/
    }
  };

  //Show Groups by sequence Number
  if (groups) {
    groups = groups.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
  }

  const currentGroup = groups && groups.length > 0 ? groups[currentStep] : null;

  const openGenerateModal = (question) => {
    setCurrentAIQuestion(question);
    setGeneratedText(""); // reset input
    setIsGenerated(false); // reset generated state
    setIsFollowUp(false); // reset follow-up state
    setShowGenerateModal(true);
    setModalError("");
  };

  const stripHTMLTags = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const closeGenerateModal = () => {
    // ✅ Abort ongoing API request if any
    if (abortController) {
      abortController.abort();
      setAbortController(null);
    }

    // ✅ If generation was in progress, restore original content
    if (isGenerating && originalAnswer && currentAIQuestion) {
      setFormState((prev) => ({
        ...prev,
        [currentAIQuestion.id]: originalAnswer,
      }));
    }

    // ✅ Reset all states
    setShowGenerateModal(false);
    setCurrentAIQuestion(null);
    setModalError("");
    setGeneratedText("");
    setIsGenerating(false);
    setIsGenerated(false);
    setIsFollowUp(false);
    setDiffOutput(null);
  };

  const handleUseGeneratedAnswer = (questionId) => {
    setShowGenerateModal(false);
    setGeneratedText("");
    setIsGenerated(false);
    setIsFollowUp(false);

    if (diffOutput && currentAIQuestion) {
      // Parse the HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(diffOutput, "text/html");

      // Remove all <del> tags (red strikethrough - deleted content)
      doc.querySelectorAll("del").forEach((del) => del.remove());

      // Remove deletion spans (red background)
      doc
        .querySelectorAll("span[style*='fee2e2'], span[style*='line-through']")
        .forEach((span) => {
          if (span.style.textDecoration === "line-through") {
            span.remove();
          }
        });

      // Unwrap <ins> tags but keep their content (remove green highlight wrapper)
      doc.querySelectorAll("ins").forEach((ins) => {
        const content = ins.innerHTML;
        ins.outerHTML = content;
      });

      // Remove green background from spans but keep content
      doc.querySelectorAll("span[style*='d1fadf']").forEach((span) => {
        span.outerHTML = span.innerHTML;
      });

      // ✅ Check if this is an input field or textarea
      const isInputField = currentAIQuestion.answerType === "input";

      let finalContent;
      if (isInputField) {
        // ✅ For input fields, extract PLAIN TEXT only
        finalContent = doc.body.textContent || doc.body.innerText || "";
        finalContent = finalContent.trim();
      } else {
        // ✅ For textarea, keep HTML structure
        finalContent = doc.body.innerHTML;
      }

      setFormState((prev) => ({
        ...prev,
        [questionId]: finalContent,
      }));

      setDiffOutput(null); // remove diff view
    }

    setCurrentAIQuestion(null); // ✅ Reset this AFTER processing
  };
  const handleDiscardGenerated = (questionId) => {
    setFormState((prev) => ({
      ...prev,
      [questionId]: originalAnswer,
    }));
    setDiffOutput(null);
    setIsGenerated(false);
    setIsFollowUp(false);
    setCurrentAIQuestion(null); // ✅ Reset current question
    setShowGenerateModal(false);
  };

  const handleInputChange = (e) => {
    const newText = e.target.value;
    setGeneratedText(newText);

    if (isGenerated && !isGenerating) {
      if (newText.trim() === "") {
        // When input becomes empty, go back to Accept Changes mode
        setIsFollowUp(false);
      } else {
        // When user types something, enable follow-up mode
        setIsFollowUp(true);
      }
    }
  };
  const generateAIAnswer = async (prompt) => {
    try {
      const res = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${chatgpt_api_key}`,
        },
        body: JSON.stringify({
          model: "gpt-4o-mini",
          messages: [{ role: "user", content: prompt }],
        }),
      });

      const data = await res.json();
      return data.choices?.[0]?.message?.content || "No answer generated";
    } catch (error) {
      console.error("Error generating:", error);
      return "";
    }
  };

  // Add this helper function at the top of your component
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const diffPreviewRef = useRef(null);

  const handleGenerate = async () => {
    setIsGenerating(true);
    setModalError("");
    setDiffOutput(null);
    setIsGenerated(false); // Reset generated state
    setIsFollowUp(false); // Reset follow-up state

    const controller = new AbortController();
    setAbortController(controller);

    try {
      const userPrompt = generatedText.trim();
      const questionId = currentAIQuestion.id;
      const currentFieldValue =
        formState[questionId] || currentAIQuestion.defaultValue || "";
      setOriginalAnswer(currentFieldValue);

      const defaultMaxLength =
        currentAIQuestion.answerType === "textarea" ? 20000 : 500;
      const maxLength = currentAIQuestion.maxLength || defaultMaxLength;

      const prompt = `
You are a professional text revision assistant.
Rewrite or refine the text according to the user's instruction.

CRITICAL RULES:
- Match the EXACT HTML structure of the input text
- Do NOT add wrapper tags
- Do NOT wrap your response in markdown code blocks
- Return pure HTML content

Current Text:
"""
${currentFieldValue || "No content"}
"""

User Request:
"""
${userPrompt || "Improve clarity and tone"}
"""

Return the improved text:`;

      const res = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${chatgpt_api_key}`,
        },
        body: JSON.stringify({
          model: "gpt-4o-mini",
          messages: [{ role: "user", content: prompt }],
          stream: false,
        }),
        signal: controller.signal,
      });

      const data = await res.json();
      let finalText = data.choices?.[0]?.message?.content || "";

      // Clean up the response
      finalText = finalText
        .trim()
        .replace(/^```html?\n?/i, "")
        .replace(/\n?```$/i, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&")
        .replace(/<\/?html>/gi, "")
        .replace(/<\/?body>/gi, "")
        .replace(/>\s+</g, "><")
        .trim();

      // Limit length
      finalText =
        finalText.length > maxLength
          ? finalText.substring(0, maxLength)
          : finalText;

      // Create diff for display
      const diffParts = diffWords(currentFieldValue, finalText);
      const diffHTML = diffParts
        .map((part) => {
          if (part.added)
            return `<ins style="background-color:#dcfce7;color:#15803d;text-decoration:none;padding:2px 0;display:inline;">${part.value}</ins>`;
          if (part.removed)
            return `<del style="background-color:#fee2e2;color:#b91c1c;text-decoration:line-through;padding:2px 0;display:inline;">${part.value}</del>`;
          return part.value;
        })
        .join("");

      setDiffOutput(diffHTML);
      setIsGenerated(true); // Set to true when generation completes
      setIsFollowUp(false); // Set to true to show follow-up mode
      setGeneratedText(""); // Clear the input for follow-up
      setAbortController(null);
    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }
      console.error("Generation error:", error);
      setModalError("Failed to generate content. Please try again.");
    } finally {
      setIsGenerating(false);
      setAbortController(null);
    }
  };

  //   const handleGenerate = async () => {
  //     setIsGenerating(true);
  //     setModalError("");
  //     setDiffOutput(null);
  //     setStreamingLineIndex(0);

  //     const controller = new AbortController();
  //     setAbortController(controller);

  //     try {
  //       const userPrompt = generatedText.trim();
  //       const questionId = currentAIQuestion.id;
  //       const currentFieldValue =
  //         formState[questionId] || currentAIQuestion.defaultValue || "";
  //       setOriginalAnswer(currentFieldValue);

  //       const defaultMaxLength =
  //         currentAIQuestion.answerType === "textarea" ? 20000 : 500;
  //       const maxLength = currentAIQuestion.maxLength || defaultMaxLength;

  //       const prompt = `
  // You are a professional text revision assistant.
  // Rewrite or refine the text according to the user's instruction.

  // CRITICAL RULES:
  // - Match the EXACT HTML structure of the input text
  // - Do NOT add wrapper tags
  // - Do NOT wrap your response in markdown code blocks
  // - Return pure HTML content

  // Current Text:
  // """
  // ${currentFieldValue || "No content"}
  // """

  // User Request:
  // """
  // ${userPrompt || "Improve clarity and tone"}
  // """

  // Return the improved text:`;

  //       const res = await fetch("https://api.openai.com/v1/chat/completions", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${chatgpt_api_key}`,
  //         },
  //         body: JSON.stringify({
  //           model: "gpt-4o-mini",
  //           messages: [{ role: "user", content: prompt }],
  //           stream: true,
  //         }),
  //         signal: controller.signal,
  //       });

  //       const reader = res.body.getReader();
  //       const decoder = new TextDecoder();
  //       let accumulatedText = "";
  //       let buffer = "";
  //       let previousLength = 0;

  //       while (true) {
  //         const { done, value } = await reader.read();
  //         if (done) break;

  //         const chunk = decoder.decode(value, { stream: true });
  //         const lines = chunk.split("\n").filter((line) => line.trim() !== "");

  //         for (const line of lines) {
  //           const message = line.replace(/^data: /, "");
  //           if (message === "[DONE]") continue;

  //           try {
  //             const parsed = JSON.parse(message);
  //             const content = parsed.choices[0]?.delta?.content || "";

  //             if (content) {
  //               buffer += content;

  //               if (
  //                 buffer.length >= 5 ||
  //                 content.includes(" ") ||
  //                 content.includes("\n")
  //               ) {
  //                 accumulatedText += buffer;
  //                 buffer = "";

  //                 const currentLength = accumulatedText.length;
  //                 if (currentLength > previousLength + 30) {
  //                   setStreamingLineIndex((prev) => (prev || 0) + 1);
  //                   previousLength = currentLength;
  //                 }

  //                 const cleanedText = accumulatedText
  //                   .trim()
  //                   .replace(/^```html?\n?/i, "")
  //                   .replace(/\n?```$/i, "");

  //                 const safeOriginal = normalizeHTMLStructure(currentFieldValue);
  //                 const safeNew = normalizeHTMLStructure(cleanedText);

  //                 // ✅ Better diff generation with proper styling
  //                 const diffParts = diffWords(
  //                   safeOriginal.replace(/<[^>]+>/g, ""),
  //                   safeNew.replace(/<[^>]+>/g, "")
  //                 );

  //                 let lastAddedIndex = -1;
  //                 const diffHTML = diffParts
  //                   .map((part, index) => {
  //                     if (part.added) {
  //                       lastAddedIndex = index;
  //                       return `<ins style="background-color:#dcfce7;color:#15803d;text-decoration:none;padding:2px 0;display:inline;">${part.value}</ins>`;
  //                     }
  //                     if (part.removed)
  //                       return `<del style="background-color:#fee2e2;color:#b91c1c;text-decoration:line-through;padding:2px 0;display:inline;">${part.value}</del>`;
  //                     return part.value; // ✅ Return plain text without extra span wrapper
  //                   })
  //                   .map((html, index) => {
  //                     if (
  //                       index === lastAddedIndex &&
  //                       typeof html === "string" &&
  //                       html.includes("<ins")
  //                     ) {
  //                       return html.replace(
  //                         '<ins style="',
  //                         '<ins id="active-streaming-line" style="box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.3); '
  //                       );
  //                     }
  //                     return html;
  //                   })
  //                   .join("");

  //                 setDiffOutput(diffHTML);

  //                 // ✅ Scroll to active line after state update
  //                 setTimeout(() => {
  //                   if (diffPreviewRef.current) {
  //                     const activeLine = diffPreviewRef.current.querySelector(
  //                       "#active-streaming-line"
  //                     );
  //                     if (activeLine) {
  //                       activeLine.scrollIntoView({
  //                         behavior: "smooth",
  //                         block: "center",
  //                         inline: "nearest",
  //                       });
  //                     }
  //                   }
  //                 }, 10);
  //               }
  //             }
  //           } catch (e) {
  //             console.error("Parse error:", e);
  //           }
  //         }
  //       }

  //       if (buffer) {
  //         accumulatedText += buffer;
  //       }

  //       setStreamingLineIndex(null);

  //       let finalText = accumulatedText
  //         .trim()
  //         .replace(/^```html?\n?/i, "")
  //         .replace(/\n?```$/i, "");

  //       finalText =
  //         finalText.length > maxLength
  //           ? finalText.substring(0, maxLength)
  //           : finalText;

  //       finalText = normalizeHTMLStructure(finalText);

  //       // ✅ Final diff with better styling
  //       const diffParts = diffWords(currentFieldValue, finalText);
  //       const diffHTML = diffParts
  //         .map((part) => {
  //           if (part.added)
  //             return `<ins style="background-color:#dcfce7;color:#15803d;text-decoration:none;padding:2px 0;display:inline;">${part.value}</ins>`;
  //           if (part.removed)
  //             return `<del style="background-color:#fee2e2;color:#b91c1c;text-decoration:line-through;padding:2px 0;display:inline;">${part.value}</del>`;
  //           return part.value; // ✅ Plain text without wrapper
  //         })
  //         .join("");

  //       setDiffOutput(diffHTML);
  //       setIsGenerated(true);
  //       setAbortController(null);
  //     } catch (error) {
  //       if (error.name === "AbortError") {
  //         console.log("Request cancelled by user");
  //         return;
  //       }
  //       console.error("Generation error:", error);
  //       setModalError("Failed to generate content. Please try again.");
  //     } finally {
  //       setIsGenerating(false);
  //       setAbortController(null);
  //       setStreamingLineIndex(null);
  //     }
  //   };

  const handleUserFormChange = (value) => {
    const assistantName = formState["__assistant_name__"] || "Maya";
    const agentId = formState["__agent_id__"];
    const agentRoom = formState["__agent_room__"];
    const currentTheme = selectedThemeColor || "#d4af37";

    const updatedFields = { __user_form__: value };

    formData.forEach((section) => {
      section.questions.forEach((question) => {
        if (
          typeof question.defaultValue === "string" &&
          (question.defaultValue.includes("{form_value}") ||
            question.defaultValue.includes("{name}") ||
            question.defaultValue.includes("{agentId}") ||
            question.defaultValue.includes("{agent_room}"))
        ) {
          const currentDefaultValue = replaceNamePlaceholders(
            question.defaultValue,
            assistantName,
            agentId,
            formState["__user_form__"], // Use current form value
            agentRoom,
          );

          // Only update if current value matches the expected default
          // OR if the field is empty (not manually modified)
          const currentValue = formState[question.id] || "";
          if (
            currentValue === currentDefaultValue ||
            currentValue.trim() === ""
          ) {
            const newValue = replaceNamePlaceholders(
              question.defaultValue,
              assistantName,
              agentId,
              value,
              agentRoom,
            );
            updatedFields[question.id] = newValue;
          }
        }
      });
    });

    // ✅ Preserve theme color in embed code (don't reset to default)
    const embedCodeQuestion = formData[0]?.questions.find(
      (q) => q.questionText === "Embed Code",
    );
    if (embedCodeQuestion && formState[embedCodeQuestion.id]) {
      const currentCode = formState[embedCodeQuestion.id];
      const updatedCode = currentCode.replace(
        /theme="[^"]*"/,
        `theme="${currentTheme}"`,
      );
      updatedFields[embedCodeQuestion.id] = updatedCode;
    }

    setFormState((prev) => ({
      ...prev,
      ...updatedFields,
    }));

    // ensure preview and picker stay synced
    requestAnimationFrame(() => {
      setSelectedThemeColor(currentTheme);
      setPreviewThemeColor(currentTheme);
    });
  };

  const renderDiff = (diffText) => {
    return diffText.split("\n").map((line, i) => {
      if (line.startsWith("+")) {
        return (
          <div key={i} style={{ color: "#16a34a" }}>
            {line}
          </div>
        );
      } else if (line.startsWith("-")) {
        return (
          <div
            key={i}
            style={{ color: "#dc2626", textDecoration: "line-through" }}
          >
            {line}
          </div>
        );
      } else {
        return (
          <div key={i} style={{ color: "#111827" }}>
            {line}
          </div>
        );
      }
    });
  };

  const saveCaretPosition = (element) => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return null;

    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    const caretOffset = preCaretRange.toString().length;

    return caretOffset;
  };

  const restoreCaretPosition = (element, offset) => {
    const selection = window.getSelection();
    const range = document.createRange();

    let currentOffset = 0;
    let found = false;

    const traverse = (node) => {
      if (found) return;

      if (node.nodeType === Node.TEXT_NODE) {
        const length = node.textContent.length;
        if (currentOffset + length >= offset) {
          range.setStart(node, offset - currentOffset);
          range.setEnd(node, offset - currentOffset);
          found = true;
          return;
        }
        currentOffset += length;
      } else {
        for (let i = 0; i < node.childNodes.length; i++) {
          traverse(node.childNodes[i]);
          if (found) return;
        }
      }
    };

    traverse(element);

    if (found) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  // In your component:
  const contentEditableRef = useRef(null);

  function normalizeHTMLStructure(html) {
    if (!html) return "";

    // Protect <va-widget> and <script> tags by escaping them first
    html = html
      .replace(/<va-widget/gi, "&lt;va-widget")
      .replace(/<\/va-widget>/gi, "&lt;/va-widget&gt;")
      .replace(/<script/gi, "&lt;script")
      .replace(/<\/script>/gi, "&lt;/script&gt;");

    // Then continue normal cleaning
    return (
      html
        .replace(/```html|```/gi, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&")
        .replace(/<\/?html>/gi, "")
        .replace(/<\/?body>/gi, "")
        .replace(/>\s+</g, "><")
        .trim()
        // Re-escape the protected tags for display
        .replace(/<va-widget/gi, "&lt;va-widget")
        .replace(/<\/va-widget>/gi, "&lt;/va-widget&gt;")
        .replace(/<script/gi, "&lt;script")
        .replace(/<\/script>/gi, "&lt;/script&gt;")
    );
  }

  useEffect(() => {
    const embedCodeQuestion = formData[0]?.questions.find(
      (q) => q.questionText === "Embed Code",
    );

    if (embedCodeQuestion) {
      const embedCode = formState[embedCodeQuestion.id] || "";

      // Extract agent-name
      const nameMatch = embedCode.match(/agent-name=([^&>]+)/);
      if (nameMatch) {
        const cleanName = nameMatch[1]
          .replace(/<br\s*\/?>/gi, "")
          .replace(/<\/?[^>]+(>|$)/g, "")
          .trim()
          .replace(/["']/g, "");
        setPreviewAgentName(cleanName);
      }

      // Extract theme color
      const themeMatch = embedCode.match(/theme="([^"]+)"/);
      if (themeMatch) {
        setPreviewThemeColor(themeMatch[1]);
        setSelectedThemeColor(themeMatch[1]); // SYNC COLOR PICKER
      }
    }
  }, [formState, formData]);

  // ─── Single-page layout helpers ───────────────────────────────────────────

  const STATIC_TYPES_SP = ["text_only", "rich_text", "notice_text", "warning_text"];

  const getQuestionColClassSP = (question, group) => {
    if (!question) return "col-sm-12";
    if (question.answerType === "label" || STATIC_TYPES_SP.includes(question.answerType))
      return "col-sm-12";
    if (group && group.column_layout === "double_column") return "col-sm-6";
    return "col-sm-12";
  };

  const smoothScrollTo = (targetY, duration = 650) => {
    const startY = window.scrollY;
    const diff = targetY - startY;
    if (Math.abs(diff) < 2) return;
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    let startTime = null;
    const tick = (now) => {
      if (!startTime) startTime = now;
      const progress = Math.min((now - startTime) / duration, 1);
      window.scrollTo(0, startY + diff * ease(progress));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const scrollToSection = (index) => {
    setActiveTabIndex(index);
    const el = sectionRefs.current[index];
    if (!el) return;
    isScrollingRef.current = true;
    setTimeout(() => { isScrollingRef.current = false; }, 750);
    const rect = el.getBoundingClientRect();
    smoothScrollTo(window.scrollY + rect.top - 80, 650);
  };

  const SELECT_TYPES_SP = ["dropdown", "select", "radio", "checkbox", "multiselect", "multi_select"];

  // Resolve the step (group) name, field label, and answer type for a given field id.
  const getFieldMeta = (fieldId) => {
    if (!fieldId) return null;
    const group = (groups || []).find((g) => g.questions.includes(fieldId));
    const q = formData[0]?.questions.find((x) => x.id === fieldId);
    if (!q) return null;
    return {
      stepName: group?.group_title || "",
      label: q.questionText || "",
      answerType: q.answerType,
    };
  };

  // Build a "Please enter/select {Label} in {Step}" message for a required field.
  const buildRequiredMessage = (meta) => {
    if (!meta) return "Please review the highlighted field.";
    const verb = SELECT_TYPES_SP.includes(meta.answerType) ? "select" : "enter";
    const inStep = meta.stepName ? ` in ${meta.stepName}` : "";
    return `Please ${verb} ${meta.label}${inStep}`;
  };

  // Scroll the first invalid field into view and move focus to its input.
  const focusFirstInvalid = (fieldId) => {
    setTimeout(() => {
      const el = fieldId ? document.getElementById(`sp-field-${fieldId}`) : null;
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        const focusable = el.querySelector("input, select, textarea, [tabindex]");
        if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 350);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 50);
  };

  const validateAllGroupsSP = () => {
    if (!groups || !formData || !formData[0]) return { isValid: true, missingFields: [], firstInvalidId: null };
    const newErrors = {};
    const missingFields = [];
    let firstInvalidId = null;
    groups.forEach((group) => {
      group.questions.forEach((questionId) => {
        const question = formData[0].questions.find((q) => q.id === questionId);
        if (!question || !question.required || STATIC_TYPES_SP.includes(question.answerType)) return;
        const value = formState[question.id];
        const empty =
          question.validationValue === "validation_phone"
            ? isPhoneEmpty(value)
            : value === undefined ||
              value === null ||
              (typeof value === "string" && value.trim() === "") ||
              (Array.isArray(value) && value.length === 0);
        if (empty) {
          newErrors[question.id] = "This field is required.";
          missingFields.push(question.questionText);
          if (!firstInvalidId) firstInvalidId = question.id;
        }
      });
    });
    setFormErrors(newErrors);
    return { isValid: missingFields.length === 0, missingFields, firstInvalidId };
  };

  const handleSubmitSinglePage = async () => {
    sessionStorage.setItem("skipResetDefaults", "true");

    const { isValid, missingFields, firstInvalidId } = validateAllGroupsSP();
    if (!isValid) {
      // Highlight all invalid fields (done in validateAllGroupsSP), but warn about
      // and focus only the first one, top-to-bottom.
      setValidationSummary({ count: missingFields.length, firstId: firstInvalidId });
      showToastWarning(buildRequiredMessage(getFieldMeta(firstInvalidId)));
      setErrorMessage("");
      focusFirstInvalid(firstInvalidId);
      return;
    }
    setValidationSummary(null);

    if (captcha_enabled === 1 && link_form !== 1 && !captchaToken) {
      showToastError("Please complete the CAPTCHA verification.");
      setErrorMessage("");
      return;
    }

    setLoading(true);
    const formDataToSend = formData.map((form) => ({
      title: form.title,
      id: form.id,
      questions: form.questions.map((q) => ({
        ...q,
        answer: q.answerType === "fixed" ? q.answer : formState[q.id],
      })),
    }));

    try {
      await onSubmit(formDataToSend);
    } finally {
      setLoading(false);
    }
  };

  // IntersectionObserver: track active section on scroll
  useEffect(() => {
    if (!isSPLayout) return;
    const observers = [];
    sectionRefs.current.forEach((el, index) => {
      if (!el) return;
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isScrollingRef.current) {
              setActiveTabIndex(index);
            }
          });
        },
        { threshold: 0.3, rootMargin: "-60px 0px -40% 0px" }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach((obs) => obs.disconnect());
  }, [groups, viewFrom]);

  // IntersectionObserver: hero visibility → show/hide floating nav
  useEffect(() => {
    if (!isSPLayout || !heroRef.current) return;
    const obs = new IntersectionObserver(
      ([entry]) => setShowFloatingNav(!entry.isIntersecting),
      { threshold: 0 }
    );
    obs.observe(heroRef.current);
    return () => obs.disconnect();
  }, [viewFrom]);

  // Mobile: auto-hide floating nav after 2s of no scroll
  useEffect(() => {
    if (!isSPLayout) return;
    const handleScroll = () => {
      setMobileNavVisible(true);
      clearTimeout(mobileNavTimerRef.current);
      mobileNavTimerRef.current = setTimeout(() => setMobileNavVisible(false), 2000);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("touchmove", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("touchmove", handleScroll);
      clearTimeout(mobileNavTimerRef.current);
    };
  }, [viewFrom]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {allowSkip === 1 &&
          isOnboarding &&
          isFilled !== 1 &&
          isSkipped !== 1 && (
            <Button
              variant="contained"
              color="primary"
              onClick={onSkipStep}
              style={{
                marginTop: "10px",
                justifyContent: "flex-end",
              }}
              title="Skip this step"
              className="skip-button-mobile"
            >
              <em className="icon ni ni-forward"></em> Skip This Step
            </Button>
          )}
        {(isFilled === 1 || isSkipped === 1) && (
          <Button
            variant="contained"
            color="primary"
            onClick={onNextStep}
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              textAlign: "right",
            }}
            className="next-button-mobile"
          >
            <em className="icon ni ni-forward"></em> Next Step
          </Button>
        )}
      </div>
      <div className="form-renderer-container" style={isSPLayout ? { background: "#eef1f7", minHeight: "100vh" } : {}}>
        {isSPLayout ? (
          <>
            {/* ── HERO + TABS ── */}
            <div
              ref={heroRef}
              style={{
                background: "#F5F6FA",
                borderRadius: "16px",
                marginBottom: "1.5rem",
                overflow: "hidden",
                border: "1px solid #dce2ec",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              }}
            >
              {/* Hero text */}
              <div style={{ padding: "36px 48px 28px", textAlign: "center" }}>
                <h2
                  style={{
                    margin: "0 0 10px",
                    fontSize: "1.85rem",
                    fontWeight: 700,
                    color: "#1c2b46",
                    lineHeight: 1.25,
                    letterSpacing: "-0.02em",
                  }}
                >
                  {formTitle || "Untitled Form"}
                </h2>
                {formDescription && (
                  <p
                    style={{
                      margin: "0 auto",
                      fontSize: "15px",
                      color: "#526484",
                      lineHeight: 1.7,
                      maxWidth: "600px",
                    }}
                  >
                    <span dangerouslySetInnerHTML={{ __html: formDescription }} />
                  </p>
                )}
              </div>

              {/* Nav tabs */}
              {groups && groups.length > 1 && (
                <div
                  ref={tabsContainerRef}
                  className="obs-hero-tabs"
                  style={{
                    borderTop: "1px solid #dce2ec",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      overflowX: "auto",
                      padding: "0 24px",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {groups.map((group, index) => {
                      const isActive = activeTabIndex === index;
                      return (
                        <button
                          key={group.id}
                          onClick={() => scrollToSection(index)}
                          type="button"
                          className="obs-tab-btn"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "9px",
                            padding: "14px 16px",
                            border: "none",
                            borderBottom: isActive
                              ? "3px solid #1ee0ac"
                              : "3px solid transparent",
                            background: "transparent",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            transition: "border-color 0.2s ease",
                            outline: "none",
                            flexShrink: 0,
                          }}
                        >
                          <span
                            className="obs-tab-circle"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "24px",
                              height: "24px",
                              minWidth: "24px",
                              borderRadius: "50%",
                              background: isActive ? "#1ee0ac" : "#e4e9f2",
                              color: isActive ? "#0d1b38" : "#6b7c95",
                              fontSize: "11px",
                              fontWeight: 700,
                            }}
                          >
                            {index + 1}
                          </span>
                          <span
                            className="obs-tab-label"
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              letterSpacing: "0.01em",
                              color: isActive ? "#0d1b38" : "#6b7c95",
                            }}
                          >
                            {group.group_title}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* ── CSS: scrollable tabs + mobile auto-hide floating nav ── */}
            <style>{`
              .obs-hero-tabs > div::-webkit-scrollbar { display: none; }

              /* ── Rich text horizontal scroll ── */
              .obs-rich-text-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
              .obs-rich-text-scroll table { min-width: max-content; border-collapse: collapse; }
              .obs-rich-text-scroll::-webkit-scrollbar { height: 4px; }
              .obs-rich-text-scroll::-webkit-scrollbar-thumb { background: #c8d3df; border-radius: 4px; }

              /* ── Form label sizing ── */
              .form-renderer-container .form-label {
                font-size: 12.5px !important;
                font-weight: 600 !important;
                color: #526484 !important;
                margin-bottom: 5px !important;
                letter-spacing: 0.01em;
              }
              .form-renderer-container .form-label.obs-section-label {
                font-size: 13.5px !important;
                font-weight: 700 !important;
                color: #344357 !important;
                margin-bottom: 4px !important;
              }
              @media (max-width: 768px) {
                .obs-hero-tabs { display: none !important; }
                .obs-floating-nav {
                  opacity: 0;
                  pointer-events: none;
                  transition: opacity 0.35s ease !important;
                  right: 8px !important;
                  padding: 5px 4px !important;
                  gap: 3px !important;
                  border-radius: 20px !important;
                }
                .obs-floating-nav.obs-mobile-visible {
                  opacity: 1;
                  pointer-events: auto;
                }
                .obs-pill-btn {
                  width: 18px !important;
                  height: 18px !important;
                  font-size: 8px !important;
                }
              }
              @media (min-width: 769px) and (max-width: 1024px) {
                .obs-hero-tabs .obs-tab-btn {
                  padding: 12px 10px !important;
                }
                .obs-hero-tabs .obs-tab-label {
                  font-size: 11px !important;
                }
                .obs-hero-tabs .obs-tab-circle {
                  width: 22px !important;
                  height: 22px !important;
                  min-width: 22px !important;
                  font-size: 10px !important;
                }
                .obs-hero-tabs > div {
                  padding: 0 12px !important;
                }
              }
            `}</style>

            {/* ── Floating vertical step pill — one button per step ── */}
            {groups && groups.length > 1 && (
              <div
                className={`obs-floating-nav${mobileNavVisible ? " obs-mobile-visible" : ""}`}
                style={{
                  display: showFloatingNav ? "flex" : "none",
                  position: "fixed",
                  right: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 1000,
                  background: "#fff",
                  borderRadius: "30px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
                  padding: "7px 5px",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "4px",
                  transition: "opacity 0.35s ease",
                }}
              >
                {groups.map((group, index) => {
                  const isActive = activeTabIndex === index;
                  return (
                    <button
                      key={group.id}
                      onClick={() => scrollToSection(index)}
                      title={group.group_title}
                      className="obs-pill-btn"
                      style={{
                        width: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        background: isActive ? "#0d1b38" : "#e4e9f2",
                        border: isActive ? "none" : "1px solid #c8d3df",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: isActive ? "#fff" : "#6b7c95",
                        fontSize: "9px",
                        fontWeight: 700,
                        transition: "all 0.25s ease",
                        padding: 0,
                        flexShrink: 0,
                      }}
                    >
                      {index + 1}
                    </button>
                  );
                })}
              </div>
            )}

            <div>
              <div>
                <div className="mb-2"></div>
                {responseMessage && <div dangerouslySetInnerHTML={{ __html: responseMessage }} />}
                {errorMessage && (
                  <div className="alert alert-danger alert-icon mb-3">
                    <em className="icon ni ni-cross-circle"></em>{" "}
                    <div dangerouslySetInnerHTML={{ __html: errorMessage }} />
                  </div>
                )}
                {groups.map((group, groupIndex) => (
                  <div
                    key={group.id}
                    id={`sp-group-${group.id}`}
                    ref={(el) => (sectionRefs.current[groupIndex] = el)}
                    className="mb-4"
                    style={{
                      scrollMarginTop: "80px",
                      background: "#fff",
                      borderRadius: "14px",
                      boxShadow: "0 1px 12px rgba(0,0,0,0.08)",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "1px solid #e5e9f2",
                        padding: "20px 24px 18px",
                        background: "#fff",
                      }}
                    >
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h6
                          style={{
                            margin: "0 0 3px",
                            fontWeight: 700,
                            fontSize: "15px",
                            color: "#1c2b46",
                            letterSpacing: "0",
                          }}
                        >
                          Step {groupIndex + 1} — {group.group_title}
                        </h6>
                        {group.group_desc && (
                          <p
                            style={{
                              margin: 0,
                              fontSize: "13px",
                              color: "#8094ae",
                              lineHeight: 1.55,
                            }}
                            dangerouslySetInnerHTML={{ __html: group.group_desc.replace(/\n/g, "<br />") }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="card-inner">
                      {/* allow_agent_name — only in first group */}
                      {groupIndex === 0 && allow_agent_name && (
                        <div className="question-container d-flex justify-content-between"
                          style={{ gap: "10px", marginBottom: "20px", paddingBottom: "20px", borderBottom: "1px solid #f0f2f5" }}
                        >
                          <div className="form-group question-text mb-0" style={{ flex: 1 }}>
                            <label className="form-label" style={{ fontSize: "0.875rem", fontWeight: "500" }}>
                              Assistant Name <sup className="text-danger">*</sup>
                            </label>
                            <input className="form-control form-control-lg"
                              onChange={(e) => handleAssistantNameChange(e.target.value)}
                              value={formState["__assistant_name__"] || ""}
                              type="text" maxLength={50} placeholder="" required
                            />
                          </div>
                          <div className="form-group question-text mb-0" style={{ flex: 1 }}>
                            <label className="form-label" style={{ fontSize: "0.875rem", fontWeight: "500" }}>
                              Lead Entry Form
                            </label>
                            <div className="form-control-wrap">
                              <div className="form-control-select">
                                <select className="form-control form-control-lg"
                                  value={formState["__user_form__"] || "No"}
                                  onChange={(e) => handleUserFormChange(e.target.value)}
                                >
                                  <option value="">Select an option</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row g-gs">
                        {group.questions
                          .map((qid) => formData[0]?.questions.find((q) => q.id === qid))
                          .filter(Boolean)
                          .sort((a, b) => a.sequenceNumber - b.sequenceNumber)
                          .map((question) => {
                            const value = formState[question.id] || question.defaultValue || "";
                            const colClass = getQuestionColClassSP(question, group);
                            const hasFieldError = Boolean(formErrors[question.id]);
                            const errorBorderStyle = hasFieldError
                              ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" }
                              : {};
                            return (
                              <div key={question.id} id={`sp-field-${question.id}`} className={`question-container ${colClass}`}>
                                <div className="form-group question-text mb-0">
                                  {question.answerType === "label" ? (
                                    <label className="form-label obs-section-label">
                                      {question.questionText}{" "}{question.required && <sup className="text-danger">*</sup>}
                                      {question.tooltip && question.tooltip.trim() !== "" && (
                                        <div className="custom-tooltip-wrapper">
                                          <em className="icon ni ni-info" style={{ color: "#6576ff", marginLeft: "5px", cursor: "pointer", fontSize: "14px" }}></em>
                                          <div className="custom-tooltip-box"><p>{question.tooltip}</p></div>
                                        </div>
                                      )}
                                    </label>
                                  ) : !STATIC_TYPES_SP.includes(question.answerType) ? (
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                      <label className="form-label">
                                        {question.questionText}{" "}{question.required && <sup className="text-danger">*</sup>}
                                        {question.tooltip && question.tooltip.trim() !== "" && (
                                          <div className="custom-tooltip-wrapper">
                                            <em className="icon ni ni-info" style={{ color: "#6576ff", marginLeft: "5px", cursor: "pointer", fontSize: "16px" }}></em>
                                            <div className="custom-tooltip-box"><p>{question.tooltip}</p></div>
                                          </div>
                                        )}
                                      </label>
                                      {chatgpt_intergation === "Yes" && question.answerType === "textarea" && (
                                        <button type="button" className="btn btn-sm btn-outline-primary"
                                          style={{ fontSize: "11px", padding: "2px 8px", height: "26px" }}
                                          onClick={() => { setCurrentAIQuestion(question); setShowGenerateModal(true); setGeneratedText(""); setDiffOutput(null); setIsFollowUp(false); }}>
                                          <em className="icon ni ni-spark" style={{ marginRight: "4px" }}></em> AI Generate
                                        </button>
                                      )}
                                    </div>
                                  ) : null}
                                  {question.answerType === "text_only" && (
                                    question.textType === "oli" ? (
                                      <ol style={{ paddingLeft: "20px", marginLeft: "20px" }}>
                                        {question.textOnly.split("\n").filter((l) => l.trim()).map((line, li) => <li key={li} style={{ listStyleType: "decimal", paddingLeft: "10px" }}>{line}</li>)}
                                      </ol>
                                    ) : question.textType === "sli" ? (
                                      <ul style={{ paddingLeft: "20px", marginLeft: "20px" }}>
                                        {question.textOnly.split("\n").filter((l) => l.trim()).map((line, li) => <li key={li} style={{ listStyleType: "disc", paddingLeft: "10px" }}>{line}</li>)}
                                      </ul>
                                    ) : (
                                      <p>{question.textOnly}</p>
                                    )
                                  )}
                                  {question.answerType === "rich_text" && (
                                    <div className="obs-rich-text-scroll">
                                      <div
                                        style={{ fontSize: "14px", lineHeight: 1.65, color: "#526484" }}
                                        dangerouslySetInnerHTML={{ __html: question.textOnly || "" }}
                                      />
                                    </div>
                                  )}
                                  {question.answerType === "notice_text" && (
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "12px",
                                        alignItems: "flex-start",
                                        background: "#eef3ff",
                                        border: "1px solid #c4d0ff",
                                        borderLeft: "4px solid #6576ff",
                                        borderRadius: "6px",
                                        padding: "14px 16px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <em
                                        className="icon ni ni-info-fill"
                                        style={{ color: "#6576ff", fontSize: "18px", marginTop: "1px", flexShrink: 0 }}
                                      ></em>
                                      <div
                                        style={{ fontSize: "13.5px", color: "#364a63", lineHeight: 1.6 }}
                                        dangerouslySetInnerHTML={{ __html: question.textOnly || "" }}
                                      />
                                    </div>
                                  )}
                                  {question.answerType === "warning_text" && (
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "12px",
                                        alignItems: "flex-start",
                                        background: "#fff8ea",
                                        border: "1px solid #ffd591",
                                        borderLeft: "4px solid #f4a600",
                                        borderRadius: "6px",
                                        padding: "14px 16px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <em
                                        className="icon ni ni-alert-fill"
                                        style={{ color: "#f4a600", fontSize: "18px", marginTop: "1px", flexShrink: 0 }}
                                      ></em>
                                      <div
                                        style={{ fontSize: "13.5px", color: "#364a63", lineHeight: 1.6 }}
                                        dangerouslySetInnerHTML={{ __html: question.textOnly || "" }}
                                      />
                                    </div>
                                  )}
                                  {question.imageUrl && !STATIC_TYPES_SP.includes(question.answerType) && (
                                    <a onClick={() => downloadPdf(question.imageUrl)} style={{ float: "right", cursor: "pointer" }}>
                                      <span className="badge badge-outline-primary"><em className="icon ni ni-download"></em> Download File</span>
                                    </a>
                                  )}
                                </div>
                                {question.imageUrl && question.answerType !== "image_input" && !STATIC_TYPES_SP.includes(question.answerType) && (
                                  <img src={question.imageUrl} alt="Admin Uploaded" className="question-image" />
                                )}

                                {question.answerType === "input" && (
                                  <div className="form-group mb-0">
                                    <div className="form-control-wrap address_cont">
                                      {question.validationValue === "validation_phone" ? (
                                        <ReactPhoneInput country="us" specialLabel="" value={formState[question.id] || ""} onChange={(v) => handleChangePhone(question.id, v)} inputStyle={{ width: "100%", height: "42px", ...(formErrors[question.id] ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" } : {}) }} buttonStyle={formErrors[question.id] ? { borderColor: "#e85347" } : undefined} />
                                      ) : question.validationValue === "validation_fulladdress" ? (
                                        <GooglePlacesAutocomplete apiKey={process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY} selectProps={{ value: formState[question.id] ? { label: formState[question.id], value: formState[question.id] } : null, onChange: (addr) => handleAddressSelect(question.id, addr), placeholder: Address ? null : "Enter your address...", styles: { control: (p) => ({ ...p, borderColor: hasFieldError ? "#e85347" : p.borderColor, boxShadow: hasFieldError ? "0 0 0 1px #e85347" : p.boxShadow }), input: (p) => ({ ...p, color: "black" }), option: (p) => ({ ...p, color: "black" }), singleValue: (p) => ({ ...p, color: "black" }), menu: (p) => ({ ...p, zIndex: 9 }) } }} />
                                      ) : question.validationValue === "validation_country" ? (
                                        <Select id="_country_sp" className="customCountrySelect-addClient" name="_country" options={countryOptions} value={country} onChange={(sel) => handleChangeCountry(question.id, sel)} styles={{ control: (p) => ({ ...p, minHeight: "45px", borderColor: hasFieldError ? "#e85347" : p.borderColor, boxShadow: hasFieldError ? "0 0 0 1px #e85347" : p.boxShadow }), menu: (p) => ({ ...p, zIndex: 9 }) }} placeholder="Select Country" />
                                      ) : (
                                        <input className="form-control form-control-lg" style={errorBorderStyle} onChange={(e) => handleChange(question.id, e.target.value, question.inputFormat)} value={formState[question.id] || question.defaultValue || ""} type="text" maxLength={question.maxLength || 100} />
                                      )}
                                    </div>
                                    {question.maxLength && <small className="text-muted" style={{ display: "block", marginTop: "4px" }}>• Maximum length is {question.maxLength} characters.</small>}
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "textarea" && (
                                  <div className="form-group">
                                    <div className="form-control-wrap">
                                      <textarea className="form-control form-control-lg" style={errorBorderStyle} onChange={(e) => handleChange(question.id, e.target.value)} value={formState[question.id] || question.defaultValue || ""} maxLength={question.maxLength || 500} />
                                    </div>
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "datetime" && (
                                  <div className="form-group">
                                    <DateTimePicker variant="inline" inputVariant="outlined" fullWidth format="MM-dd-yyyy hh:mm a" error={hasFieldError} value={formState[question.id] || null} onChange={(d) => handleChange(question.id, d)} />
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "date" && (
                                  <div className="form-group">
                                    <DatePicker variant="inline" inputVariant="outlined" fullWidth format="MM-dd-yyyy" error={hasFieldError} value={formState[question.id] || null} onChange={(d) => handleChange(question.id, d)} />
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "time" && (
                                  <div className="form-group">
                                    <TimePicker variant="inline" inputVariant="outlined" fullWidth error={hasFieldError} value={formState[question.id] || null} onChange={(t) => handleChange(question.id, t)} />
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "dropdown" && (
                                  <div className="form-group">
                                    <div className="form-control-wrap"><div className="form-control-select">
                                      <select className="form-control form-control-lg" style={errorBorderStyle} onChange={(e) => handleChange(question.id, e.target.value)} value={formState[question.id] || question.defaultValue || ""}>
                                        <option value="">Select an option</option>
                                        {question.options.map((opt, oi) => <option key={oi} value={opt}>{opt}</option>)}
                                      </select>
                                    </div></div>
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "checkbox" && (
                                  <div style={{ marginTop: "8px" }}>
                                    {question.options.map((opt, oi) => {
                                      const isChecked = formState[question.id]?.includes(opt) || false;
                                      const hKey = `cb_${question.id}_${oi}`;
                                      const isHovered = hoveredId === hKey;
                                      const showTeal = isChecked ? !isHovered : isHovered;
                                      return (
                                        <label
                                          key={oi}
                                          htmlFor={`sp_cb_${question.id}_${oi}`}
                                          onMouseEnter={() => setHoveredId(hKey)}
                                          onMouseLeave={() => setHoveredId(null)}
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: "14px",
                                            padding: "14px 16px",
                                            borderRadius: "8px",
                                            border: hasFieldError
                                              ? "1.5px solid #e85347"
                                              : showTeal
                                                ? "1.5px solid #1ee0ac"
                                                : "1.5px solid #e5e9f2",
                                            background: showTeal ? "#edfaf6" : "#ffffff",
                                            cursor: "pointer",
                                            transition: "all 0.15s ease",
                                            marginBottom: "10px",
                                            width: "100%",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            className="vdrSelected"
                                            id={`sp_cb_${question.id}_${oi}`}
                                            checked={isChecked}
                                            onChange={(e) => handleCheckboxChange(question.id, opt, e.target.checked)}
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              flexShrink: 0,
                                              marginTop: "1px",
                                              accentColor: "#1ee0ac",
                                              cursor: "pointer",
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "13.5px",
                                              color: showTeal ? "#1c2b46" : "#526484",
                                              fontWeight: showTeal ? 600 : 400,
                                              lineHeight: 1.55,
                                              flex: 1,
                                            }}
                                          >
                                            {opt}
                                          </span>
                                        </label>
                                      );
                                    })}
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "radio" && (
                                  <div style={{ marginTop: "8px" }}>
                                    {question.options.map((opt, oi) => {
                                      const isSelected = formState[question.id] === opt;
                                      const hKey = `sp_radio_${question.id}_${oi}`;
                                      const isHovered = hoveredId === hKey;
                                      const showTeal = isSelected || isHovered;
                                      return (
                                        <label
                                          key={oi}
                                          htmlFor={hKey}
                                          onMouseEnter={() => setHoveredId(hKey)}
                                          onMouseLeave={() => setHoveredId(null)}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "14px",
                                            padding: "14px 16px",
                                            borderRadius: "8px",
                                            border: hasFieldError
                                              ? "1.5px solid #e85347"
                                              : showTeal
                                                ? "1.5px solid #1ee0ac"
                                                : "1.5px solid #e5e9f2",
                                            background: showTeal ? "#edfaf6" : "#ffffff",
                                            cursor: "pointer",
                                            transition: "all 0.15s ease",
                                            marginBottom: "10px",
                                            width: "100%",
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            id={hKey}
                                            name={`sp_radio_${question.id}`}
                                            checked={isSelected}
                                            onChange={() => handleChange(question.id, opt)}
                                            value={opt}
                                            style={{ display: "none" }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "13.5px",
                                              color: showTeal ? "#1c2b46" : "#526484",
                                              fontWeight: showTeal ? 600 : 400,
                                              lineHeight: 1.55,
                                              flex: 1,
                                            }}
                                          >
                                            {opt}
                                          </span>
                                          <span style={{
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            background: isSelected ? "#1ee0ac" : "transparent",
                                            border: isSelected ? "none" : "2px solid #d0d5dd",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                            transition: "all 0.15s ease",
                                          }}>
                                            {isSelected && (
                                              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                <path d="M2 6.5L5 9.5L11 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                              </svg>
                                            )}
                                          </span>
                                        </label>
                                      );
                                    })}
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "image_input" && (
                                  <div className="form-group">
                                    <div className="form-control-group" id="fileContainer">
                                      <input type="file" id={`sp_file_${question.id}`} className="file-block" style={errorBorderStyle} name="add_picture" accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.xlx,.xlxs,.csv" onChange={(e) => handleFileChange(question.id, e)} />
                                      {formState[question.id] && (
                                        <div className="uploaded-file-preview">
                                          {formState[question.id].match(/\.(jpeg|jpg|png)$/i) ? (
                                            <><img src={`${APP_LIVE_URL}files_data/form_response_uploads/${formState[question.id]}`} alt="Uploaded preview" style={{ maxWidth: "100px" }} /><a onClick={() => removeUploadedFile(question.id)} style={{ cursor: "pointer", color: "red", fontSize: "20px", marginLeft: "5px" }} title="Delete"><em className="icon ni ni-trash-fill"></em></a></>
                                          ) : (
                                            <p>{formState[question.id].split("/").pop()}<a onClick={() => removeUploadedFile(question.id)} style={{ cursor: "pointer", color: "red", fontSize: "20px", marginLeft: "5px" }} title="Delete"><em className="icon ni ni-trash-fill"></em></a></p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </div>
                                )}
                                {question.answerType === "signature" && (
                                  <>
                                    <ul className="nav nav-tabs">
                                      <li className="nav-item"><a className={signatureType === "draw" || signatureType === "" ? "nav-link active" : "nav-link"} data-toggle="tab" onClick={() => setSignatureType("draw")} href="#sp-tabDraw"><em className="icon ni ni-edit-alt"></em><span>Draw</span></a></li>
                                      <li className="nav-item"><a className={signatureType === "choose" ? "nav-link active" : "nav-link"} data-toggle="tab" onClick={() => setSignatureType("choose")} href="#sp-tabChoose"><em className="icon ni ni-list-check"></em><span>Choose</span></a></li>
                                    </ul>
                                    <div className="tab-content">
                                      <div className={signatureType === "choose" ? "tab-pane active" : "tab-pane"} id="sp-tabChoose">
                                        <div className="example-alert mb-4"><div className="alert alert-light">On the Type tab, enter your name to generate a live signature preview. You can then choose from the available font styles before saving.</div></div>
                                        <div className="form-group mb-4">
                                          <div className="form-control-wrap">
                                            <input className="form-control form-control-lg" onChange={(e) => handleChangeSignature(question.id, e.target.value)} onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/gi, ""); }} value={signatureText} type="text" maxLength={100} placeholder="Authorized Person Name" />
                                          </div>
                                          {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                        </div>
                                        <h6 className="title">Choose Style</h6>
                                        <ul className="cc-pay-method">
                                          <li className="cc-pay-dd dropdown">
                                            <a href="#" className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator" data-toggle="dropdown"><span style={{ fontFamily: signatureClass }}>{signatureText || "Your Signature"}</span></a>
                                            <div className="dropdown-menu dropdown-menu-auto">
                                              <ul className="link-list-plain">
                                                {cursiveFonts.map((font, fi) => (
                                                  <li key={fi}><a style={{ cursor: "pointer" }} onClick={() => setSignatureClass(font.value)} className="cc-pay-item"><span className="cc-pay-item-name"><span className="cc-pay-item-method" style={{ fontFamily: font.value }}>{signatureText !== "" ? signatureText : font.name}</span></span></a></li>
                                                ))}
                                              </ul>
                                            </div>
                                          </li>
                                        </ul>
                                        <div className="signature-preview mt-3" id={`styled-text-container${question.id}`} style={{ fontFamily: signatureClass, fontSize: "40px", width: "480px", height: "80px", backgroundColor: "transparent", border: "none", lineHeight: "80px", color: "#000" }}>{signatureText || "Your Signature"}</div>
                                        <div className="col-sm-12 mt-4 pl-0" style={{ clear: "both" }}>
                                          <button type="button" className="btn btn-primary" style={{ margin: "13px 0px 12px 0px" }} onClick={() => saveChooseImage(question.id)}><em className="icon ni ni-folder-check"></em> <span>Save Signature</span></button>
                                        </div>
                                      </div>
                                      <div className={signatureType === "draw" || signatureType === "" ? "tab-pane active" : "tab-pane"} id="sp-tabDraw">
                                        <div className="row">
                                          <div className="col-sm-12">
                                            <div className="example-alert mb-4"><div className="alert alert-light">Draw your signature in the box below, then select Save Signature to continue. Clear resets the drawing area.</div></div>
                                            {formState[question.id] && <div className="uploaded-file-preview"><img src={`${APP_LIVE_URL}files_data/form_response_uploads/${formState[question.id]}`} alt="Uploaded Signature" style={{ maxWidth: "200px" }} /></div>}
                                            <div id={`divSig${question.id}`} style={{ display: "none" }}><div className="mb-4"><img src="" className="clsimgSig" height="100" width="200" alt="" /></div></div>
                                            <div><strong>Signature Drawing</strong></div>
                                          </div>
                                          <div className="col-sm-12">
                                            <div style={hasFieldError ? { border: "1px solid #e85347", boxShadow: "0 0 0 1px #e85347", borderRadius: "4px", display: "inline-block" } : undefined}>
                                              <SignatureCanvas clearOnResize={true} canvasProps={{ className: styles.sigPad }} velocityFilterWeight={0.7} throttle={50} ref={(ref) => (sigPadRefs.current[question.id] = ref)} />
                                            </div>
                                          </div>
                                          <div className="col-sm-12 mt-4">
                                            <button className="btn btn-warning" style={{ margin: "13px 0px 12px 0px" }} onClick={() => clearSignature(question.id)} type="button"><em className="icon ni ni-delete"></em> <span>Clear</span></button>
                                            <button type="button" className="btn btn-primary" style={{ margin: "13px 0px 12px 10px" }} onClick={() => saveSignature(question.id)}><em className="icon ni ni-folder-check"></em> <span>Save Signature</span></button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                  </>
                                )}
                                {question.answerType === "fixed" && (
                                  <>
                                    <div className="form-group mb-0">
                                      <div className="form-control-wrap">
                                        <input className="form-control form-control-lg" onChange={(e) => handleChangeFixed(question.id, question.answer)} value={question.answer} type="text" maxLength={255} />
                                      </div>
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                    <CopyToClipboard text={question.answer} onCopy={() => setCopied(true)} style={{ cursor: "pointer" }}>
                                      <div className="form-note text-primary"><strong>Copy to Clipboard {copied ? <span><em className="icon ni ni-done"></em></span> : null}</strong></div>
                                    </CopyToClipboard>
                                  </>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  ))}
                  {shouldShowCaptcha && (
                    <div className="captcha-section" style={{ marginTop: "20px", marginBottom: "10px" }}>
                      <ReCAPTCHA ref={captchaRef} sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY} onChange={handleCaptchaChange} onExpired={handleCaptchaExpired} />
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "12px",
                      padding: "18px 0 4px",
                      marginTop: "12px",
                      borderTop: "1px solid #e5e9f2",
                    }}
                  >
                    {allow_submit === 1 ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitSinglePage}
                        disabled={loading || isFormInReviewMode}
                        style={{
                          minWidth: "160px",
                          height: "42px",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "14px",
                          textTransform: "none",
                          letterSpacing: "0.02em",
                          background: loading || isFormInReviewMode ? undefined : "#1c2b46",
                          boxShadow: "0 2px 10px rgba(28,43,70,0.3)",
                        }}
                      >
                        {loading ? (
                          "Submitting..."
                        ) : (
                          <>
                            <em className="icon ni ni-check-thick" style={{ marginRight: "6px" }}></em>
                            Submit Form
                          </>
                        )}
                      </Button>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "10px 16px",
                          borderRadius: "6px",
                          background: "#fff8ea",
                          border: "1px solid #ffd591",
                          color: "#8a6c00",
                          fontSize: "13.5px",
                          fontWeight: 500,
                        }}
                      >
                        <em className="icon ni ni-lock" style={{ fontSize: "16px" }}></em>
                        Submission is disabled for this form.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : null}
        {/* ── Legacy wizard layout (kept for reference, inactive) ── */}
        {viewFrom === "_disabled_agent-logged-in" ? (
          <>
            {currentGroup ? (
              <>
                <div className="card">
                  <div className="card-inner">
                    <div className="mb-5" style={{ background: "#fff" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                      >
                        <div className="nk-kycfm-title">
                          <h5 className="title">
                            {formTitle || "Untitled Form"}
                          </h5>
                          {currentStep === 0 && (
                            <p className="sub-title">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: formDescription,
                                }}
                              />
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <form
                      autoComplete="off"
                      action="#"
                      className="nk-wizard nk-wizard-simple is-alter wizard clearfix"
                      id="wizard-01"
                      role="application"
                      novalidate="novalidate"
                    >
                      <div className="steps clearfix">
                        <ul role="tablist" className="">
                          {groups.map((group, index) => {
                            const isCurrent = currentStep === index;
                            const isCompleted = currentStep > index;
                            const isDisabled = currentStep < index;

                            return (
                              <li
                                key={group.id}
                                role="tab"
                                className={`${isCurrent ? "current" : ""} ${
                                  isDisabled ? "disabled" : ""
                                } ${index === 0 ? "first" : ""} ${
                                  index === groups.length - 1 ? "last" : ""
                                }`}
                                aria-disabled={isDisabled}
                                aria-selected={isCurrent}
                                style={{ marginBottom: "0.725rem" }}
                              >
                                <div
                                  id={`wizard-01-t-${index}`}
                                  aria-controls={`wizard-01-p-${index}`}
                                >
                                  {isCurrent && (
                                    <span className="current-info audible">
                                      current step:{" "}
                                    </span>
                                  )}
                                  <span className="number">
                                    {String(index + 1).padStart(2, "0")}
                                  </span>
                                  <h5>{group.group_title}</h5>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <div className="nk-stepper-content">
                          <div className="nk-stepper-steps stepper-steps">
                            <div className="nk-kycfm">
                              <div className="">
                                {responseMessage && (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: responseMessage,
                                    }}
                                  ></div>
                                )}
                                {errorMessage && (
                                  <div className="alert alert-danger alert-icon mb-3">
                                    <em className="icon ni ni-cross-circle"></em>{" "}
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: errorMessage,
                                      }}
                                    ></div>
                                  </div>
                                )}
                                <div className="mb-3">
                                  <h5 className="title">
                                    {currentGroup.group_title}
                                  </h5>
                                  <p
                                    className="sub-title"
                                    dangerouslySetInnerHTML={{
                                      __html: currentGroup.group_desc
                                        ? currentGroup.group_desc.replace(
                                            /\n/g,
                                            "<br />",
                                          )
                                        : "",
                                    }}
                                  ></p>
                                </div>
                                {/* Assistant Name Input - Always show at the top */}
                                {allow_agent_name ? (
                                  <>
                                    <div
                                      className="question-container d-flex justify-content-between"
                                      style={{
                                        gap: "10px",
                                        marginBottom: "10px",
                                        paddingBottom: "20px",
                                      }}
                                    >
                                      {/* Assistant Name Input */}
                                      <div
                                        className="form-group question-text mb-0"
                                        style={{ flex: 1 }}
                                      >
                                        <label
                                          className="form-label"
                                          style={{
                                            fontSize: "0.875rem",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Assistant Name{" "}
                                          <sup className="text-danger">*</sup>
                                          <div
                                            className="custom-tooltip-wrapper"
                                            style={{
                                              display: "inline-block",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                                cursor: "pointer",
                                                fontSize: "16px",
                                              }}
                                            ></em>
                                            <div className="custom-tooltip-box">
                                              This name will be used throughout
                                              conversation prompts and messages.
                                              It replaces {"{name}"}{" "}
                                              placeholders in your system
                                              prompts and first message.
                                            </div>
                                          </div>
                                        </label>

                                        <input
                                          className="form-control form-control-lg"
                                          onChange={(e) =>
                                            handleAssistantNameChange(
                                              e.target.value,
                                            )
                                          }
                                          value={
                                            formState["__assistant_name__"] ||
                                            ""
                                          }
                                          type="text"
                                          maxLength={50}
                                          placeholder=""
                                          required
                                        />
                                      </div>

                                      {/* User Form Dropdown Styled */}
                                      <div
                                        className="form-group question-text mb-0"
                                        style={{ flex: 1 }}
                                      >
                                        <label
                                          className="form-label"
                                          style={{
                                            fontSize: "0.875rem",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Lead Entry Form
                                          <div
                                            className="custom-tooltip-wrapper"
                                            style={{
                                              display: "inline-block",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                                cursor: "pointer",
                                                fontSize: "16px",
                                              }}
                                            ></em>
                                            <div className="custom-tooltip-box">
                                              Choose whether to enable a user
                                              facing form for this assistant.
                                            </div>
                                          </div>
                                        </label>

                                        <div className="form-control-wrap">
                                          <div className="form-control-select">
                                            <select
                                              className="form-control form-control-lg"
                                              value={
                                                formState["__user_form__"] ||
                                                "No"
                                              }
                                              onChange={(e) =>
                                                handleUserFormChange(
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              <option value="">
                                                Select an option
                                              </option>
                                              <option value="Yes">Yes</option>
                                              <option value="No">No</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : null}

                                <div className="row g-gs">
                                  {/*currentGroup.questions.map((questionId) => {
                          const question = formData[0].questions.find(
                            (q) => q.id === questionId
                          );
                          if (!question) {
                            return null;
                          }*/}

                                  {currentGroup.questions
                                    .map((questionId) => {
                                      // Find the corresponding question from formData
                                      const question =
                                        formData[0].questions.find(
                                          (q) => q.id === questionId,
                                        );
                                      return question;
                                    })
                                    .filter(Boolean) // Remove any undefined values if a question is not found
                                    .sort(
                                      (a, b) =>
                                        a.sequenceNumber - b.sequenceNumber,
                                    ) // Sort by sequence number
                                    .map((question) => {
                                      const value =
                                        formState[question.id] || "";

                                      return (
                                        <div
                                          key={question.id}
                                          className={
                                            question.answerType === "label" ||
                                            question.answerType === "text_only"
                                              ? "question-container col-sm-12"
                                              : "question-container col-sm-6"
                                          }
                                        >
                                          <div
                                            className="form-group question-text mb-0"
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            {question.answerType === "label" ? (
                                              <label
                                                className="form-label"
                                                style={{ fontSize: "1.275rem" }}
                                              >
                                                {question.questionText}{" "}
                                                {question.required && (
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                )}
                                                {question.tooltip &&
                                                  question.tooltip.trim() !==
                                                    "" && (
                                                    <div className="custom-tooltip-wrapper">
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                          marginLeft: "5px",
                                                          cursor: "pointer",
                                                          fontSize: "16px",
                                                        }}
                                                      ></em>

                                                      <div
                                                        className="custom-tooltip-box"
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            question.tooltip,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  )}
                                              </label>
                                            ) : (
                                              <>
                                                {question.answerType !==
                                                "text_only" ? (
                                                  <label className="form-label">
                                                    {question.questionText}{" "}
                                                    {question.required && (
                                                      <sup className="text-danger">
                                                        *
                                                      </sup>
                                                    )}
                                                    {question.tooltip &&
                                                      question.tooltip.trim() !==
                                                        "" && (
                                                        <div className="custom-tooltip-wrapper">
                                                          <em
                                                            className="icon ni ni-info"
                                                            style={{
                                                              color: "#6576ff",
                                                              marginLeft: "5px",
                                                              cursor: "pointer",
                                                              fontSize: "16px",
                                                            }}
                                                          ></em>

                                                          <div
                                                            className="custom-tooltip-box"
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                question.tooltip,
                                                            }}
                                                          ></div>
                                                        </div>
                                                      )}
                                                  </label>
                                                ) : null}
                                              </>
                                            )}
                                            {question.answerType ===
                                            "text_only" ? (
                                              <>
                                                {question.textType === "p" ? (
                                                  <p>{question.textOnly} </p>
                                                ) : question.textType ===
                                                  "oli" ? (
                                                  <ol
                                                    style={{
                                                      paddingLeft: "20px",
                                                      marginLeft: "20px",
                                                    }}
                                                  >
                                                    {question.textOnly
                                                      .split("\n")
                                                      .filter(
                                                        (line) =>
                                                          line.trim() !== "",
                                                      )
                                                      .map((line, index) => (
                                                        <li
                                                          key={index}
                                                          style={{
                                                            listStyleType:
                                                              "decimal",
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          {line}
                                                        </li>
                                                      ))}
                                                  </ol>
                                                ) : question.textType ===
                                                  "sli" ? (
                                                  <ul
                                                    style={{
                                                      paddingLeft: "20px",
                                                      marginLeft: "20px",
                                                    }}
                                                  >
                                                    {question.textOnly
                                                      .split("\n")
                                                      .filter(
                                                        (line) =>
                                                          line.trim() !== "",
                                                      )
                                                      .map((line, index) => (
                                                        <li
                                                          key={index}
                                                          style={{
                                                            listStyleType:
                                                              "disc",
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          {line}
                                                        </li>
                                                      ))}
                                                  </ul>
                                                ) : (
                                                  <p>{question.textOnly} </p>
                                                )}
                                              </>
                                            ) : null}
                                            <div
                                              style={{
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "flex-end", // 👈 pushes buttons to right
                                                gap: "8px",
                                              }}
                                            >
                                              {question.imageUrl && (
                                                <a
                                                  onClick={() =>
                                                    downloadPdf(
                                                      question.imageUrl,
                                                    )
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <span className="badge badge-outline-primary">
                                                    <em className="icon ni ni-download"></em>{" "}
                                                    Download File
                                                  </span>
                                                </a>
                                              )}

                                              {chatgptEnabled &&
                                                question.allowAI === 1 && (
                                                  <a
                                                    onClick={() =>
                                                      openGenerateModal(
                                                        question,
                                                      )
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <span className="badge badge-outline-primary">
                                                      <em className="icon ni ni-spark"></em>{" "}
                                                      Generate
                                                    </span>
                                                  </a>
                                                )}

                                              {/* Shared Modal */}
                                              {showGenerateModal &&
                                                currentAIQuestion?.id ===
                                                  question.id && (
                                                  <div
                                                    ref={modalRef}
                                                    style={{
                                                      position: "absolute",
                                                      bottom: "100%",
                                                      right: "0",
                                                      width: "420px",
                                                      background: "#fff",
                                                      color: "#111827",
                                                      borderRadius: "10px",
                                                      boxShadow:
                                                        "0 6px 20px rgba(0,0,0,0.15)",
                                                      padding: "18px",
                                                      zIndex: 2000,
                                                      marginBottom: "10px",
                                                    }}
                                                  >
                                                    <h6
                                                      style={{
                                                        fontSize: "15px",
                                                        fontWeight: "600",
                                                        marginBottom: "12px",
                                                      }}
                                                    >
                                                      Edit Prompt
                                                    </h6>

                                                    {/* ⚠️ Error message */}
                                                    {modalError && (
                                                      <div
                                                        style={{
                                                          backgroundColor:
                                                            "#fee",
                                                          border:
                                                            "1px solid #fcc",
                                                          borderRadius: "6px",
                                                          padding: "10px 12px",
                                                          marginBottom: "12px",
                                                          fontSize: "13px",
                                                          color: "#c33",
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                          gap: "8px",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            flexShrink: 0,
                                                          }}
                                                        >
                                                          ⚠️
                                                        </span>
                                                        <span>
                                                          {modalError}
                                                        </span>
                                                      </div>
                                                    )}

                                                    {/* 🧠 User instruction input */}
                                                    <input
                                                      type="text"
                                                      placeholder={
                                                        isGenerated
                                                          ? isFollowUp
                                                            ? "Add follow-ups or refinements..."
                                                            : "Type to make follow-up edits or click Accept Changes below"
                                                          : "Describe how you'd like to edit the prompt"
                                                      }
                                                      style={{
                                                        width: "100%",
                                                        padding: "10px 12px",
                                                        border:
                                                          "1px solid #d1d5db",
                                                        borderRadius: "8px",
                                                        marginBottom: "14px",
                                                        fontSize: "14px",
                                                        boxSizing: "border-box",
                                                      }}
                                                      value={generatedText}
                                                      onChange={
                                                        handleInputChange
                                                      }
                                                      disabled={isGenerating}
                                                    />

                                                    {/* 🔘 Button Group */}
                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        gridTemplateColumns:
                                                          "1fr 1fr",
                                                        gap: "10px",
                                                        width: "100%",
                                                      }}
                                                    >
                                                      {!isGenerated ? (
                                                        // Before generation - Show Cancel and Generate buttons
                                                        <>
                                                          <button
                                                            type="button"
                                                            onClick={
                                                              closeGenerateModal
                                                            }
                                                            style={{
                                                              background:
                                                                "#f3f4f6",
                                                              color: "#374151",
                                                              border:
                                                                "1px solid #e5e7eb",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "8px 16px",
                                                              cursor: "pointer",
                                                              fontWeight: "500",
                                                              fontSize: "14px",
                                                            }}
                                                          >
                                                            Cancel
                                                          </button>
                                                          <button
                                                            type="button"
                                                            onClick={
                                                              handleGenerate
                                                            }
                                                            disabled={
                                                              isGenerating ||
                                                              !generatedText.trim()
                                                            }
                                                            style={{
                                                              background:
                                                                "#6576ff",
                                                              color: "white",
                                                              border: "none",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "8px 16px",
                                                              cursor:
                                                                isGenerating ||
                                                                !generatedText.trim()
                                                                  ? "not-allowed"
                                                                  : "pointer",
                                                              fontWeight: "600",
                                                              opacity:
                                                                isGenerating ||
                                                                !generatedText.trim()
                                                                  ? 0.6
                                                                  : 1,
                                                              fontSize: "14px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              gap: "8px",
                                                            }}
                                                          >
                                                            {isGenerating
                                                              ? "Generating…"
                                                              : "Submit Edit"}
                                                          </button>
                                                        </>
                                                      ) : isFollowUp ? (
                                                        // Follow-up mode - Show Discard and Generate buttons
                                                        <>
                                                          <button
                                                            type="button"
                                                            onClick={() =>
                                                              handleDiscardGenerated(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              background:
                                                                "#f3f4f6",
                                                              color: "#374151",
                                                              border:
                                                                "1px solid #e5e7eb",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "8px 16px",
                                                              cursor: "pointer",
                                                              fontWeight: "500",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              gap: "8px",
                                                              fontSize: "14px",
                                                            }}
                                                          >
                                                            <em
                                                              className="icon ni ni-cross"
                                                              style={{
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            ></em>
                                                            Discard Changes
                                                          </button>
                                                          <button
                                                            type="button"
                                                            onClick={
                                                              handleGenerate
                                                            }
                                                            disabled={
                                                              isGenerating ||
                                                              !generatedText.trim()
                                                            }
                                                            style={{
                                                              background:
                                                                "#6576ff",
                                                              color: "white",
                                                              border: "none",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "8px 16px",
                                                              cursor:
                                                                isGenerating ||
                                                                !generatedText.trim()
                                                                  ? "not-allowed"
                                                                  : "pointer",
                                                              fontWeight: "600",
                                                              opacity:
                                                                isGenerating ||
                                                                !generatedText.trim()
                                                                  ? 0.6
                                                                  : 1,
                                                              fontSize: "14px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              gap: "8px",
                                                            }}
                                                          >
                                                            {isGenerating
                                                              ? "Generating…"
                                                              : "Send Follow-up"}
                                                          </button>
                                                        </>
                                                      ) : (
                                                        // After generation (no follow-up yet) - Show Discard and Accept buttons
                                                        <>
                                                          <button
                                                            type="button"
                                                            onClick={() =>
                                                              handleDiscardGenerated(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              background:
                                                                "#f3f4f6",
                                                              color: "#374151",
                                                              border:
                                                                "1px solid #e5e7eb",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "8px 16px",
                                                              cursor: "pointer",
                                                              fontWeight: "500",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              gap: "8px",
                                                              fontSize: "14px",
                                                            }}
                                                          >
                                                            <em
                                                              className="icon ni ni-cross"
                                                              style={{
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            ></em>
                                                            Discard Changes
                                                          </button>
                                                          <button
                                                            type="button"
                                                            onClick={() =>
                                                              handleUseGeneratedAnswer(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              background:
                                                                "#6576ff",
                                                              color: "white",
                                                              border: "none",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "8px 16px",
                                                              cursor: "pointer",
                                                              fontWeight: "600",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              gap: "8px",
                                                              fontSize: "14px",
                                                            }}
                                                          >
                                                            Accept Changes{" "}
                                                            <em
                                                              className="icon ni ni-check"
                                                              style={{
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            ></em>
                                                          </button>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                            </div>
                                          </div>

                                          {question.answerType === "input" && (
                                            <div className="form-group mb-0">
                                              <div
                                                className="form-control-wrap address_cont"
                                                style={{ position: "relative" }}
                                              >
                                                {/* Only show regular input when NOT showing diff */}
                                                {!diffOutput ||
                                                currentAIQuestion?.id !==
                                                  question.id ? (
                                                  <>
                                                    {/* Phone validation */}
                                                    {question.validationValue ===
                                                    "validation_phone" ? (
                                                      <ReactPhoneInput
                                                        country="us"
                                                        value={formState[question.id] || ""}
                                                        onChange={(v) => handleChangePhone(question.id, v)}
                                                        disabled={isGenerating && currentAIQuestion?.id === question.id}
                                                        inputStyle={{
                                                          width: "100%",
                                                          height: "42px",
                                                          opacity: isGenerating && currentAIQuestion?.id === question.id ? 0.4 : 1,
                                                          ...(formErrors[question.id] ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" } : {}),
                                                        }}
                                                        buttonStyle={formErrors[question.id] ? { borderColor: "#e85347" } : undefined}
                                                      />
                                                    ) : question.validationValue ===
                                                      "validation_fulladdress" ? (
                                                      <GooglePlacesAutocomplete
                                                        apiKey={
                                                          process.env
                                                            .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                                        }
                                                        selectProps={{
                                                          value: formState[
                                                            question.id
                                                          ]
                                                            ? {
                                                                label:
                                                                  formState[
                                                                    question.id
                                                                  ],
                                                                value:
                                                                  formState[
                                                                    question.id
                                                                  ],
                                                              }
                                                            : null,
                                                          onChange: (address) =>
                                                            handleAddressSelect(
                                                              question.id,
                                                              address,
                                                            ),
                                                          placeholder: Address
                                                            ? null
                                                            : "Enter your address...",
                                                          isDisabled:
                                                            isGenerating &&
                                                            currentAIQuestion?.id ===
                                                              question.id,
                                                          styles: {
                                                            input: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                            }),
                                                            option: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                            }),
                                                            singleValue: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                            }),
                                                            menu: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              zIndex: 9,
                                                            }),
                                                            control: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              opacity:
                                                                isGenerating &&
                                                                currentAIQuestion?.id ===
                                                                  question.id
                                                                  ? 0.4
                                                                  : 1,
                                                            }),
                                                          },
                                                        }}
                                                      />
                                                    ) : question.validationValue ===
                                                      "validation_country" ? (
                                                      <Select
                                                        id="_country"
                                                        className="customCountrySelect-addClient"
                                                        name="_country"
                                                        label="Country"
                                                        options={countryOptions}
                                                        value={country}
                                                        onChange={(
                                                          selectedOption,
                                                        ) =>
                                                          handleChangeCountry(
                                                            question.id,
                                                            selectedOption,
                                                          )
                                                        }
                                                        isDisabled={
                                                          isGenerating &&
                                                          currentAIQuestion?.id ===
                                                            question.id
                                                        }
                                                        styles={{
                                                          control: (
                                                            provided,
                                                          ) => ({
                                                            ...provided,
                                                            minHeight: "45px",
                                                            opacity:
                                                              isGenerating &&
                                                              currentAIQuestion?.id ===
                                                                question.id
                                                                ? 0.4
                                                                : 1,
                                                          }),
                                                          menu: (
                                                            provided,
                                                            state,
                                                          ) => ({
                                                            ...provided,
                                                            zIndex: 9,
                                                          }),
                                                        }}
                                                        placeholder="Select Country"
                                                      />
                                                    ) : (
                                                      <input
                                                        className="form-control form-control-lg"
                                                        onChange={(e) =>
                                                          handleChange(
                                                            question.id,
                                                            e.target.value,
                                                            question.inputFormat,
                                                          )
                                                        }
                                                        value={
                                                          formState[
                                                            question.id
                                                          ] || ""
                                                        }
                                                        type="text"
                                                        maxLength={
                                                          question.maxLength ||
                                                          500
                                                        }
                                                        style={{
                                                          paddingRight: "90px",
                                                          opacity:
                                                            isGenerating &&
                                                            currentAIQuestion?.id ===
                                                              question.id
                                                              ? 0.4
                                                              : 1,
                                                          transition:
                                                            "opacity 0.3s ease",
                                                        }}
                                                        readOnly={
                                                          isGenerating &&
                                                          currentAIQuestion?.id ===
                                                            question.id
                                                        }
                                                      />
                                                    )}
                                                  </>
                                                ) : null}

                                                {/* 🟩 Diff Preview for Input */}
                                                {diffOutput &&
                                                  currentAIQuestion?.id ===
                                                    question.id && (
                                                    <div
                                                      className="diff-preview"
                                                      style={{
                                                        backgroundColor:
                                                          "#f9fafb",
                                                        border: isGenerating
                                                          ? "2px solid #6576ff"
                                                          : "1px solid #e5e7eb",
                                                        borderRadius: "8px",
                                                        padding: "12px 16px",
                                                        fontSize: "15px",
                                                        lineHeight: "1.6",
                                                        color: "#111827",
                                                        minHeight: "45px",
                                                        display: "block", // ✅ Changed from flex
                                                        boxShadow: isGenerating
                                                          ? "0 0 0 3px rgba(101, 118, 255, 0.15)"
                                                          : "none",
                                                        transition:
                                                          "all 0.3s ease",
                                                        wordWrap: "break-word",
                                                        whiteSpace: "normal", // ✅ Allow normal wrapping
                                                        overflowWrap:
                                                          "break-word",
                                                      }}
                                                      dangerouslySetInnerHTML={{
                                                        __html: diffOutput,
                                                      }}
                                                    />
                                                  )}

                                                {/* 🌀 Loader Overlay - Shows on top during generation */}
                                                {isGenerating &&
                                                  currentAIQuestion?.id ===
                                                    question.id && (
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        backgroundColor:
                                                          "rgba(255, 255, 255, 0.85)",
                                                        backdropFilter:
                                                          "blur(2px)",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        alignItems: "center",
                                                        borderRadius: "8px",
                                                        zIndex: 10,
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "12px",
                                                          padding: "8px 16px",
                                                          background: "#fff",
                                                          borderRadius: "8px",
                                                          boxShadow:
                                                            "0 2px 8px rgba(0,0,0,0.1)",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            width: "32px",
                                                            height: "32px",
                                                            borderRadius: "50%",
                                                            background:
                                                              "linear-gradient(135deg, #6576ff 0%, #8b9cff 100%)",
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            justifyContent:
                                                              "center",
                                                            animation:
                                                              "pulse-scale 2s ease-in-out infinite",
                                                          }}
                                                        >
                                                          <em
                                                            className="icon ni ni-spark-fill"
                                                            style={{
                                                              fontSize: "16px",
                                                              color: "#fff",
                                                              animation:
                                                                "spin 2s linear infinite",
                                                            }}
                                                          />
                                                        </div>
                                                        <span
                                                          style={{
                                                            fontWeight: 600,
                                                            fontSize: "13px",
                                                            color: "#111827",
                                                          }}
                                                        >
                                                          Generating...
                                                        </span>
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>

                                              <div
                                                className="helper-text"
                                                style={{ marginTop: "6px" }}
                                              >
                                                {question.maxLength && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Maximum length is{" "}
                                                    {question.maxLength}{" "}
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "number_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only numbers are allowed
                                                    (e.g. 123456).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphabet_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphabets are allowed
                                                    (e.g. JohnDoe).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphanumeric" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphanumeric characters
                                                    are allowed (e.g. John123).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "open" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    You can enter any
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                              </div>
                                              {/* Display form errors if present */}
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "signature" && (
                                            <>
                                              <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                  <a
                                                    className={
                                                      signatureType ===
                                                        "draw" ||
                                                      signatureType === ""
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                    }
                                                    data-toggle="tab"
                                                    onClick={() =>
                                                      setSignatureType("draw")
                                                    }
                                                    href="#tabItem6"
                                                  >
                                                    <em className="icon ni ni-edit-alt"></em>
                                                    <span>E-Sign</span>
                                                  </a>
                                                </li>
                                                <li className="nav-item">
                                                  <a
                                                    className={
                                                      signatureType === "choose"
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                    }
                                                    data-toggle="tab"
                                                    onClick={() =>
                                                      setSignatureType("choose")
                                                    }
                                                    href="#tabItem5"
                                                  >
                                                    <em className="icon ni ni-list-check"></em>
                                                    <span>Type</span>
                                                  </a>
                                                </li>
                                              </ul>
                                              <div className="tab-content">
                                                <div
                                                  className={
                                                    signatureType === "choose"
                                                      ? "tab-pane active"
                                                      : "tab-pane"
                                                  }
                                                  id="tabItem5"
                                                >
                                                  <div className="example-alert mb-4">
                                                    <div className="alert alert-light">
                                                      Pick a style for your
                                                      signature (Authorized
                                                      Person Name).
                                                    </div>
                                                  </div>
                                                  <div className="form-group mb-4">
                                                    <div className="form-control-wrap">
                                                      <input
                                                        className={`form-control form-control-lg`}
                                                        onChange={(e) =>
                                                          handleChangeSignature(
                                                            question.id,
                                                            e.target.value,
                                                          )
                                                        }
                                                        onInput={(e) => {
                                                          e.target.value =
                                                            e.target.value.replace(
                                                              /[^a-zA-Z0-9 ]/gi,
                                                              "",
                                                            );
                                                        }}
                                                        value={signatureText}
                                                        type="text"
                                                        maxLength={100}
                                                        placeholder="Authorized Person Name"
                                                      />
                                                    </div>
                                                    {formErrors[
                                                      question.id
                                                    ] && (
                                                      <FormHelperText error>
                                                        {
                                                          formErrors[
                                                            question.id
                                                          ]
                                                        }
                                                      </FormHelperText>
                                                    )}
                                                  </div>

                                                  <h6 className="title">
                                                    Choose Style
                                                  </h6>

                                                  <ul className="cc-pay-method">
                                                    <li className="cc-pay-dd dropdown">
                                                      <a
                                                        href="#"
                                                        className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator"
                                                        data-toggle="dropdown"
                                                      >
                                                        <span
                                                          style={{
                                                            fontFamily:
                                                              signatureClass,
                                                          }}
                                                        >
                                                          {signatureText ||
                                                            "Your Signature"}
                                                        </span>
                                                      </a>
                                                      <div className="dropdown-menu dropdown-menu-auto">
                                                        <ul className="link-list-plain">
                                                          {cursiveFonts.map(
                                                            (font, index) => (
                                                              <li key={index}>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    setSignatureClass(
                                                                      font.value,
                                                                    )
                                                                  }
                                                                  className="cc-pay-item"
                                                                >
                                                                  <span className="cc-pay-item-name">
                                                                    <span
                                                                      className="cc-pay-item-method"
                                                                      style={{
                                                                        fontFamily:
                                                                          font.value,
                                                                      }}
                                                                    >
                                                                      {signatureText !==
                                                                      ""
                                                                        ? signatureText
                                                                        : font.name}
                                                                    </span>
                                                                  </span>
                                                                </a>
                                                              </li>
                                                            ),
                                                          )}
                                                        </ul>
                                                      </div>
                                                    </li>
                                                  </ul>
                                                  <div
                                                    className="signature-preview mt-3"
                                                    id={`styled-text-container${question.id}`}
                                                    style={{
                                                      fontFamily:
                                                        signatureClass,
                                                      fontSize: "40px",
                                                      width: "480px",
                                                      height: "80px",
                                                      background:
                                                        "trasnparent",
                                                      backgroundColor:
                                                        "transparent",
                                                      border: "none",
                                                      lineHeight: "80px",
                                                      color: "#000",
                                                    }}
                                                  >
                                                    {signatureText ||
                                                      "Your Signature"}
                                                  </div>

                                                  <div
                                                    className="col-sm-12 mt-4 pl-0"
                                                    style={{ clear: "both" }}
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-primary"
                                                      style={{
                                                        margin:
                                                          "13px 0px 12px 0px",
                                                      }}
                                                      onClick={() =>
                                                        saveChooseImage(
                                                          question.id,
                                                        )
                                                      }
                                                    >
                                                      <em className="icon ni ni-folder-check"></em>{" "}
                                                      <span>
                                                        Save Signature
                                                      </span>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div
                                                  className={
                                                    signatureType === "draw" ||
                                                    signatureType === ""
                                                      ? "tab-pane active"
                                                      : "tab-pane"
                                                  }
                                                  id="tabItem6"
                                                >
                                                  <div className="row">
                                                    <div className="col-sm-12">
                                                      <div className="example-alert mb-4">
                                                        <div className="alert alert-light">
                                                          Please Save the
                                                          signature to proceed.
                                                        </div>
                                                      </div>
                                                      {formState[
                                                        question.id
                                                      ] && (
                                                        <div className="uploaded-file-preview">
                                                          <img
                                                            src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                              formState[
                                                                question.id
                                                              ]
                                                            }`}
                                                            alt="Uploaded Signature"
                                                            style={{
                                                              maxWidth: "200px",
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                      <div
                                                        id={`divSig${question.id}`}
                                                        style={{
                                                          display: "none",
                                                        }}
                                                      >
                                                        <div className="mb-4">
                                                          <img
                                                            src=""
                                                            className="clsimgSig"
                                                            height="100"
                                                            width="200"
                                                            onerror="this.style.display='none'"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div>
                                                        <strong>
                                                          Signature
                                                        </strong>
                                                      </div>
                                                    </div>

                                                    <div className="col-sm-12">
                                                      <SignatureCanvas
                                                        clearOnResize={true}
                                                        canvasProps={{
                                                          className:
                                                            styles.sigPad,
                                                        }}
                                                        velocityFilterWeight={
                                                          0.7
                                                        }
                                                        throttle={50}
                                                        ref={(ref) =>
                                                          (sigPadRefs.current[
                                                            question.id
                                                          ] = ref)
                                                        }
                                                      />
                                                    </div>
                                                    <div className="col-sm-12 mt-4">
                                                      <button
                                                        className="btn btn-warning"
                                                        style={{
                                                          margin:
                                                            "13px 0px 12px 0px",
                                                        }}
                                                        onClick={() =>
                                                          clearSignature(
                                                            question.id,
                                                          )
                                                        }
                                                        type="button"
                                                      >
                                                        <em className="icon ni ni-delete"></em>{" "}
                                                        <span>Clear</span>
                                                      </button>
                                                      {/*<button
                                            className="btn btn-success"
                                            style={{
                                              margin: "13px 0px 12px 10px",
                                            }}
                                            type="button"
                                            onClick={() =>
                                              previewSignature(question.id)
                                            }
                                          >
                                            <em className="icon ni ni-eye"></em>{" "}
                                            <span>Preview</span>
                                          </button>*/}
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{
                                                          margin:
                                                            "13px 0px 12px 10px",
                                                        }}
                                                        onClick={() =>
                                                          saveSignature(
                                                            question.id,
                                                          )
                                                        }
                                                      >
                                                        <em className="icon ni ni-folder-check"></em>{" "}
                                                        <span>
                                                          Save Signature
                                                        </span>
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                          {question.answerType === "fixed" && (
                                            <>
                                              <div className="form-group mb-0">
                                                <div className="form-control-wrap">
                                                  <input
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChangeFixed(
                                                        question.id,
                                                        question.answer,
                                                      )
                                                    }
                                                    value={question.answer}
                                                    type="text"
                                                    maxLength={255}
                                                  />
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                              <CopyToClipboard
                                                text={question.answer}
                                                onCopy={() => setCopied(true)}
                                                style={{ cursor: "pointer" }}
                                              >
                                                <div className="form-note text-primary">
                                                  <strong>
                                                    Copy to Clipboard{" "}
                                                    {copied ? (
                                                      <span>
                                                        <em className="icon ni ni-done"></em>
                                                      </span>
                                                    ) : null}
                                                  </strong>
                                                </div>
                                              </CopyToClipboard>
                                            </>
                                          )}
                                          {question.answerType === "label" && (
                                            <div className="form-group mb-0">
                                              <h6></h6>
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "textarea" && (
                                            <div className="form-group">
                                              <div
                                                className="form-control-wrap"
                                                style={{
                                                  display: "flex",
                                                  gap: "20px",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                {/* Textarea container - increased width */}
                                                <div
                                                  style={{
                                                    flex: 3,
                                                    minWidth: "100%",
                                                  }}
                                                >
                                                  {" "}
                                                  {/* Increased from flex: 1 to flex: 2 */}
                                                  <div
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    {/* 🧠 Detect HTML or show textarea */}
                                                    {!diffOutput &&
                                                      (() => {
                                                        const rawValue =
                                                          formState[
                                                            question.id
                                                          ] ?? "";
                                                        const isHtml =
                                                          /<\/?[a-z][\s\S]*>/i.test(
                                                            rawValue.trim(),
                                                          );

                                                        if (isHtml) {
                                                          return (
                                                            <div
                                                              ref={
                                                                contentEditableRef
                                                              }
                                                              contentEditable={
                                                                !isGenerating
                                                              }
                                                              suppressContentEditableWarning
                                                              className="form-control form-control-lg"
                                                              style={{
                                                                height: "500px",
                                                                backgroundColor:
                                                                  "#fff",
                                                                borderRadius:
                                                                  "8px",
                                                                border:
                                                                  "1px solid #e5e7eb",
                                                                padding: "12px",
                                                                overflowY:
                                                                  "auto",
                                                                fontSize:
                                                                  "15px",
                                                                lineHeight: 1.6,
                                                                color:
                                                                  "#111827",
                                                                whiteSpace:
                                                                  "pre-wrap",
                                                                fontFamily:
                                                                  "inherit",
                                                                opacity:
                                                                  isGenerating
                                                                    ? 0.4
                                                                    : 1,
                                                                transition:
                                                                  "opacity 0.3s ease",
                                                                pointerEvents:
                                                                  isGenerating
                                                                    ? "none"
                                                                    : "auto",
                                                                width: "100%", // Ensure full width
                                                              }}
                                                              onInput={(e) => {
                                                                const caretPos =
                                                                  saveCaretPosition(
                                                                    e.currentTarget,
                                                                  );
                                                                handleChange(
                                                                  question.id,
                                                                  e
                                                                    .currentTarget
                                                                    .innerHTML,
                                                                );

                                                                setTimeout(
                                                                  () => {
                                                                    if (
                                                                      contentEditableRef.current &&
                                                                      caretPos !==
                                                                        null
                                                                    ) {
                                                                      restoreCaretPosition(
                                                                        contentEditableRef.current,
                                                                        caretPos,
                                                                      );
                                                                    }
                                                                  },
                                                                  0,
                                                                );
                                                              }}
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  normalizeHTMLStructure(
                                                                    rawValue.replace(
                                                                      /<(\/?)h2(.*?)>/gi,
                                                                      "<$1strong$2>",
                                                                    ),
                                                                  ),
                                                              }}
                                                            />
                                                          );
                                                        }

                                                        // Plain textarea for non-HTML content
                                                        return (
                                                          <textarea
                                                            className="form-control form-control-lg"
                                                            readOnly={
                                                              isGenerating
                                                            }
                                                            style={{
                                                              height: "500px",
                                                              backgroundColor:
                                                                "#fff",
                                                              borderRadius:
                                                                "8px",
                                                              border:
                                                                "1px solid #e5e7eb",
                                                              fontFamily:
                                                                "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas",
                                                              fontSize: "14px",
                                                              whiteSpace:
                                                                "pre-wrap",
                                                              lineHeight: 1.6,
                                                              padding: "12px",
                                                              resize:
                                                                "vertical",
                                                              opacity:
                                                                isGenerating
                                                                  ? 0.4
                                                                  : 1,
                                                              transition:
                                                                "opacity 0.3s ease",
                                                              pointerEvents:
                                                                isGenerating
                                                                  ? "none"
                                                                  : "auto",
                                                              width: "100%", // Ensure full width
                                                            }}
                                                            onChange={(e) =>
                                                              handleChange(
                                                                question.id,
                                                                e.target.value,
                                                              )
                                                            }
                                                            value={rawValue}
                                                            maxLength={
                                                              question.maxLength ||
                                                              20000
                                                            }
                                                          />
                                                        );
                                                      })()}

                                                    {/* 🟩 Diff Preview */}
                                                    {diffOutput && (
                                                      <div
                                                        ref={diffPreviewRef}
                                                        className="diff-preview"
                                                        contentEditable={false}
                                                        style={{
                                                          position: "relative",
                                                          backgroundColor:
                                                            "#f9fafb",
                                                          border: isGenerating
                                                            ? "2px solid #6576ff"
                                                            : "1px solid #e5e7eb",
                                                          borderRadius: "8px",
                                                          height: "500px",
                                                          padding: "16px",
                                                          overflowY: "auto",
                                                          fontSize: "15px",
                                                          lineHeight: 1.6,
                                                          color: "#111827",
                                                          whiteSpace:
                                                            "pre-wrap",
                                                          fontFamily: "inherit",
                                                          scrollBehavior:
                                                            "smooth",
                                                          boxShadow:
                                                            isGenerating
                                                              ? "0 0 0 3px rgba(101, 118, 255, 0.15)"
                                                              : "none",
                                                          transition:
                                                            "all 0.3s ease",
                                                          width: "100%", // Ensure full width
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            diffOutput.replace(
                                                              /<(\/?)h2(.*?)>/gi,
                                                              "<$1strong$2>",
                                                            ),
                                                        }}
                                                      />
                                                    )}

                                                    {/* 🌀 Loader Overlay */}
                                                    {isGenerating && (
                                                      <div
                                                        style={{
                                                          position: "absolute",
                                                          inset: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 0.75)",
                                                          backdropFilter:
                                                            "blur(3px)",
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center",
                                                          gap: "20px",
                                                          borderRadius: "8px",
                                                          zIndex: 10,
                                                        }}
                                                      >
                                                        {/* Animated Icon Circle */}
                                                        <div
                                                          style={{
                                                            width: "70px",
                                                            height: "70px",
                                                            borderRadius: "50%",
                                                            background:
                                                              "linear-gradient(135deg, #6576ff 0%, #8b9cff 100%)",
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            justifyContent:
                                                              "center",
                                                            animation:
                                                              "pulse-scale 2s ease-in-out infinite",
                                                            boxShadow:
                                                              "0 8px 24px rgba(101, 118, 255, 0.3)",
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              width: "58px",
                                                              height: "58px",
                                                              borderRadius:
                                                                "50%",
                                                              backgroundColor:
                                                                "#fff",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                            }}
                                                          >
                                                            <em
                                                              className="icon ni ni-spark-fill"
                                                              style={{
                                                                fontSize:
                                                                  "30px",
                                                                color:
                                                                  "#6576ff",
                                                                animation:
                                                                  "spin 2s linear infinite",
                                                              }}
                                                            />
                                                          </div>
                                                        </div>

                                                        {/* Text */}
                                                        <div
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              fontWeight: 600,
                                                              fontSize: "18px",
                                                              color: "#111827",
                                                              marginBottom:
                                                                "8px",
                                                            }}
                                                          >
                                                            Generating Content
                                                          </div>
                                                          <div
                                                            style={{
                                                              fontSize: "14px",
                                                              color: "#6b7280",
                                                            }}
                                                          >
                                                            AI is working on
                                                            your prompt...
                                                          </div>
                                                        </div>

                                                        {/* Animated Progress Bar */}
                                                        <div
                                                          style={{
                                                            width: "220px",
                                                            height: "4px",
                                                            backgroundColor:
                                                              "#e5e7eb",
                                                            borderRadius: "2px",
                                                            overflow: "hidden",
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              height: "100%",
                                                              width: "40%",
                                                              background:
                                                                "linear-gradient(90deg, #6576ff 0%, #8b9cff 100%)",
                                                              borderRadius:
                                                                "2px",
                                                              animation:
                                                                "loading 1.5s ease-in-out infinite",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                                {/* Widget Preview Container - moved to right */}
                                                {question.questionText ===
                                                  "Embed Code" && (
                                                  <div
                                                    style={{
                                                      flexShrink: 0,
                                                      width: "360px",
                                                      marginLeft: "40px",
                                                    }}
                                                  >
                                                    {/* Header */}
                                                    <div
                                                      style={{
                                                        marginBottom: "16px",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <h3
                                                        style={{
                                                          margin: "0 0 6px 0",
                                                          fontSize: "0.875rem",
                                                          fontWeight: "600",
                                                          color: "#344357",
                                                        }}
                                                      >
                                                        Widget Preview
                                                      </h3>
                                                      <p
                                                        style={{
                                                          margin: "0",
                                                          fontSize: "13px",
                                                          color: "#6b7280",
                                                          lineHeight: "1.4",
                                                        }}
                                                      >
                                                        Live preview of how the
                                                        widget will appear on
                                                        your website
                                                      </p>
                                                    </div>

                                                    {isLeadFormEnabled ? (
                                                      /* 🟢 LEAD FORM PREVIEW MODE */
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          marginTop: "8px",
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            width: "340px",
                                                            borderRadius:
                                                              "16px",
                                                            backgroundColor:
                                                              "#0b1221",
                                                            color: "#fff",
                                                            boxShadow:
                                                              "0 6px 24px rgba(0,0,0,0.25)",
                                                            fontFamily:
                                                              "'Segoe UI', Roboto, -apple-system, BlinkMacSystemFont, sans-serif",
                                                            overflow: "hidden",
                                                            textAlign: "center",
                                                            padding:
                                                              "22px 20px",
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          {/* Close Icon */}
                                                          <div
                                                            style={{
                                                              position:
                                                                "absolute",
                                                              right: "18px",
                                                              top: "14px",
                                                              fontSize: "18px",
                                                              color: "#9ca3af",
                                                              cursor:
                                                                "not-allowed",
                                                            }}
                                                          >
                                                            ✕
                                                          </div>

                                                          {/* Header Icon */}
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "center",
                                                              alignItems:
                                                                "center",
                                                              marginBottom:
                                                                "10px",
                                                            }}
                                                          >
                                                            <em
                                                              className="icon ni ni-call"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                                color:
                                                                  previewThemeColor ||
                                                                  "#d4af37", // ✅ Dynamic theme color
                                                              }}
                                                            ></em>
                                                          </div>

                                                          {/* Title */}
                                                          <h4
                                                            style={{
                                                              fontSize: "16px",
                                                              fontWeight: "600",
                                                              marginBottom:
                                                                "2px",
                                                            }}
                                                          >
                                                            Connect with{" "}
                                                            {(
                                                              previewAgentName ||
                                                              "Maya"
                                                            ).replace(
                                                              /<[^>]+>/g,
                                                              "",
                                                            )}
                                                          </h4>

                                                          {/* Subtitle */}
                                                          <p
                                                            style={{
                                                              fontSize:
                                                                "12.5px",
                                                              color: "#cbd5e1",
                                                              marginBottom:
                                                                "14px",
                                                            }}
                                                          >
                                                            Provide your
                                                            information to start
                                                            your consultation
                                                          </p>

                                                          {/* Inputs */}
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "column",
                                                              gap: "8px",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            {/* Full Name */}
                                                            <label
                                                              style={{
                                                                fontSize:
                                                                  "13px",
                                                                fontWeight:
                                                                  "500",
                                                                marginBottom:
                                                                  "0px",
                                                              }}
                                                            >
                                                              Full Name{" "}
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#f87171",
                                                                }}
                                                              >
                                                                *
                                                              </span>
                                                            </label>
                                                            <input
                                                              type="text"
                                                              placeholder="Enter your full name"
                                                              disabled
                                                              style={{
                                                                padding:
                                                                  "9px 11px",
                                                                borderRadius:
                                                                  "8px",
                                                                border:
                                                                  "1px solid #1e293b",
                                                                backgroundColor:
                                                                  "#111827",
                                                                color:
                                                                  "#e2e8f0",
                                                                fontSize:
                                                                  "13px",
                                                              }}
                                                            />

                                                            {/* Email Address */}
                                                            <label
                                                              style={{
                                                                fontSize:
                                                                  "13px",
                                                                fontWeight:
                                                                  "500",
                                                                marginTop:
                                                                  "4px",
                                                                marginBottom:
                                                                  "0px",
                                                              }}
                                                            >
                                                              Email Address{" "}
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#f87171",
                                                                }}
                                                              >
                                                                *
                                                              </span>
                                                            </label>
                                                            <input
                                                              type="email"
                                                              placeholder="your.email@company.com"
                                                              disabled
                                                              style={{
                                                                padding:
                                                                  "9px 11px",
                                                                borderRadius:
                                                                  "8px",
                                                                border:
                                                                  "1px solid #1e293b",
                                                                backgroundColor:
                                                                  "#111827",
                                                                color:
                                                                  "#e2e8f0",
                                                                fontSize:
                                                                  "13px",
                                                              }}
                                                            />

                                                            {/* USA Phone Number */}
                                                            <label
                                                              style={{
                                                                fontSize:
                                                                  "13px",
                                                                fontWeight:
                                                                  "500",
                                                                marginTop:
                                                                  "4px",
                                                                marginBottom:
                                                                  "0px",
                                                              }}
                                                            >
                                                              USA Phone Number{" "}
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#f87171",
                                                                }}
                                                              >
                                                                *
                                                              </span>
                                                            </label>
                                                            <input
                                                              type="tel"
                                                              placeholder="(555) 123-4567"
                                                              disabled
                                                              style={{
                                                                padding:
                                                                  "9px 11px",
                                                                borderRadius:
                                                                  "8px",
                                                                border:
                                                                  "1px solid #1e293b",
                                                                backgroundColor:
                                                                  "#111827",
                                                                color:
                                                                  "#e2e8f0",
                                                                fontSize:
                                                                  "13px",
                                                              }}
                                                            />
                                                          </div>

                                                          {/* Info Note */}
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              gap: "6px",
                                                              marginTop: "10px",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <em
                                                              className="icon ni ni-shield"
                                                              style={{
                                                                fontSize:
                                                                  "15px",
                                                                color:
                                                                  previewThemeColor ||
                                                                  "#d4af37", // ✅ Dynamic theme color
                                                                flexShrink: 0,
                                                                marginTop:
                                                                  "1px",
                                                              }}
                                                            ></em>

                                                            <p
                                                              style={{
                                                                fontSize:
                                                                  "11px",
                                                                color:
                                                                  "#cbd5e1",
                                                                lineHeight:
                                                                  "1.35",
                                                                margin: 0,
                                                              }}
                                                            >
                                                              Your information
                                                              is protected and
                                                              will only be used
                                                              to connect you
                                                              with{" "}
                                                              {(
                                                                previewAgentName ||
                                                                "Maya"
                                                              ).replace(
                                                                /<[^>]+>/g,
                                                                "",
                                                              )}
                                                              .
                                                            </p>
                                                          </div>

                                                          {/* Button */}
                                                          <button
                                                            disabled
                                                            style={{
                                                              marginTop: "14px",
                                                              width: "100%",
                                                              backgroundColor:
                                                                previewThemeColor ||
                                                                "#d4af37", // ✅ Dynamic theme color
                                                              color: "#000",
                                                              border: "none",
                                                              borderRadius:
                                                                "8px",
                                                              padding: "10px",
                                                              fontWeight: "600",
                                                              fontSize: "14px",
                                                              cursor:
                                                                "not-allowed",
                                                            }}
                                                          >
                                                            Start Consultation
                                                          </button>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      /* 🟡 AI WIDGET PREVIEW MODE */
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            borderRadius:
                                                              "20px",
                                                            overflow: "hidden",
                                                            width: "340px",
                                                            minHeight: "445px",
                                                            boxShadow:
                                                              "0 6px 24px rgba(0,0,0,0.25)",
                                                            fontFamily:
                                                              "'Segoe UI', Roboto, -apple-system, BlinkMacSystemFont, sans-serif",
                                                            backgroundColor:
                                                              "#0b0c10",
                                                            color: "#fff",
                                                            display: "flex",
                                                            flexDirection:
                                                              "column",
                                                          }}
                                                        >
                                                          {/* Header */}
                                                          <div
                                                            style={{
                                                              backgroundColor:
                                                                previewThemeColor ||
                                                                "#d4af37",
                                                              color: "#000",
                                                              padding:
                                                                "14px 18px 10px",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: "6px",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            >
                                                              <em
                                                                className="icon ni ni-mic"
                                                                style={{
                                                                  fontSize:
                                                                    "16px",
                                                                  color: "#000",
                                                                }}
                                                              ></em>
                                                              <span>
                                                                {(
                                                                  previewAgentName ||
                                                                  "Maya"
                                                                ).replace(
                                                                  /<[^>]+>/g,
                                                                  "",
                                                                )}
                                                              </span>
                                                            </div>
                                                            <div
                                                              style={{
                                                                fontSize:
                                                                  "12px",
                                                                fontWeight: 400,
                                                                marginTop:
                                                                  "2px",
                                                                color: "#000",
                                                              }}
                                                            >
                                                              Available 24/7
                                                            </div>
                                                          </div>

                                                          {/* Body */}
                                                          <div
                                                            style={{
                                                              padding:
                                                                "38px 24px 36px",
                                                              textAlign:
                                                                "center",
                                                              flexGrow: 1,
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                width: "72px",
                                                                height: "72px",
                                                                margin:
                                                                  "0 auto 24px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                            >
                                                              <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth={2}
                                                                stroke={
                                                                  previewThemeColor ||
                                                                  "#d4af37"
                                                                }
                                                                style={{
                                                                  width: "42px",
                                                                  height:
                                                                    "42px",
                                                                }}
                                                              >
                                                                <path
                                                                  strokeLinecap="round"
                                                                  strokeLinejoin="round"
                                                                  d="M12 1.5a3 3 0 00-3 3v6a3 3 0 006 0v-6a3 3 0 00-3-3zM5.25 10.5v1.5a6.75 6.75 0 0013.5 0v-1.5M12 19.5v3m-4.5 0h9"
                                                                />
                                                              </svg>
                                                            </div>

                                                            <h6
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                                fontWeight: 600,
                                                                marginBottom:
                                                                  "12px",
                                                                color:
                                                                  "#ffffff",
                                                              }}
                                                            >
                                                              Talk to{" "}
                                                              {(
                                                                previewAgentName ||
                                                                "Maya"
                                                              ).replace(
                                                                /<[^>]+>/g,
                                                                "",
                                                              )}
                                                            </h6>

                                                            <p
                                                              style={{
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "#d1d5db",
                                                                margin:
                                                                  "0 auto 38px",
                                                                lineHeight: 1.6,
                                                                maxWidth:
                                                                  "270px",
                                                              }}
                                                            >
                                                              Experience our
                                                              advanced{" "}
                                                              {(
                                                                previewAgentName ||
                                                                "Maya"
                                                              ).replace(
                                                                /<[^>]+>/g,
                                                                "",
                                                              )}{" "}
                                                              voice agent with
                                                              real-time
                                                              conversation
                                                              capabilities.
                                                            </p>

                                                            <button
                                                              disabled
                                                              style={{
                                                                backgroundColor:
                                                                  previewThemeColor ||
                                                                  "#d4af37",
                                                                color: "#000",
                                                                border: "none",
                                                                borderRadius:
                                                                  "8px",
                                                                padding:
                                                                  "12px 20px",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "15px",
                                                                width: "100%",
                                                                maxWidth:
                                                                  "270px",
                                                                height: "48px",
                                                                cursor:
                                                                  "not-allowed",
                                                              }}
                                                            >
                                                              <em
                                                                className="icon ni ni-mic"
                                                                style={{
                                                                  fontSize:
                                                                    "18px",
                                                                  color: "#000",
                                                                  marginRight:
                                                                    "6px",
                                                                }}
                                                              ></em>
                                                              Start{" "}
                                                              {(
                                                                previewAgentName ||
                                                                "Maya"
                                                              ).replace(
                                                                /<[^>]+>/g,
                                                                "",
                                                              )}
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "datetime" && (
                                            <div className="form-group">
                                              <DateTimePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                format="MM-dd-yyyy hh:mm a"
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(date) =>
                                                  handleChange(
                                                    question.id,
                                                    date,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType === "date" && (
                                            <div className="form-group">
                                              <DatePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                format="MM-dd-yyyy"
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(date) =>
                                                  handleChange(
                                                    question.id,
                                                    date,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType === "time" && (
                                            <div className="form-group">
                                              <TimePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(time) =>
                                                  handleChange(
                                                    question.id,
                                                    time,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "dropdown" && (
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div className="form-control-select">
                                                  <select
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    value={
                                                      formState[question.id] ??
                                                      ""
                                                    }
                                                  >
                                                    <option value="">
                                                      Select an option
                                                    </option>
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <option
                                                          key={index}
                                                          value={option}
                                                        >
                                                          {option}
                                                        </option>
                                                      ),
                                                    )}
                                                  </select>
                                                </div>
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "checkbox" && (
                                            <>
                                              <div className="mt-2 prettyprint ">
                                                <div className="row">
                                                  {question.options.map(
                                                    (option, index) => (
                                                      <div
                                                        className="col-md-12 mb-1"
                                                        key={`options_${index}`}
                                                      >
                                                        <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                          <input
                                                            type="checkbox"
                                                            className="custom-control-input vdrSelected"
                                                            id={`question_checkbox_${question.id}_${index}`}
                                                            checked={
                                                              formState[
                                                                question.id
                                                              ]?.includes(
                                                                option,
                                                              ) || false
                                                            }
                                                            onChange={(e) =>
                                                              handleCheckboxChange(
                                                                question.id,
                                                                option,
                                                                e.target
                                                                  .checked,
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            className="custom-control-label"
                                                            htmlFor={`question_checkbox_${question.id}_${index}`}
                                                          >
                                                            {option}
                                                          </label>
                                                        </div>
                                                        {formErrors[
                                                          question.id
                                                        ] && (
                                                          <FormHelperText error>
                                                            {
                                                              formErrors[
                                                                question.id
                                                              ]
                                                            }
                                                          </FormHelperText>
                                                        )}
                                                      </div>
                                                    ),
                                                  )}
                                                </div>
                                              </div>
                                            </>
                                          )}

                                          {question.answerType === "radio" && (
                                            <div className="form-pm-group">
                                              <ul className="buysell-pm-list">
                                                {question.options.map(
                                                  (option, index) => (
                                                    <li
                                                      className="buysell-pm-item"
                                                      key={index}
                                                    >
                                                      <input
                                                        className="buysell-pm-control"
                                                        type="radio"
                                                        name={`radio_${question.id}`}
                                                        id={`radio_${question.id}_${index}`}
                                                        checked={
                                                          formState[
                                                            question.id
                                                          ]?.includes(option) ||
                                                          false
                                                        }
                                                        onChange={(e) =>
                                                          handleChange(
                                                            question.id,
                                                            option,
                                                          )
                                                        }
                                                        value={option}
                                                      />
                                                      <label
                                                        className="buysell-pm-label"
                                                        htmlFor={`radio_${question.id}_${index}`}
                                                      >
                                                        <span className="pm-name">
                                                          {option}
                                                        </span>
                                                        <span className="pm-icon">
                                                          {/*<em className="icon ni ni-question"></em>*/}
                                                        </span>
                                                      </label>
                                                    </li>
                                                  ),
                                                )}
                                              </ul>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "image_input" && (
                                            <div className="form-group">
                                              <div
                                                className="form-control-group"
                                                id="fileContainer"
                                              >
                                                <input
                                                  type="file"
                                                  id={`add_picture_${question.id}`}
                                                  className="file-block"
                                                  name="add_picture"
                                                  accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                  onChange={(e) =>
                                                    handleFileChange(
                                                      question.id,
                                                      e,
                                                    )
                                                  }
                                                />
                                                {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                {formState[question.id] && (
                                                  <div className="uploaded-file-preview">
                                                    {formState[
                                                      question.id
                                                    ].match(
                                                      /\.(jpeg|jpg|png)$/i,
                                                    ) ? (
                                                      <>
                                                        <img
                                                          src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                            formState[
                                                              question.id
                                                            ]
                                                          }`}
                                                          alt="Uploaded preview"
                                                          style={{
                                                            maxWidth: "100px",
                                                          }}
                                                        />
                                                        <a
                                                          onClick={() =>
                                                            removeUploadedFile(
                                                              question.id,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "20px",
                                                            marginLeft: "5px",
                                                          }}
                                                          className="fs-20"
                                                          title="Delete"
                                                        >
                                                          <em className="icon ni ni-trash-fill"></em>
                                                        </a>
                                                      </>
                                                    ) : (
                                                      <p>
                                                        {formState[question.id]
                                                          .split("/")
                                                          .pop()}
                                                        <a
                                                          onClick={() =>
                                                            removeUploadedFile(
                                                              question.id,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "20px",
                                                            marginLeft: "5px",
                                                          }}
                                                          className="fs-20"
                                                          title="Delete"
                                                        >
                                                          <em className="icon ni ni-trash-fill"></em>
                                                        </a>
                                                      </p> // Display file name for non-images
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* CAPTCHA Section - Show on last step for multi-step forms or on single-step forms */}
                      {shouldShowCaptcha && (
                        <div
                          className="captcha-section"
                          style={{
                            marginTop: "20px",
                            marginBottom: "10px",
                          }}
                        >
                          <ReCAPTCHA
                            ref={captchaRef}
                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                            onChange={handleCaptchaChange}
                            onExpired={handleCaptchaExpired}
                          />
                        </div>
                      )}
                      <div
                        className="actions clearfix"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "20px",
                        }}
                      >
                        <ul role="menu" aria-label="Pagination">
                          {currentStep > 0 && (
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => setCurrentStep(currentStep - 1)}
                              style={{
                                marginBottom: "10px",
                                marginTop: "10px",
                              }}
                              className="back-button-mobile"
                            >
                              Back
                            </Button>
                          )}
                          {allowSkip === 1 &&
                            isOnboarding &&
                            isFilled !== 1 &&
                            isSkipped !== 1 && (
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={onSkipStep}
                                style={{
                                  marginLeft: "10px",
                                  marginBottom: "10px",
                                  marginTop: "10px",
                                }}
                                className="skip-button-mobile"
                              >
                                <em className="icon ni ni-forward"></em> Skip
                                This Step
                              </Button>
                            )}
                          {(isFilled === 1 || isSkipped === 1) && (
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={onNextStep}
                              style={{
                                marginLeft: "10px",
                                marginBottom: "10px",
                                marginTop: "10px",
                              }}
                              className="next-button-mobile"
                            >
                              <em className="icon ni ni-forward"></em> Next Step
                            </Button>
                          )}
                          {currentStep < groups.length - 1 ? (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleNextStep}
                              style={{ marginLeft: "10px" }}
                            >
                              Continue
                            </Button>
                          ) : (
                            <>
                              {allow_submit === 1 && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleSubmit}
                                  style={{ marginLeft: "10px" }}
                                  disabled={loading || isFormInReviewMode}
                                >
                                  {loading ? "Loading..." : "Submit"}
                                </Button>
                              )}
                              {allow_submit === 0 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-warning"
                                  style={{ marginLeft: "10px" }}
                                >
                                  Submission is disabled for this form.
                                </button>
                              )}
                            </>
                          )}
                        </ul>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            ) : (
              hasUngroupedQuestions && (
                <>
                  <div className="nk-block nk-block-lg">
                    <div className="card">
                      <form
                        autoComplete="off"
                        className="nk-stepper stepper-init is-alter nk-stepper-s1"
                        action="#"
                        id="stepper-create-project"
                        data-step-current="2"
                        noValidate
                        style={{ display: "block" }}
                      >
                        <div className="row g-0 col-sep col-sep-md col-sep-xl">
                          <div className="col-md-3 col-xl-3">
                            <div className="card-inner">
                              <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                                {groups.map((group, index) => (
                                  <li
                                    key={group.id}
                                    className={
                                      currentStep === index
                                        ? "current"
                                        : currentStep > index
                                          ? "done"
                                          : ""
                                    }
                                  >
                                    <div className="step-item">
                                      <div className="step-text">
                                        <div className="lead-text">
                                          {group.group_title}
                                        </div>
                                        <div
                                          className="sub-text"
                                          dangerouslySetInnerHTML={{
                                            __html: group.group_desc,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>

                          <div className="col-md-9 col-xl-9">
                            <div className="card-inner">
                              <div className="nk-stepper-content">
                                <div className="nk-stepper-steps stepper-steps">
                                  <div className="nk-kycfm">
                                    <div
                                      className="nk-kycfm-head"
                                      style={{ background: "#f5f6fa" }}
                                    >
                                      <div className="nk-kycfm-title">
                                        <h5 className="title">
                                          {formTitle || "Untitled Form"}
                                        </h5>
                                        <p className="sub-title">
                                          {formDescription || "Untitled Form"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="nk-kycfm-content">
                                      {responseMessage && (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: responseMessage,
                                          }}
                                        ></div>
                                      )}
                                      {errorMessage && (
                                        <div className="alert alert-danger alert-icon mb-3">
                                          <em className="icon ni ni-cross-circle"></em>{" "}
                                          Please fill out all the required
                                          questions!
                                        </div>
                                      )}
                                      <div className="row g-gs">
                                        {ungroupedQuestions.map((question) => (
                                          <div
                                            key={question.id}
                                            className="question-container col-sm-6"
                                          >
                                            <div className="form-group question-text mb-0">
                                              <label className="form-label">
                                                {question.questionText}{" "}
                                                {question.required && (
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                )}
                                                {question.tooltip &&
                                                  question.tooltip.trim() !==
                                                    "" && (
                                                    <div className="custom-tooltip-wrapper">
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                          marginLeft: "5px",
                                                          cursor: "pointer",
                                                          fontSize: "16px",
                                                        }}
                                                      ></em>

                                                      <div
                                                        className="custom-tooltip-box"
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            question.tooltip,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  )}
                                              </label>
                                            </div>
                                            {question.imageUrl && (
                                              <img
                                                src={question.imageUrl}
                                                alt="Admin Uploaded"
                                                className="question-image"
                                              />
                                            )}
                                            {question.answerType ===
                                              "input" && (
                                              <div className="form-group mb-0">
                                                <div className="form-control-wrap">
                                                  <input
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    type="text"
                                                    maxLength={500}
                                                  />
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "textarea" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <textarea
                                                    className={`form-control form-control-lg`}
                                                    style={{ height: "500px" }}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                        question.inputFormat,
                                                      )
                                                    }
                                                    placeholder="test"
                                                    maxLength={
                                                      question.maxLength ||
                                                      20000
                                                    }
                                                  ></textarea>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "datetime" && (
                                              <div className="form-group">
                                                <DateTimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy hh:mm a"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "date" && (
                                              <div className="form-group">
                                                <DatePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "time" && (
                                              <div className="form-group">
                                                <TimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(time) =>
                                                    handleChange(
                                                      question.id,
                                                      time,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "dropdown" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <div className="form-control-select">
                                                    <select
                                                      className={`form-control form-control-lg`}
                                                      onChange={(e) =>
                                                        handleChange(
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                    >
                                                      <option value="">
                                                        Select an option
                                                      </option>
                                                      {question.options.map(
                                                        (option, index) => (
                                                          <option
                                                            key={index}
                                                            value={option}
                                                          >
                                                            {option}
                                                          </option>
                                                        ),
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "checkbox" && (
                                              <>
                                                <div className="mt-2 prettyprint ">
                                                  <div className="row">
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <div
                                                          className="col-md-6 mb-1"
                                                          key={`options_${index}`}
                                                        >
                                                          <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                            <input
                                                              type="checkbox"
                                                              className="custom-control-input vdrSelected"
                                                              id={`question_checkbox_${question.id}_${index}`}
                                                              checked={
                                                                formState[
                                                                  question.id
                                                                ]?.includes(
                                                                  option,
                                                                ) || false
                                                              }
                                                              onChange={(e) =>
                                                                handleCheckboxChange(
                                                                  question.id,
                                                                  option,
                                                                  e.target
                                                                    .checked,
                                                                )
                                                              }
                                                            />
                                                            <label
                                                              className="custom-control-label"
                                                              htmlFor={`question_checkbox_${question.id}_${index}`}
                                                            >
                                                              {option}
                                                            </label>
                                                          </div>
                                                          {formErrors[
                                                            question.id
                                                          ] && (
                                                            <FormHelperText
                                                              error
                                                            >
                                                              {
                                                                formErrors[
                                                                  question.id
                                                                ]
                                                              }
                                                            </FormHelperText>
                                                          )}
                                                        </div>
                                                      ),
                                                    )}
                                                  </div>
                                                </div>
                                              </>
                                            )}

                                            {question.answerType ===
                                              "radio" && (
                                              <div className="form-pm-group">
                                                <ul className="buysell-pm-list">
                                                  {question.options.map(
                                                    (option, index) => (
                                                      <li
                                                        className="buysell-pm-item"
                                                        key={index}
                                                      >
                                                        <input
                                                          className="buysell-pm-control"
                                                          type="radio"
                                                          name={`radio_${question.id}`}
                                                          id={`radio_${question.id}_${index}`}
                                                          onChange={(e) =>
                                                            handleChange(
                                                              question.id,
                                                              option,
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          className="buysell-pm-label"
                                                          htmlFor={`radio_${question.id}_${index}`}
                                                        >
                                                          <span className="pm-name">
                                                            {option}
                                                          </span>
                                                          <span className="pm-icon">
                                                            {/*<em className="icon ni ni-question"></em>*/}
                                                          </span>
                                                        </label>
                                                      </li>
                                                    ),
                                                  )}
                                                </ul>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "image_input" && (
                                              <div className="form-group">
                                                <div
                                                  className="form-control-group"
                                                  id="fileContainer"
                                                >
                                                  <input
                                                    type="file"
                                                    id={`add_picture_${question.id}`}
                                                    className="file-block"
                                                    name="add_picture"
                                                    accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                    onChange={(e) =>
                                                      handleFileChange(
                                                        question.id,
                                                        e,
                                                      )
                                                    }
                                                  />
                                                  {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                  {formState[question.id] && (
                                                    <div className="uploaded-file-preview">
                                                      {formState[
                                                        question.id
                                                      ].match(
                                                        /\.(jpeg|jpg|png)$/i,
                                                      ) ? (
                                                        <>
                                                          <img
                                                            src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                              formState[
                                                                question.id
                                                              ]
                                                            }`}
                                                            alt="Uploaded preview"
                                                            style={{
                                                              maxWidth: "100px",
                                                            }}
                                                          />
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </>
                                                      ) : (
                                                        <p>
                                                          {formState[
                                                            question.id
                                                          ]
                                                            .split("/")
                                                            .pop()}
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </p> // Display file name for non-images
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* CAPTCHA Section for single-step/ungrouped forms */}
                            {shouldShowCaptcha && (
                              <div
                                className="captcha-section"
                                style={{
                                  marginTop: "20px",
                                  marginBottom: "10px",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <ReCAPTCHA
                                  ref={captchaRef}
                                  sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                  onChange={handleCaptchaChange}
                                  onExpired={handleCaptchaExpired}
                                />
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "20px",
                              }}
                            >
                              {allowSkip === 1 &&
                                isOnboarding &&
                                isFilled !== 1 &&
                                isSkipped !== 1 && (
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={onSkipStep}
                                    style={{
                                      marginRight: "10px",
                                    }}
                                    className="skip-button-mobile"
                                  >
                                    <em className="icon ni ni-forward"></em>{" "}
                                    Skip This Step
                                  </Button>
                                )}
                              {(isFilled === 1 || isSkipped === 1) && (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={onNextStep}
                                  style={{
                                    marginRight: "10px",
                                  }}
                                  className="next-button-mobile"
                                >
                                  <em className="icon ni ni-forward"></em> Next
                                  Step
                                </Button>
                              )}
                              {allow_submit === 1 && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleSubmit}
                                  style={{ marginLeft: "10px" }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )
            )}
          </>
        ) : viewFrom == "_disabled_agent-not-logged-in" ? (
          <>
            {currentGroup ? (
              <>
                <div className="nk-block nk-block-lg">
                  <div className="card">
                    <form
                      autoComplete="off"
                      className="nk-stepper stepper-init is-alter nk-stepper-s1"
                      action="#"
                      id="stepper-create-project"
                      data-step-current="2"
                      noValidate
                      style={{ display: "block" }}
                    >
                      <div className="row g-0 col-sep col-sep-md col-sep-xl">
                        <div className="col-md-3 col-xl-3">
                          <div className="card-inner">
                            <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                              {groups.map((group, index) => (
                                <li
                                  key={group.id}
                                  className={
                                    currentStep === index
                                      ? "current"
                                      : currentStep > index
                                        ? "done"
                                        : ""
                                  }
                                  style={{ marginBottom: "0.725rem" }}
                                >
                                  <div
                                    className="step-item"
                                    data-group-number={index + 1}
                                  >
                                    <div className="step-text">
                                      <div className="lead-text">
                                        {group.group_title}
                                        {group.group_instructions &&
                                        group.group_instructions !== "" ? (
                                          <div className="custom-tooltip-wrapper">
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                fontSize: "16px",
                                              }}
                                            ></em>

                                            <div className="custom-tooltip-box">
                                              {group.group_instructions
                                                .split("\n")
                                                .filter(
                                                  (line) => line.trim() !== "",
                                                )
                                                .map((line, index) => (
                                                  <p>{line}</p>
                                                ))}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div
                          className="col-md-9 col-xl-9 p-0"
                          style={{ borderLeft: "1px solid #e5e9f2" }}
                        >
                          <div className="card-inner p-0">
                            <div className="nk-stepper-content">
                              <div className="nk-stepper-steps stepper-steps">
                                <div className="nk-kycfm">
                                  <div
                                    className="nk-kycfm-head"
                                    style={{ background: "#fff" }}
                                  >
                                    <div className="nk-kycfm-title">
                                      <h5 className="title">
                                        {formTitle || "Untitled Form"}
                                      </h5>
                                      {currentStep === 0 && (
                                        <p className="sub-title">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: formDescription,
                                            }}
                                          />
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="nk-kycfm-content">
                                    {responseMessage && (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: responseMessage,
                                        }}
                                      ></div>
                                    )}
                                    {errorMessage && (
                                      <div className="alert alert-danger alert-icon mb-3">
                                        <em className="icon ni ni-cross-circle"></em>{" "}
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: errorMessage,
                                          }}
                                        ></div>
                                      </div>
                                    )}
                                    <div className="mb-3">
                                      <h5 className="title">
                                        {currentGroup.group_title}
                                      </h5>
                                      <p
                                        className="sub-title"
                                        dangerouslySetInnerHTML={{
                                          __html: currentGroup.group_desc
                                            ? currentGroup.group_desc.replace(
                                                /\n/g,
                                                "<br />",
                                              )
                                            : "",
                                        }}
                                      ></p>
                                    </div>
                                    {/* Assistant Name Input - Always show at the top */}
                                    {allow_agent_name ? (
                                      <>
                                        <div
                                          className="question-container d-flex justify-content-between"
                                          style={{
                                            gap: "10px",
                                            marginBottom: "10px",
                                            paddingBottom: "20px",
                                          }}
                                        >
                                          {/* Assistant Name Input */}
                                          <div
                                            className="form-group question-text mb-0"
                                            style={{ flex: 1 }}
                                          >
                                            <label
                                              className="form-label"
                                              style={{
                                                fontSize: "0.875rem",
                                                fontWeight: "500",
                                              }}
                                            >
                                              Assistant Name{" "}
                                              <sup className="text-danger">
                                                *
                                              </sup>
                                              <div
                                                className="custom-tooltip-wrapper"
                                                style={{
                                                  display: "inline-block",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                  }}
                                                ></em>
                                                <div className="custom-tooltip-box">
                                                  This name will be used
                                                  throughout conversation
                                                  prompts and messages. It
                                                  replaces {"{name}"}{" "}
                                                  placeholders in your system
                                                  prompts and first message.
                                                </div>
                                              </div>
                                            </label>

                                            <input
                                              className="form-control form-control-lg"
                                              onChange={(e) =>
                                                handleAssistantNameChange(
                                                  e.target.value,
                                                )
                                              }
                                              value={
                                                formState[
                                                  "__assistant_name__"
                                                ] || ""
                                              }
                                              type="text"
                                              maxLength={50}
                                              placeholder=""
                                              required
                                            />
                                          </div>

                                          {/* User Form Dropdown */}
                                          <div
                                            className="form-group question-text mb-0"
                                            style={{ flex: 1 }}
                                          >
                                            <label
                                              className="form-label"
                                              style={{
                                                fontSize: "0.875rem",
                                                fontWeight: "500",
                                              }}
                                            >
                                              Lead Entry Form
                                              <div
                                                className="custom-tooltip-wrapper"
                                                style={{
                                                  display: "inline-block",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                <em
                                                  className="icon ni ni-info"
                                                  style={{
                                                    color: "#6576ff",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                  }}
                                                ></em>
                                                <div className="custom-tooltip-box">
                                                  Choose whether to enable a
                                                  user facing form for this
                                                  assistant.
                                                </div>
                                              </div>
                                            </label>

                                            <div className="form-control-wrap">
                                              <div className="form-control-select">
                                                <select
                                                  className="form-control form-control-lg"
                                                  value={
                                                    formState[
                                                      "__user_form__"
                                                    ] || "No"
                                                  }
                                                  onChange={(e) =>
                                                    handleUserFormChange(
                                                      e.target.value,
                                                    )
                                                  }
                                                >
                                                  <option value="">
                                                    Select an option
                                                  </option>
                                                  <option value="Yes">
                                                    Yes
                                                  </option>
                                                  <option value="No">No</option>
                                                </select>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : null}

                                    <div className="row g-gs">
                                      {/*currentGroup.questions.map((questionId) => {
                          const question = formData[0].questions.find(
                            (q) => q.id === questionId
                          );
                          if (!question) {
                            return null;
                          }*/}

                                      {currentGroup.questions
                                        .map((questionId) => {
                                          // Find the corresponding question from formData
                                          const question =
                                            formData[0].questions.find(
                                              (q) => q.id === questionId,
                                            );
                                          return question;
                                        })
                                        .filter(Boolean) // Remove any undefined values if a question is not found
                                        .sort(
                                          (a, b) =>
                                            a.sequenceNumber - b.sequenceNumber,
                                        ) // Sort by sequence number
                                        .map((question) => {
                                          const value =
                                            formState[question.id] || "";

                                          return (
                                            <div
                                              key={question.id}
                                              className={
                                                question.answerType ===
                                                  "label" ||
                                                question.answerType ===
                                                  "text_only"
                                                  ? "question-container col-sm-12"
                                                  : "question-container col-sm-6"
                                              }
                                            >
                                              <div
                                                className="form-group question-text mb-0"
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                {question.answerType ===
                                                "label" ? (
                                                  <label
                                                    className="form-label"
                                                    style={{
                                                      fontSize: "1.275rem",
                                                    }}
                                                  >
                                                    {question.questionText}{" "}
                                                    {question.required && (
                                                      <sup className="text-danger">
                                                        *
                                                      </sup>
                                                    )}
                                                    {question.tooltip &&
                                                      question.tooltip.trim() !==
                                                        "" && (
                                                        <div className="custom-tooltip-wrapper">
                                                          <em
                                                            className="icon ni ni-info"
                                                            style={{
                                                              color: "#6576ff",
                                                              marginLeft: "5px",
                                                              cursor: "pointer",
                                                              fontSize: "16px",
                                                            }}
                                                          ></em>

                                                          <div
                                                            className="custom-tooltip-box"
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                question.tooltip,
                                                            }}
                                                          ></div>
                                                        </div>
                                                      )}
                                                  </label>
                                                ) : (
                                                  <>
                                                    {question.answerType !==
                                                    "text_only" ? (
                                                      <label className="form-label">
                                                        {question.questionText}{" "}
                                                        {question.required && (
                                                          <sup className="text-danger">
                                                            *
                                                          </sup>
                                                        )}
                                                        {question.tooltip &&
                                                          question.tooltip.trim() !==
                                                            "" && (
                                                            <div className="custom-tooltip-wrapper">
                                                              <em
                                                                className="icon ni ni-info"
                                                                style={{
                                                                  color:
                                                                    "#6576ff",
                                                                  marginLeft:
                                                                    "5px",
                                                                  cursor:
                                                                    "pointer",
                                                                  fontSize:
                                                                    "16px",
                                                                }}
                                                              ></em>

                                                              <div
                                                                className="custom-tooltip-box"
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    question.tooltip,
                                                                }}
                                                              ></div>
                                                            </div>
                                                          )}
                                                      </label>
                                                    ) : null}
                                                  </>
                                                )}
                                                {question.answerType ===
                                                "text_only" ? (
                                                  <>
                                                    {question.textType ===
                                                    "p" ? (
                                                      <p>
                                                        {question.textOnly}{" "}
                                                      </p>
                                                    ) : question.textType ===
                                                      "oli" ? (
                                                      <ol
                                                        style={{
                                                          paddingLeft: "20px",
                                                          marginLeft: "20px",
                                                        }}
                                                      >
                                                        {question.textOnly
                                                          .split("\n")
                                                          .filter(
                                                            (line) =>
                                                              line.trim() !==
                                                              "",
                                                          )
                                                          .map(
                                                            (line, index) => (
                                                              <li
                                                                key={index}
                                                                style={{
                                                                  listStyleType:
                                                                    "decimal",
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                {line}
                                                              </li>
                                                            ),
                                                          )}
                                                      </ol>
                                                    ) : question.textType ===
                                                      "sli" ? (
                                                      <ul
                                                        style={{
                                                          paddingLeft: "20px",
                                                          marginLeft: "20px",
                                                        }}
                                                      >
                                                        {question.textOnly
                                                          .split("\n")
                                                          .filter(
                                                            (line) =>
                                                              line.trim() !==
                                                              "",
                                                          )
                                                          .map(
                                                            (line, index) => (
                                                              <li
                                                                key={index}
                                                                style={{
                                                                  listStyleType:
                                                                    "disc",
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                {line}
                                                              </li>
                                                            ),
                                                          )}
                                                      </ul>
                                                    ) : (
                                                      <p>
                                                        {question.textOnly}{" "}
                                                      </p>
                                                    )}
                                                  </>
                                                ) : null}
                                                <div
                                                  style={{
                                                    position: "relative",
                                                    display: "flex",
                                                    justifyContent: "flex-end", // 👈 pushes buttons to right
                                                    gap: "8px",
                                                  }}
                                                >
                                                  {question.imageUrl && (
                                                    <a
                                                      onClick={() =>
                                                        downloadPdf(
                                                          question.imageUrl,
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <span className="badge badge-outline-primary">
                                                        <em className="icon ni ni-download"></em>{" "}
                                                        Download File
                                                      </span>
                                                    </a>
                                                  )}

                                                  {chatgptEnabled &&
                                                    question.allowAI === 1 && (
                                                      <a
                                                        onClick={() =>
                                                          openGenerateModal(
                                                            question,
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        <span className="badge badge-outline-primary">
                                                          <em className="icon ni ni-spark"></em>{" "}
                                                          Generate
                                                        </span>
                                                      </a>
                                                    )}

                                                  {/* Shared Modal */}
                                                  {showGenerateModal &&
                                                    currentAIQuestion?.id ===
                                                      question.id && (
                                                      <div
                                                        ref={modalRef}
                                                        style={{
                                                          position: "absolute",
                                                          bottom: "100%",
                                                          right: "0",
                                                          width: "420px",
                                                          background: "#fff",
                                                          color: "#111827",
                                                          borderRadius: "10px",
                                                          boxShadow:
                                                            "0 6px 20px rgba(0,0,0,0.15)",
                                                          padding: "18px",
                                                          zIndex: 2000,
                                                          marginBottom: "10px",
                                                        }}
                                                      >
                                                        <h6
                                                          style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginBottom:
                                                              "12px",
                                                          }}
                                                        >
                                                          Edit Prompt
                                                        </h6>

                                                        {modalError && (
                                                          <div
                                                            style={{
                                                              backgroundColor:
                                                                "#fee",
                                                              border:
                                                                "1px solid #fcc",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "10px 12px",
                                                              marginBottom:
                                                                "12px",
                                                              fontSize: "13px",
                                                              color: "#c33",
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              gap: "8px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                flexShrink: 0,
                                                              }}
                                                            >
                                                              ⚠️
                                                            </span>
                                                            <span>
                                                              {modalError}
                                                            </span>
                                                          </div>
                                                        )}

                                                        <input
                                                          type="text"
                                                          placeholder={
                                                            isFollowUp
                                                              ? "Add follow-ups or refinements..."
                                                              : isGenerated
                                                                ? "Add follow-ups or refinements..."
                                                                : "Describe how you'd like to edit the prompt"
                                                          }
                                                          style={{
                                                            width: "100%",
                                                            padding:
                                                              "10px 12px",
                                                            border:
                                                              "1px solid #d1d5db",
                                                            borderRadius: "8px",
                                                            marginBottom:
                                                              "14px",
                                                            fontSize: "14px",
                                                            boxSizing:
                                                              "border-box",
                                                          }}
                                                          value={generatedText}
                                                          onChange={
                                                            handleInputChange
                                                          }
                                                          disabled={
                                                            isGenerating
                                                          }
                                                        />

                                                        <div
                                                          style={{
                                                            display: "grid",
                                                            gridTemplateColumns:
                                                              "1fr 1fr",
                                                            gap: "10px",
                                                            width: "100%",
                                                          }}
                                                        >
                                                          {!isGenerated ? (
                                                            <>
                                                              <button
                                                                type="button"
                                                                onClick={
                                                                  closeGenerateModal
                                                                }
                                                                style={{
                                                                  background:
                                                                    "#f3f4f6",
                                                                  color:
                                                                    "#374151",
                                                                  border:
                                                                    "1px solid #e5e7eb",
                                                                  borderRadius:
                                                                    "6px",
                                                                  padding:
                                                                    "8px 16px",
                                                                  cursor:
                                                                    "pointer",
                                                                  fontWeight:
                                                                    "500",
                                                                  fontSize:
                                                                    "14px",
                                                                  outline:
                                                                    "none",
                                                                }}
                                                              >
                                                                Cancel
                                                              </button>
                                                              <button
                                                                type="button"
                                                                onClick={
                                                                  handleGenerate
                                                                }
                                                                disabled={
                                                                  isGenerating
                                                                }
                                                                style={{
                                                                  background:
                                                                    "#6576ff",
                                                                  color:
                                                                    "white",
                                                                  border:
                                                                    "none",
                                                                  borderRadius:
                                                                    "6px",
                                                                  padding:
                                                                    "8px 16px",
                                                                  cursor:
                                                                    isGenerating
                                                                      ? "not-allowed"
                                                                      : "pointer",
                                                                  fontWeight:
                                                                    "600",
                                                                  opacity:
                                                                    isGenerating
                                                                      ? 0.6
                                                                      : 1,
                                                                  fontSize:
                                                                    "14px",
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  gap: "8px",
                                                                  outline:
                                                                    "none",
                                                                }}
                                                              >
                                                                {isGenerating ? (
                                                                  "Generating…"
                                                                ) : (
                                                                  <>
                                                                    Submit Edit{" "}
                                                                    <em
                                                                      className="icon ni ni-send-alt"
                                                                      style={{
                                                                        fontSize:
                                                                          "16px",
                                                                      }}
                                                                    ></em>
                                                                  </>
                                                                )}
                                                              </button>
                                                            </>
                                                          ) : isFollowUp ? (
                                                            <>
                                                              <button
                                                                type="button"
                                                                onClick={() =>
                                                                  handleDiscardGenerated(
                                                                    question.id,
                                                                  )
                                                                }
                                                                style={{
                                                                  background:
                                                                    "#f3f4f6",
                                                                  color:
                                                                    "#374151",
                                                                  border:
                                                                    "1px solid #e5e7eb",
                                                                  borderRadius:
                                                                    "6px",
                                                                  padding:
                                                                    "8px 16px",
                                                                  cursor:
                                                                    "pointer",
                                                                  fontWeight:
                                                                    "500",
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  gap: "8px",
                                                                  fontSize:
                                                                    "14px",
                                                                  outline:
                                                                    "none",
                                                                }}
                                                              >
                                                                <em
                                                                  className="icon ni ni-cross"
                                                                  style={{
                                                                    fontSize:
                                                                      "16px",
                                                                  }}
                                                                ></em>{" "}
                                                                Discard Changes
                                                              </button>
                                                              <button
                                                                type="button"
                                                                onClick={
                                                                  handleGenerate
                                                                }
                                                                disabled={
                                                                  isGenerating
                                                                }
                                                                style={{
                                                                  background:
                                                                    "#6576ff",
                                                                  color:
                                                                    "white",
                                                                  border:
                                                                    "none",
                                                                  borderRadius:
                                                                    "6px",
                                                                  padding:
                                                                    "8px 16px",
                                                                  cursor:
                                                                    isGenerating
                                                                      ? "not-allowed"
                                                                      : "pointer",
                                                                  fontWeight:
                                                                    "600",
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  gap: "8px",
                                                                  opacity:
                                                                    isGenerating
                                                                      ? 0.6
                                                                      : 1,
                                                                  fontSize:
                                                                    "14px",
                                                                  outline:
                                                                    "none",
                                                                }}
                                                              >
                                                                {isGenerating ? (
                                                                  "Sending..."
                                                                ) : (
                                                                  <>
                                                                    Send
                                                                    Follow-up{" "}
                                                                    <em
                                                                      className="icon ni ni-send-alt"
                                                                      style={{
                                                                        fontSize:
                                                                          "16px",
                                                                      }}
                                                                    ></em>
                                                                  </>
                                                                )}
                                                              </button>
                                                            </>
                                                          ) : (
                                                            <>
                                                              <button
                                                                type="button"
                                                                onClick={() =>
                                                                  handleDiscardGenerated(
                                                                    question.id,
                                                                  )
                                                                }
                                                                style={{
                                                                  background:
                                                                    "#f3f4f6",
                                                                  color:
                                                                    "#374151",
                                                                  border:
                                                                    "1px solid #e5e7eb",
                                                                  borderRadius:
                                                                    "6px",
                                                                  padding:
                                                                    "8px 16px",
                                                                  cursor:
                                                                    "pointer",
                                                                  fontWeight:
                                                                    "500",
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  gap: "8px",
                                                                  fontSize:
                                                                    "14px",
                                                                  outline:
                                                                    "none",
                                                                }}
                                                              >
                                                                <em
                                                                  className="icon ni ni-cross"
                                                                  style={{
                                                                    fontSize:
                                                                      "16px",
                                                                  }}
                                                                ></em>{" "}
                                                                Discard Changes
                                                              </button>
                                                              <button
                                                                type="button"
                                                                onClick={() => {
                                                                  handleUseGeneratedAnswer(
                                                                    question.id,
                                                                  );
                                                                }}
                                                                style={{
                                                                  background:
                                                                    "#6576ff",
                                                                  color:
                                                                    "white",
                                                                  border:
                                                                    "none",
                                                                  borderRadius:
                                                                    "6px",
                                                                  padding:
                                                                    "8px 16px",
                                                                  cursor:
                                                                    "pointer",
                                                                  fontWeight:
                                                                    "600",
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  gap: "8px",
                                                                  fontSize:
                                                                    "14px",
                                                                  outline:
                                                                    "none",
                                                                }}
                                                              >
                                                                Accept Changes{" "}
                                                                <em
                                                                  className="icon ni ni-check"
                                                                  style={{
                                                                    fontSize:
                                                                      "16px",
                                                                  }}
                                                                ></em>
                                                              </button>
                                                            </>
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}
                                                </div>
                                              </div>

                                              {question.answerType ===
                                                "input" && (
                                                <div className="form-group mb-0">
                                                  <div
                                                    className="form-control-wrap address_cont"
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    {/* Only show regular input when NOT showing diff */}
                                                    {!diffOutput ||
                                                    currentAIQuestion?.id !==
                                                      question.id ? (
                                                      <>
                                                        {/* Phone validation */}
                                                        {question.validationValue ===
                                                        "validation_phone" ? (
                                                          <ReactPhoneInput
                                                            country="us"
                                                            specialLabel=""
                                                            value={formState[question.id] || ""}
                                                            onChange={(v) => handleChangePhone(question.id, v)}
                                                            disabled={isGenerating && currentAIQuestion?.id === question.id}
                                                            inputStyle={{
                                                              width: "100%",
                                                              opacity: isGenerating && currentAIQuestion?.id === question.id ? 0.4 : 1,
                                                              ...(formErrors[question.id] ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" } : {}),
                                                            }}
                                                            buttonStyle={formErrors[question.id] ? { borderColor: "#e85347" } : undefined}
                                                          />
                                                        ) : question.validationValue ===
                                                          "validation_fulladdress" ? (
                                                          <GooglePlacesAutocomplete
                                                            apiKey={
                                                              process.env
                                                                .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                                            }
                                                            selectProps={{
                                                              value: formState[
                                                                question.id
                                                              ]
                                                                ? {
                                                                    label:
                                                                      formState[
                                                                        question
                                                                          .id
                                                                      ],
                                                                    value:
                                                                      formState[
                                                                        question
                                                                          .id
                                                                      ],
                                                                  }
                                                                : null,
                                                              onChange: (
                                                                address,
                                                              ) =>
                                                                handleAddressSelect(
                                                                  question.id,
                                                                  address,
                                                                ),
                                                              placeholder:
                                                                Address
                                                                  ? null
                                                                  : "Enter your address...",
                                                              isDisabled:
                                                                isGenerating &&
                                                                currentAIQuestion?.id ===
                                                                  question.id,
                                                              styles: {
                                                                input: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  color:
                                                                    "black",
                                                                }),
                                                                option: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  color:
                                                                    "black",
                                                                }),
                                                                singleValue: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  color:
                                                                    "black",
                                                                }),
                                                                menu: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  zIndex: 9,
                                                                }),
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  opacity:
                                                                    isGenerating &&
                                                                    currentAIQuestion?.id ===
                                                                      question.id
                                                                      ? 0.4
                                                                      : 1,
                                                                }),
                                                              },
                                                            }}
                                                          />
                                                        ) : question.validationValue ===
                                                          "validation_country" ? (
                                                          <Select
                                                            id="_country"
                                                            className="customCountrySelect-addClient"
                                                            name="_country"
                                                            label="Country"
                                                            options={
                                                              countryOptions
                                                            }
                                                            value={country}
                                                            onChange={(
                                                              selectedOption,
                                                            ) =>
                                                              handleChangeCountry(
                                                                question.id,
                                                                selectedOption,
                                                              )
                                                            }
                                                            isDisabled={
                                                              isGenerating &&
                                                              currentAIQuestion?.id ===
                                                                question.id
                                                            }
                                                            styles={{
                                                              control: (
                                                                provided,
                                                              ) => ({
                                                                ...provided,
                                                                minHeight:
                                                                  "45px",
                                                                opacity:
                                                                  isGenerating &&
                                                                  currentAIQuestion?.id ===
                                                                    question.id
                                                                    ? 0.4
                                                                    : 1,
                                                              }),
                                                              menu: (
                                                                provided,
                                                                state,
                                                              ) => ({
                                                                ...provided,
                                                                zIndex: 9,
                                                              }),
                                                            }}
                                                            placeholder="Select Country"
                                                          />
                                                        ) : (
                                                          <input
                                                            className="form-control form-control-lg"
                                                            onChange={(e) =>
                                                              handleChange(
                                                                question.id,
                                                                e.target.value,
                                                                question.inputFormat,
                                                              )
                                                            }
                                                            value={
                                                              formState[
                                                                question.id
                                                              ] || ""
                                                            }
                                                            type="text"
                                                            maxLength={
                                                              question.maxLength ||
                                                              500
                                                            }
                                                            style={{
                                                              paddingRight:
                                                                "90px",
                                                              opacity:
                                                                isGenerating &&
                                                                currentAIQuestion?.id ===
                                                                  question.id
                                                                  ? 0.4
                                                                  : 1,
                                                              transition:
                                                                "opacity 0.3s ease",
                                                            }}
                                                            readOnly={
                                                              isGenerating &&
                                                              currentAIQuestion?.id ===
                                                                question.id
                                                            }
                                                          />
                                                        )}
                                                      </>
                                                    ) : null}

                                                    {/* 🟩 Diff Preview for Input */}
                                                    {diffOutput &&
                                                      currentAIQuestion?.id ===
                                                        question.id && (
                                                        <div
                                                          className="diff-preview"
                                                          style={{
                                                            backgroundColor:
                                                              "#f9fafb",
                                                            border: isGenerating
                                                              ? "2px solid #6576ff"
                                                              : "1px solid #e5e7eb",
                                                            borderRadius: "8px",
                                                            padding:
                                                              "12px 16px",
                                                            fontSize: "15px",
                                                            lineHeight: "1.6",
                                                            color: "#111827",
                                                            minHeight: "45px",
                                                            display: "block",
                                                            boxShadow:
                                                              isGenerating
                                                                ? "0 0 0 3px rgba(101, 118, 255, 0.15)"
                                                                : "none",
                                                            transition:
                                                              "all 0.3s ease",
                                                            wordWrap:
                                                              "break-word",
                                                            whiteSpace:
                                                              "normal",
                                                            overflowWrap:
                                                              "break-word",
                                                          }}
                                                          dangerouslySetInnerHTML={{
                                                            __html: diffOutput,
                                                          }}
                                                        />
                                                      )}

                                                    {/* 🌀 Loader Overlay - Shows on top during generation */}
                                                    {isGenerating &&
                                                      currentAIQuestion?.id ===
                                                        question.id && (
                                                        <div
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            inset: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 0.85)",
                                                            backdropFilter:
                                                              "blur(2px)",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            alignItems:
                                                              "center",
                                                            borderRadius: "8px",
                                                            zIndex: 10,
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "12px",
                                                              padding:
                                                                "8px 16px",
                                                              background:
                                                                "#fff",
                                                              borderRadius:
                                                                "8px",
                                                              boxShadow:
                                                                "0 2px 8px rgba(0,0,0,0.1)",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                width: "32px",
                                                                height: "32px",
                                                                borderRadius:
                                                                  "50%",
                                                                background:
                                                                  "linear-gradient(135deg, #6576ff 0%, #8b9cff 100%)",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                                animation:
                                                                  "pulse-scale 2s ease-in-out infinite",
                                                              }}
                                                            >
                                                              <em
                                                                className="icon ni ni-spark-fill"
                                                                style={{
                                                                  fontSize:
                                                                    "16px",
                                                                  color: "#fff",
                                                                  animation:
                                                                    "spin 2s linear infinite",
                                                                }}
                                                              />
                                                            </div>
                                                            <span
                                                              style={{
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "13px",
                                                                color:
                                                                  "#111827",
                                                              }}
                                                            >
                                                              Generating...
                                                            </span>
                                                          </div>
                                                        </div>
                                                      )}
                                                  </div>

                                                  <div
                                                    className="helper-text"
                                                    style={{ marginTop: "6px" }}
                                                  >
                                                    {question.maxLength && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Maximum length is{" "}
                                                        {question.maxLength}{" "}
                                                        characters.
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "number_only" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Only numbers are allowed
                                                        (e.g. 123456).
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "alphabet_only" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Only alphabets are
                                                        allowed (e.g. JohnDoe).
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "alphanumeric" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Only alphanumeric
                                                        characters are allowed
                                                        (e.g. John123).
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "open" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        You can enter any
                                                        characters.
                                                        <br />
                                                      </small>
                                                    )}
                                                  </div>
                                                  {/* Display form errors if present */}
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "signature" && (
                                                <>
                                                  <ul className="nav nav-tabs">
                                                    <li className="nav-item">
                                                      <a
                                                        className={
                                                          signatureType ===
                                                            "draw" ||
                                                          signatureType === ""
                                                            ? "nav-link active"
                                                            : "nav-link"
                                                        }
                                                        data-toggle="tab"
                                                        onClick={() =>
                                                          setSignatureType(
                                                            "draw",
                                                          )
                                                        }
                                                        href="#tabItem6"
                                                      >
                                                        <em className="icon ni ni-edit-alt"></em>
                                                        <span>Draw</span>
                                                      </a>
                                                    </li>
                                                    <li className="nav-item">
                                                      <a
                                                        className={
                                                          signatureType ===
                                                          "choose"
                                                            ? "nav-link active"
                                                            : "nav-link"
                                                        }
                                                        data-toggle="tab"
                                                        onClick={() =>
                                                          setSignatureType(
                                                            "choose",
                                                          )
                                                        }
                                                        href="#tabItem5"
                                                      >
                                                        <em className="icon ni ni-list-check"></em>
                                                        <span>Choose</span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                  <div className="tab-content">
                                                    <div
                                                      className={
                                                        signatureType ===
                                                        "choose"
                                                          ? "tab-pane active"
                                                          : "tab-pane"
                                                      }
                                                      id="tabItem5"
                                                    >
                                                      <div className="example-alert mb-4">
                                                        <div className="alert alert-light">
                                                          Pick a style for your
                                                          signature (Authorized
                                                          Person Name).
                                                        </div>
                                                      </div>
                                                      <div className="form-group mb-4">
                                                        <div className="form-control-wrap">
                                                          <input
                                                            className={`form-control form-control-lg`}
                                                            onChange={(e) =>
                                                              handleChangeSignature(
                                                                question.id,
                                                                e.target.value,
                                                              )
                                                            }
                                                            onInput={(e) => {
                                                              e.target.value =
                                                                e.target.value.replace(
                                                                  /[^a-zA-Z0-9 ]/gi,
                                                                  "",
                                                                );
                                                            }}
                                                            value={
                                                              signatureText
                                                            }
                                                            type="text"
                                                            maxLength={100}
                                                            placeholder="Authorized Person Name"
                                                          />
                                                        </div>
                                                        {formErrors[
                                                          question.id
                                                        ] && (
                                                          <FormHelperText error>
                                                            {
                                                              formErrors[
                                                                question.id
                                                              ]
                                                            }
                                                          </FormHelperText>
                                                        )}
                                                      </div>

                                                      <h6 className="title">
                                                        Choose Style
                                                      </h6>

                                                      <ul className="cc-pay-method">
                                                        <li className="cc-pay-dd dropdown">
                                                          <a
                                                            href="#"
                                                            className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator"
                                                            data-toggle="dropdown"
                                                          >
                                                            <span
                                                              style={{
                                                                fontFamily:
                                                                  signatureClass,
                                                              }}
                                                            >
                                                              {signatureText ||
                                                                "Your Signature"}
                                                            </span>
                                                          </a>
                                                          <div className="dropdown-menu dropdown-menu-auto">
                                                            <ul className="link-list-plain">
                                                              {cursiveFonts.map(
                                                                (
                                                                  font,
                                                                  index,
                                                                ) => (
                                                                  <li
                                                                    key={
                                                                      index
                                                                    }
                                                                  >
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        setSignatureClass(
                                                                          font.value,
                                                                        )
                                                                      }
                                                                      className="cc-pay-item"
                                                                    >
                                                                      <span className="cc-pay-item-name">
                                                                        <span
                                                                          className="cc-pay-item-method"
                                                                          style={{
                                                                            fontFamily:
                                                                              font.value,
                                                                          }}
                                                                        >
                                                                          {signatureText !==
                                                                          ""
                                                                            ? signatureText
                                                                            : font.name}
                                                                        </span>
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ),
                                                              )}
                                                            </ul>
                                                          </div>
                                                        </li>
                                                      </ul>
                                                      <div
                                                        className="signature-preview mt-3"
                                                        id={`styled-text-container${question.id}`}
                                                        style={{
                                                          fontFamily:
                                                            signatureClass,
                                                          fontSize: "40px",
                                                          width: "480px",
                                                          height: "80px",
                                                          background:
                                                            "trasnparent",
                                                          backgroundColor:
                                                            "transparent",
                                                          border: "none",
                                                          lineHeight:
                                                            "80px",
                                                          color: "#000",
                                                        }}
                                                      >
                                                        {signatureText ||
                                                          "Your Signature"}
                                                      </div>

                                                      <div
                                                        className="col-sm-12 mt-4 pl-0"
                                                        style={{
                                                          clear: "both",
                                                        }}
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-primary"
                                                          style={{
                                                            margin:
                                                              "13px 0px 12px 0px",
                                                          }}
                                                          onClick={() =>
                                                            saveChooseImage(
                                                              question.id,
                                                            )
                                                          }
                                                        >
                                                          <em className="icon ni ni-folder-check"></em>{" "}
                                                          <span>
                                                            Save Signature
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={
                                                        signatureType ===
                                                          "draw" ||
                                                        signatureType === ""
                                                          ? "tab-pane active"
                                                          : "tab-pane"
                                                      }
                                                      id="tabItem6"
                                                    >
                                                      <div className="row">
                                                        <div className="col-sm-12">
                                                          <div className="example-alert mb-4">
                                                            <div className="alert alert-light">
                                                              Please Save the
                                                              signature to
                                                              proceed.
                                                            </div>
                                                          </div>
                                                          {formState[
                                                            question.id
                                                          ] && (
                                                            <div className="uploaded-file-preview">
                                                              <img
                                                                src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                                  formState[
                                                                    question.id
                                                                  ]
                                                                }`}
                                                                alt="Uploaded Signature"
                                                                style={{
                                                                  maxWidth:
                                                                    "200px",
                                                                }}
                                                              />
                                                            </div>
                                                          )}
                                                          <div
                                                            id={`divSig${question.id}`}
                                                            style={{
                                                              display: "none",
                                                            }}
                                                          >
                                                            <div className="mb-4">
                                                              <img
                                                                src=""
                                                                className="clsimgSig"
                                                                height="100"
                                                                width="200"
                                                                onerror="this.style.display='none'"
                                                              />
                                                            </div>
                                                          </div>
                                                          <div>
                                                            <strong>
                                                              Signature
                                                            </strong>
                                                          </div>
                                                        </div>

                                                        <div className="col-sm-12">
                                                          <SignatureCanvas
                                                            clearOnResize={true}
                                                            canvasProps={{
                                                              className:
                                                                styles.sigPad,
                                                            }}
                                                            velocityFilterWeight={
                                                              0.7
                                                            }
                                                            throttle={50}
                                                            ref={(ref) =>
                                                              (sigPadRefs.current[
                                                                question.id
                                                              ] = ref)
                                                            }
                                                          />
                                                        </div>
                                                        <div className="col-sm-12 mt-4">
                                                          <button
                                                            className="btn btn-warning"
                                                            style={{
                                                              margin:
                                                                "13px 0px 12px 0px",
                                                            }}
                                                            onClick={() =>
                                                              clearSignature(
                                                                question.id,
                                                              )
                                                            }
                                                            type="button"
                                                          >
                                                            <em className="icon ni ni-delete"></em>{" "}
                                                            <span>Clear</span>
                                                          </button>
                                                          {/*<button
                                            className="btn btn-success"
                                            style={{
                                              margin: "13px 0px 12px 10px",
                                            }}
                                            type="button"
                                            onClick={() =>
                                              previewSignature(question.id)
                                            }
                                          >
                                            <em className="icon ni ni-eye"></em>{" "}
                                            <span>Preview</span>
                                          </button>*/}
                                                          <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            style={{
                                                              margin:
                                                                "13px 0px 12px 10px",
                                                            }}
                                                            onClick={() =>
                                                              saveSignature(
                                                                question.id,
                                                              )
                                                            }
                                                          >
                                                            <em className="icon ni ni-folder-check"></em>{" "}
                                                            <span>
                                                              Save Signature
                                                            </span>
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                              {question.answerType ===
                                                "fixed" && (
                                                <>
                                                  <div className="form-group mb-0">
                                                    <div className="form-control-wrap">
                                                      <input
                                                        className={`form-control form-control-lg`}
                                                        onChange={(e) =>
                                                          handleChangeFixed(
                                                            question.id,
                                                            question.answer,
                                                          )
                                                        }
                                                        value={question.answer}
                                                        type="text"
                                                        maxLength={255}
                                                      />
                                                    </div>
                                                    {formErrors[
                                                      question.id
                                                    ] && (
                                                      <FormHelperText error>
                                                        {
                                                          formErrors[
                                                            question.id
                                                          ]
                                                        }
                                                      </FormHelperText>
                                                    )}
                                                  </div>
                                                  <CopyToClipboard
                                                    text={question.answer}
                                                    onCopy={() =>
                                                      setCopied(true)
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <div className="form-note text-primary">
                                                      <strong>
                                                        Copy to Clipboard{" "}
                                                        {copied ? (
                                                          <span>
                                                            <em className="icon ni ni-done"></em>
                                                          </span>
                                                        ) : null}
                                                      </strong>
                                                    </div>
                                                  </CopyToClipboard>
                                                </>
                                              )}
                                              {question.answerType ===
                                                "label" && (
                                                <div className="form-group mb-0">
                                                  <h6></h6>
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "textarea" && (
                                                <div className="form-group">
                                                  <div
                                                    className="form-control-wrap"
                                                    style={{
                                                      display: "flex",
                                                      gap: "20px",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    {/* Textarea container - increased width */}
                                                    <div
                                                      style={{
                                                        flex: 3,
                                                        minWidth: "100%",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        {/* 🧠 Detect HTML or show textarea */}
                                                        {!diffOutput &&
                                                          (() => {
                                                            const rawValue =
                                                              formState[
                                                                question.id
                                                              ] ?? "";
                                                            const isHtml =
                                                              /<\/?[a-z][\s\S]*>/i.test(
                                                                rawValue.trim(),
                                                              );

                                                            if (isHtml) {
                                                              return (
                                                                <div
                                                                  ref={
                                                                    contentEditableRef
                                                                  }
                                                                  contentEditable={
                                                                    !isGenerating
                                                                  }
                                                                  suppressContentEditableWarning
                                                                  className="form-control form-control-lg"
                                                                  style={{
                                                                    height:
                                                                      "500px",
                                                                    backgroundColor:
                                                                      "#fff",
                                                                    borderRadius:
                                                                      "8px",
                                                                    border:
                                                                      "1px solid #e5e7eb",
                                                                    padding:
                                                                      "12px",
                                                                    overflowY:
                                                                      "auto",
                                                                    fontSize:
                                                                      "15px",
                                                                    lineHeight: 1.6,
                                                                    color:
                                                                      "#111827",
                                                                    whiteSpace:
                                                                      "pre-wrap",
                                                                    fontFamily:
                                                                      "inherit",
                                                                    opacity:
                                                                      isGenerating
                                                                        ? 0.4
                                                                        : 1,
                                                                    transition:
                                                                      "opacity 0.3s ease",
                                                                    pointerEvents:
                                                                      isGenerating
                                                                        ? "none"
                                                                        : "auto",
                                                                    width:
                                                                      "100%",
                                                                  }}
                                                                  onInput={(
                                                                    e,
                                                                  ) => {
                                                                    const caretPos =
                                                                      saveCaretPosition(
                                                                        e.currentTarget,
                                                                      );
                                                                    handleChange(
                                                                      question.id,
                                                                      e
                                                                        .currentTarget
                                                                        .innerHTML,
                                                                    );

                                                                    setTimeout(
                                                                      () => {
                                                                        if (
                                                                          contentEditableRef.current &&
                                                                          caretPos !==
                                                                            null
                                                                        ) {
                                                                          restoreCaretPosition(
                                                                            contentEditableRef.current,
                                                                            caretPos,
                                                                          );
                                                                        }
                                                                      },
                                                                      0,
                                                                    );
                                                                  }}
                                                                  dangerouslySetInnerHTML={{
                                                                    __html:
                                                                      normalizeHTMLStructure(
                                                                        rawValue.replace(
                                                                          /<(\/?)h2(.*?)>/gi,
                                                                          "<$1strong$2>",
                                                                        ),
                                                                      ),
                                                                  }}
                                                                />
                                                              );
                                                            }

                                                            // Plain textarea for non-HTML content
                                                            return (
                                                              <textarea
                                                                className="form-control form-control-lg"
                                                                readOnly={
                                                                  isGenerating
                                                                }
                                                                style={{
                                                                  height:
                                                                    "500px",
                                                                  backgroundColor:
                                                                    "#fff",
                                                                  borderRadius:
                                                                    "8px",
                                                                  border:
                                                                    "1px solid #e5e7eb",
                                                                  fontFamily:
                                                                    "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas",
                                                                  fontSize:
                                                                    "14px",
                                                                  whiteSpace:
                                                                    "pre-wrap",
                                                                  lineHeight: 1.6,
                                                                  padding:
                                                                    "12px",
                                                                  resize:
                                                                    "vertical",
                                                                  opacity:
                                                                    isGenerating
                                                                      ? 0.4
                                                                      : 1,
                                                                  transition:
                                                                    "opacity 0.3s ease",
                                                                  pointerEvents:
                                                                    isGenerating
                                                                      ? "none"
                                                                      : "auto",
                                                                  width: "100%",
                                                                }}
                                                                onChange={(e) =>
                                                                  handleChange(
                                                                    question.id,
                                                                    e.target
                                                                      .value,
                                                                    question.inputFormat,
                                                                  )
                                                                }
                                                                value={rawValue}
                                                                maxLength={
                                                                  question.maxLength ||
                                                                  20000
                                                                }
                                                              />
                                                            );
                                                          })()}

                                                        {/* 🟩 Diff Preview */}
                                                        {diffOutput && (
                                                          <div
                                                            ref={diffPreviewRef}
                                                            className="diff-preview"
                                                            contentEditable={
                                                              false
                                                            }
                                                            style={{
                                                              position:
                                                                "relative",
                                                              backgroundColor:
                                                                "#f9fafb",
                                                              border:
                                                                isGenerating
                                                                  ? "2px solid #6576ff"
                                                                  : "1px solid #e5e7eb",
                                                              borderRadius:
                                                                "8px",
                                                              height: "500px",
                                                              padding: "16px",
                                                              overflowY: "auto",
                                                              fontSize: "15px",
                                                              lineHeight: 1.6,
                                                              color: "#111827",
                                                              whiteSpace:
                                                                "pre-wrap",
                                                              fontFamily:
                                                                "inherit",
                                                              scrollBehavior:
                                                                "smooth",
                                                              boxShadow:
                                                                isGenerating
                                                                  ? "0 0 0 3px rgba(101, 118, 255, 0.15)"
                                                                  : "none",
                                                              transition:
                                                                "all 0.3s ease",
                                                              width: "100%",
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                diffOutput.replace(
                                                                  /<(\/?)h2(.*?)>/gi,
                                                                  "<$1strong$2>",
                                                                ),
                                                            }}
                                                          />
                                                        )}

                                                        {/* 🌀 Loader Overlay */}
                                                        {isGenerating && (
                                                          <div
                                                            style={{
                                                              position:
                                                                "absolute",
                                                              inset: 0,
                                                              backgroundColor:
                                                                "rgba(255, 255, 255, 0.75)",
                                                              backdropFilter:
                                                                "blur(3px)",
                                                              display: "flex",
                                                              flexDirection:
                                                                "column",
                                                              justifyContent:
                                                                "center",
                                                              alignItems:
                                                                "center",
                                                              gap: "20px",
                                                              borderRadius:
                                                                "8px",
                                                              zIndex: 10,
                                                            }}
                                                          >
                                                            {/* Animated Icon Circle */}
                                                            <div
                                                              style={{
                                                                width: "70px",
                                                                height: "70px",
                                                                borderRadius:
                                                                  "50%",
                                                                background:
                                                                  "linear-gradient(135deg, #6576ff 0%, #8b9cff 100%)",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                                animation:
                                                                  "pulse-scale 2s ease-in-out infinite",
                                                                boxShadow:
                                                                  "0 8px 24px rgba(101, 118, 255, 0.3)",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  width: "58px",
                                                                  height:
                                                                    "58px",
                                                                  borderRadius:
                                                                    "50%",
                                                                  backgroundColor:
                                                                    "#fff",
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                }}
                                                              >
                                                                <em
                                                                  className="icon ni ni-spark-fill"
                                                                  style={{
                                                                    fontSize:
                                                                      "30px",
                                                                    color:
                                                                      "#6576ff",
                                                                    animation:
                                                                      "spin 2s linear infinite",
                                                                  }}
                                                                />
                                                              </div>
                                                            </div>

                                                            {/* Text */}
                                                            <div
                                                              style={{
                                                                textAlign:
                                                                  "center",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  fontWeight: 600,
                                                                  fontSize:
                                                                    "18px",
                                                                  color:
                                                                    "#111827",
                                                                  marginBottom:
                                                                    "8px",
                                                                }}
                                                              >
                                                                Generating
                                                                Content
                                                              </div>
                                                              <div
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#6b7280",
                                                                }}
                                                              >
                                                                AI is working on
                                                                your prompt...
                                                              </div>
                                                            </div>

                                                            {/* Animated Progress Bar */}
                                                            <div
                                                              style={{
                                                                width: "220px",
                                                                height: "4px",
                                                                backgroundColor:
                                                                  "#e5e7eb",
                                                                borderRadius:
                                                                  "2px",
                                                                overflow:
                                                                  "hidden",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  height:
                                                                    "100%",
                                                                  width: "40%",
                                                                  background:
                                                                    "linear-gradient(90deg, #6576ff 0%, #8b9cff 100%)",
                                                                  borderRadius:
                                                                    "2px",
                                                                  animation:
                                                                    "loading 1.5s ease-in-out infinite",
                                                                }}
                                                              />
                                                            </div>
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>

                                                    {/* Widget Preview Container - for Embed Code questions */}
                                                    {question.questionText ===
                                                      "Embed Code" && (
                                                      <div
                                                        style={{
                                                          flexShrink: 0,
                                                          width: "360px",
                                                          marginLeft: "40px",
                                                        }}
                                                      >
                                                        {/* Header */}
                                                        <div
                                                          style={{
                                                            marginBottom:
                                                              "16px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          <h3
                                                            style={{
                                                              margin:
                                                                "0 0 6px 0",
                                                              fontSize:
                                                                "0.875rem",
                                                              fontWeight: "600",
                                                              color: "#344357",
                                                            }}
                                                          >
                                                            Widget Preview
                                                          </h3>
                                                          <p
                                                            style={{
                                                              margin: "0",
                                                              fontSize: "13px",
                                                              color: "#6b7280",
                                                              lineHeight: "1.4",
                                                            }}
                                                          >
                                                            Live preview of how
                                                            the widget will
                                                            appear on your
                                                            website
                                                          </p>
                                                        </div>
                                                        {isLeadFormEnabled ? (
                                                          /* 🟢 LEAD FORM PREVIEW MODE */
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "center",
                                                              marginTop: "8px",
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                width: "340px",
                                                                borderRadius:
                                                                  "16px",
                                                                backgroundColor:
                                                                  "#0b1221",
                                                                color: "#fff",
                                                                boxShadow:
                                                                  "0 6px 24px rgba(0,0,0,0.25)",
                                                                fontFamily:
                                                                  "'Segoe UI', Roboto, -apple-system, BlinkMacSystemFont, sans-serif",
                                                                overflow:
                                                                  "hidden",
                                                                textAlign:
                                                                  "center",
                                                                padding:
                                                                  "22px 20px",
                                                                position:
                                                                  "relative",
                                                              }}
                                                            >
                                                              {/* Close Icon */}
                                                              <div
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  right: "18px",
                                                                  top: "14px",
                                                                  fontSize:
                                                                    "18px",
                                                                  color:
                                                                    "#9ca3af",
                                                                  cursor:
                                                                    "not-allowed",
                                                                }}
                                                              >
                                                                ✕
                                                              </div>

                                                              {/* Header Icon */}
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                  marginBottom:
                                                                    "10px",
                                                                }}
                                                              >
                                                                <em
                                                                  className="icon ni ni-call"
                                                                  style={{
                                                                    fontSize:
                                                                      "20px",
                                                                    color:
                                                                      "#d4af37", // ✅ fixed gold
                                                                  }}
                                                                ></em>
                                                              </div>

                                                              {/* Title */}
                                                              <h4
                                                                style={{
                                                                  fontSize:
                                                                    "16px",
                                                                  fontWeight:
                                                                    "600",
                                                                  marginBottom:
                                                                    "2px",
                                                                }}
                                                              >
                                                                Connect with{" "}
                                                                {(
                                                                  previewAgentName ||
                                                                  "Maya"
                                                                ).replace(
                                                                  /<[^>]+>/g,
                                                                  "",
                                                                )}
                                                              </h4>

                                                              {/* Subtitle */}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "12.5px",
                                                                  color:
                                                                    "#cbd5e1",
                                                                  marginBottom:
                                                                    "14px",
                                                                }}
                                                              >
                                                                Provide your
                                                                information to
                                                                start your
                                                                consultation
                                                              </p>

                                                              {/* Inputs */}
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  flexDirection:
                                                                    "column",
                                                                  gap: "8px",
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                {/* Full Name */}
                                                                <label
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    fontWeight:
                                                                      "500",
                                                                    marginBottom:
                                                                      "0px",
                                                                  }}
                                                                >
                                                                  Full Name{" "}
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#f87171",
                                                                    }}
                                                                  >
                                                                    *
                                                                  </span>
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  placeholder="Enter your full name"
                                                                  disabled
                                                                  style={{
                                                                    padding:
                                                                      "9px 11px",
                                                                    borderRadius:
                                                                      "8px",
                                                                    border:
                                                                      "1px solid #1e293b",
                                                                    backgroundColor:
                                                                      "#111827",
                                                                    color:
                                                                      "#e2e8f0",
                                                                    fontSize:
                                                                      "13px",
                                                                  }}
                                                                />

                                                                {/* Email Address */}
                                                                <label
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    fontWeight:
                                                                      "500",
                                                                    marginTop:
                                                                      "4px",
                                                                    marginBottom:
                                                                      "0px",
                                                                  }}
                                                                >
                                                                  Email Address{" "}
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#f87171",
                                                                    }}
                                                                  >
                                                                    *
                                                                  </span>
                                                                </label>
                                                                <input
                                                                  type="email"
                                                                  placeholder="your.email@company.com"
                                                                  disabled
                                                                  style={{
                                                                    padding:
                                                                      "9px 11px",
                                                                    borderRadius:
                                                                      "8px",
                                                                    border:
                                                                      "1px solid #1e293b",
                                                                    backgroundColor:
                                                                      "#111827",
                                                                    color:
                                                                      "#e2e8f0",
                                                                    fontSize:
                                                                      "13px",
                                                                  }}
                                                                />

                                                                {/* USA Phone Number */}
                                                                <label
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    fontWeight:
                                                                      "500",
                                                                    marginTop:
                                                                      "4px",
                                                                    marginBottom:
                                                                      "0px",
                                                                  }}
                                                                >
                                                                  USA Phone
                                                                  Number{" "}
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#f87171",
                                                                    }}
                                                                  >
                                                                    *
                                                                  </span>
                                                                </label>
                                                                <input
                                                                  type="tel"
                                                                  placeholder="(555) 123-4567"
                                                                  disabled
                                                                  style={{
                                                                    padding:
                                                                      "9px 11px",
                                                                    borderRadius:
                                                                      "8px",
                                                                    border:
                                                                      "1px solid #1e293b",
                                                                    backgroundColor:
                                                                      "#111827",
                                                                    color:
                                                                      "#e2e8f0",
                                                                    fontSize:
                                                                      "13px",
                                                                  }}
                                                                />
                                                              </div>

                                                              {/* Info Note */}
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                  gap: "6px",
                                                                  marginTop:
                                                                    "10px",
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                <em
                                                                  className="icon ni ni-shield"
                                                                  style={{
                                                                    fontSize:
                                                                      "15px",
                                                                    color:
                                                                      "#d4af37", // ✅ fixed gold
                                                                    flexShrink: 0,
                                                                    marginTop:
                                                                      "1px",
                                                                  }}
                                                                ></em>

                                                                <p
                                                                  style={{
                                                                    fontSize:
                                                                      "11px",
                                                                    color:
                                                                      "#cbd5e1",
                                                                    lineHeight:
                                                                      "1.35",
                                                                    margin: 0,
                                                                  }}
                                                                >
                                                                  Your
                                                                  information is
                                                                  protected and
                                                                  will only be
                                                                  used to
                                                                  connect you
                                                                  with{" "}
                                                                  {(
                                                                    previewAgentName ||
                                                                    "Maya"
                                                                  ).replace(
                                                                    /<[^>]+>/g,
                                                                    "",
                                                                  )}
                                                                  .
                                                                </p>
                                                              </div>

                                                              {/* Button */}
                                                              <button
                                                                disabled
                                                                style={{
                                                                  marginTop:
                                                                    "14px",
                                                                  width: "100%",
                                                                  backgroundColor:
                                                                    "#d4af37",
                                                                  color: "#000",
                                                                  border:
                                                                    "none",
                                                                  borderRadius:
                                                                    "8px",
                                                                  padding:
                                                                    "10px",
                                                                  fontWeight:
                                                                    "600",
                                                                  fontSize:
                                                                    "14px",
                                                                  cursor:
                                                                    "not-allowed",
                                                                }}
                                                              >
                                                                Start
                                                                Consultation
                                                              </button>
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          /* 🟡 AI WIDGET PREVIEW MODE */
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              gap: "16px",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            {/* === Left: Theme Color Picker === */}
                                                            <div>
                                                              <div
                                                                style={{
                                                                  flex: "0 0 auto",
                                                                  padding:
                                                                    "12px",
                                                                  backgroundColor:
                                                                    "#f8fafc",
                                                                  borderRadius:
                                                                    "10px",
                                                                  border:
                                                                    "1px solid #e2e8f0",
                                                                  minWidth:
                                                                    "120px",
                                                                  boxShadow:
                                                                    "0 1px 3px rgba(0, 0, 0, 0.04)",
                                                                }}
                                                              >
                                                                <label
                                                                  className="form-label"
                                                                  style={{
                                                                    fontSize:
                                                                      "0.75rem",
                                                                    fontWeight:
                                                                      "600",
                                                                    color:
                                                                      "#374151",
                                                                    marginBottom:
                                                                      "10px",
                                                                    display:
                                                                      "block",
                                                                    textAlign:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  Theme Color
                                                                </label>

                                                                {/* Color Picker + Reset */}
                                                                <div
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    flexDirection:
                                                                      "column",
                                                                    gap: "10px",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  <div
                                                                    style={{
                                                                      position:
                                                                        "relative",
                                                                      display:
                                                                        "flex",
                                                                      alignItems:
                                                                        "center",
                                                                      justifyContent:
                                                                        "center",
                                                                      gap: "10px",
                                                                    }}
                                                                  >
                                                                    <input
                                                                      type="color"
                                                                      value={
                                                                        selectedThemeColor
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) => {
                                                                        const newColor =
                                                                          e
                                                                            .target
                                                                            .value;
                                                                        setSelectedThemeColor(
                                                                          newColor,
                                                                        );
                                                                        setPreviewThemeColor(
                                                                          newColor,
                                                                        );
                                                                        const embedCodeQuestion =
                                                                          formData[0]?.questions.find(
                                                                            (
                                                                              q,
                                                                            ) =>
                                                                              q.questionText ===
                                                                              "Embed Code",
                                                                          );
                                                                        if (
                                                                          embedCodeQuestion &&
                                                                          formState[
                                                                            embedCodeQuestion
                                                                              .id
                                                                          ]
                                                                        ) {
                                                                          const currentCode =
                                                                            formState[
                                                                              embedCodeQuestion
                                                                                .id
                                                                            ];
                                                                          const updatedCode =
                                                                            currentCode.replace(
                                                                              /theme="[^"]*"/,
                                                                              `theme="${newColor}"`,
                                                                            );
                                                                          handleChange(
                                                                            embedCodeQuestion.id,
                                                                            updatedCode,
                                                                          );
                                                                        }
                                                                      }}
                                                                      style={{
                                                                        width:
                                                                          "44px",
                                                                        height:
                                                                          "44px",
                                                                        border:
                                                                          "2px solid #e5e7eb",
                                                                        borderRadius:
                                                                          "8px",
                                                                        cursor:
                                                                          "pointer",
                                                                        padding:
                                                                          "2px",
                                                                        backgroundColor:
                                                                          "#ffffff",
                                                                        boxShadow:
                                                                          "0 1px 2px rgba(0, 0, 0, 0.05)",
                                                                      }}
                                                                    />

                                                                    {/* Reset Button */}
                                                                    <button
                                                                      type="button"
                                                                      title="Reset to Default Theme"
                                                                      onClick={() => {
                                                                        const defaultColor =
                                                                          "#d4af37";
                                                                        setSelectedThemeColor(
                                                                          defaultColor,
                                                                        );
                                                                        setPreviewThemeColor(
                                                                          defaultColor,
                                                                        );
                                                                        localStorage.setItem(
                                                                          "selectedThemeColor",
                                                                          defaultColor,
                                                                        );
                                                                        const embedCodeQuestion =
                                                                          formData[0]?.questions.find(
                                                                            (
                                                                              q,
                                                                            ) =>
                                                                              q.questionText ===
                                                                              "Embed Code",
                                                                          );
                                                                        if (
                                                                          embedCodeQuestion &&
                                                                          formState[
                                                                            embedCodeQuestion
                                                                              .id
                                                                          ]
                                                                        ) {
                                                                          const currentCode =
                                                                            formState[
                                                                              embedCodeQuestion
                                                                                .id
                                                                            ];
                                                                          const updatedCode =
                                                                            currentCode.replace(
                                                                              /theme="[^"]*"/,
                                                                              `theme="${defaultColor}"`,
                                                                            );
                                                                          handleChange(
                                                                            embedCodeQuestion.id,
                                                                            updatedCode,
                                                                          );
                                                                        }
                                                                      }}
                                                                      style={{
                                                                        backgroundColor:
                                                                          "#ffffff",
                                                                        border:
                                                                          "1px solid #e5e7eb",
                                                                        borderRadius:
                                                                          "50%",
                                                                        width:
                                                                          "32px",
                                                                        height:
                                                                          "32px",
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        justifyContent:
                                                                          "center",
                                                                        cursor:
                                                                          "pointer",
                                                                        boxShadow:
                                                                          "0 1px 2px rgba(0,0,0,0.06)",
                                                                      }}
                                                                    >
                                                                      <i
                                                                        className="ni ni-reload"
                                                                        style={{
                                                                          fontSize:
                                                                            "14px",
                                                                          color:
                                                                            selectedThemeColor ===
                                                                            "#d4af37"
                                                                              ? "#b7791f"
                                                                              : "#475569",
                                                                        }}
                                                                      ></i>
                                                                    </button>
                                                                  </div>

                                                                  <div
                                                                    style={{
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                  >
                                                                    <span
                                                                      style={{
                                                                        fontSize:
                                                                          "11px",
                                                                        color:
                                                                          "#374151",
                                                                        fontWeight:
                                                                          "500",
                                                                        display:
                                                                          "block",
                                                                        marginBottom:
                                                                          "2px",
                                                                      }}
                                                                    >
                                                                      {
                                                                        selectedThemeColor
                                                                      }
                                                                    </span>
                                                                    <p
                                                                      style={{
                                                                        margin: 0,
                                                                        fontSize:
                                                                          "10px",
                                                                        color:
                                                                          "#6b7280",
                                                                        lineHeight:
                                                                          "1.3",
                                                                      }}
                                                                    >
                                                                      Click to
                                                                      customize
                                                                    </p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            {/* === Right: AI Widget Preview === */}
                                                            <div
                                                              style={{
                                                                flex: "1",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  borderRadius:
                                                                    "20px",
                                                                  overflow:
                                                                    "hidden",
                                                                  width:
                                                                    "340px",
                                                                  minHeight:
                                                                    "445px",
                                                                  boxShadow:
                                                                    "0 6px 24px rgba(0,0,0,0.25)",
                                                                  fontFamily:
                                                                    "'Segoe UI', Roboto, -apple-system, BlinkMacSystemFont, sans-serif",
                                                                  backgroundColor:
                                                                    "#0b0c10",
                                                                  color: "#fff",
                                                                  display:
                                                                    "flex",
                                                                  flexDirection:
                                                                    "column",
                                                                }}
                                                              >
                                                                {/* Header */}
                                                                <div
                                                                  style={{
                                                                    backgroundColor:
                                                                      previewThemeColor ||
                                                                      "#d4af37",
                                                                    color:
                                                                      "#000",
                                                                    padding:
                                                                      "14px 18px 10px",
                                                                  }}
                                                                >
                                                                  <div
                                                                    style={{
                                                                      display:
                                                                        "flex",
                                                                      alignItems:
                                                                        "center",
                                                                      gap: "6px",
                                                                      fontWeight: 600,
                                                                      fontSize:
                                                                        "16px",
                                                                    }}
                                                                  >
                                                                    <em
                                                                      className="icon ni ni-mic"
                                                                      style={{
                                                                        fontSize:
                                                                          "16px",
                                                                        color:
                                                                          "#000",
                                                                      }}
                                                                    ></em>
                                                                    <span>
                                                                      {(
                                                                        previewAgentName ||
                                                                        "Maya"
                                                                      ).replace(
                                                                        /<[^>]+>/g,
                                                                        "",
                                                                      )}
                                                                    </span>
                                                                  </div>
                                                                  <div
                                                                    style={{
                                                                      fontSize:
                                                                        "12px",
                                                                      fontWeight: 400,
                                                                      marginTop:
                                                                        "2px",
                                                                      color:
                                                                        "#000",
                                                                    }}
                                                                  >
                                                                    Available
                                                                    24/7
                                                                  </div>
                                                                </div>

                                                                {/* Body */}
                                                                <div
                                                                  style={{
                                                                    padding:
                                                                      "38px 24px 36px",
                                                                    textAlign:
                                                                      "center",
                                                                    flexGrow: 1,
                                                                  }}
                                                                >
                                                                  <div
                                                                    style={{
                                                                      width:
                                                                        "72px",
                                                                      height:
                                                                        "72px",
                                                                      margin:
                                                                        "0 auto 24px",
                                                                      display:
                                                                        "flex",
                                                                      alignItems:
                                                                        "center",
                                                                      justifyContent:
                                                                        "center",
                                                                    }}
                                                                  >
                                                                    <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      fill="none"
                                                                      viewBox="0 0 24 24"
                                                                      strokeWidth={
                                                                        2
                                                                      }
                                                                      stroke={
                                                                        previewThemeColor ||
                                                                        "#d4af37"
                                                                      }
                                                                      style={{
                                                                        width:
                                                                          "42px",
                                                                        height:
                                                                          "42px",
                                                                      }}
                                                                    >
                                                                      <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        d="M12 1.5a3 3 0 00-3 3v6a3 3 0 006 0v-6a3 3 0 00-3-3zM5.25 10.5v1.5a6.75 6.75 0 0013.5 0v-1.5M12 19.5v3m-4.5 0h9"
                                                                      />
                                                                    </svg>
                                                                  </div>

                                                                  <h6
                                                                    style={{
                                                                      fontSize:
                                                                        "20px",
                                                                      fontWeight: 600,
                                                                      marginBottom:
                                                                        "12px",
                                                                      color:
                                                                        "#ffffff",
                                                                    }}
                                                                  >
                                                                    Talk to{" "}
                                                                    {(
                                                                      previewAgentName ||
                                                                      "Maya"
                                                                    ).replace(
                                                                      /<[^>]+>/g,
                                                                      "",
                                                                    )}
                                                                  </h6>

                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "14px",
                                                                      color:
                                                                        "#d1d5db",
                                                                      margin:
                                                                        "0 auto 38px",
                                                                      lineHeight: 1.6,
                                                                      maxWidth:
                                                                        "270px",
                                                                    }}
                                                                  >
                                                                    Experience
                                                                    our advanced{" "}
                                                                    {(
                                                                      previewAgentName ||
                                                                      "Maya"
                                                                    ).replace(
                                                                      /<[^>]+>/g,
                                                                      "",
                                                                    )}{" "}
                                                                    voice agent
                                                                    with
                                                                    real-time
                                                                    conversation
                                                                    capabilities.
                                                                  </p>

                                                                  <button
                                                                    disabled
                                                                    style={{
                                                                      backgroundColor:
                                                                        previewThemeColor ||
                                                                        "#d4af37",
                                                                      color:
                                                                        "#000",
                                                                      border:
                                                                        "none",
                                                                      borderRadius:
                                                                        "8px",
                                                                      padding:
                                                                        "12px 20px",
                                                                      fontWeight: 600,
                                                                      fontSize:
                                                                        "15px",
                                                                      width:
                                                                        "100%",
                                                                      maxWidth:
                                                                        "270px",
                                                                      height:
                                                                        "48px",
                                                                      cursor:
                                                                        "not-allowed",
                                                                    }}
                                                                  >
                                                                    <em
                                                                      className="icon ni ni-mic"
                                                                      style={{
                                                                        fontSize:
                                                                          "18px",
                                                                        color:
                                                                          "#000",
                                                                        marginRight:
                                                                          "6px",
                                                                      }}
                                                                    ></em>
                                                                    Start{" "}
                                                                    {(
                                                                      previewAgentName ||
                                                                      "Maya"
                                                                    ).replace(
                                                                      /<[^>]+>/g,
                                                                      "",
                                                                    )}
                                                                  </button>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "datetime" && (
                                                <div className="form-group">
                                                  <DateTimePicker
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    fullWidth
                                                    format="MM-dd-yyyy hh:mm a"
                                                    value={
                                                      formState[question.id] ||
                                                      null
                                                    }
                                                    onChange={(date) =>
                                                      handleChange(
                                                        question.id,
                                                        date,
                                                      )
                                                    }
                                                  />
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "date" && (
                                                <div className="form-group">
                                                  <DatePicker
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    fullWidth
                                                    format="MM-dd-yyyy"
                                                    value={
                                                      formState[question.id] ||
                                                      null
                                                    }
                                                    onChange={(date) =>
                                                      handleChange(
                                                        question.id,
                                                        date,
                                                      )
                                                    }
                                                  />
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "time" && (
                                                <div className="form-group">
                                                  <TimePicker
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    fullWidth
                                                    value={
                                                      formState[question.id] ||
                                                      null
                                                    }
                                                    onChange={(time) =>
                                                      handleChange(
                                                        question.id,
                                                        time,
                                                      )
                                                    }
                                                  />
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "dropdown" && (
                                                <div className="form-group">
                                                  <div className="form-control-wrap">
                                                    <div className="form-control-select">
                                                      <select
                                                        className={`form-control form-control-lg`}
                                                        onChange={(e) =>
                                                          handleChange(
                                                            question.id,
                                                            e.target.value,
                                                          )
                                                        }
                                                        value={value}
                                                      >
                                                        <option value="">
                                                          Select an option
                                                        </option>
                                                        {question.options.map(
                                                          (option, index) => (
                                                            <option
                                                              key={index}
                                                              value={option}
                                                            >
                                                              {option}
                                                            </option>
                                                          ),
                                                        )}
                                                      </select>
                                                    </div>
                                                  </div>
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "checkbox" && (
                                                <>
                                                  <div className="mt-2 prettyprint ">
                                                    <div className="row">
                                                      {question.options.map(
                                                        (option, index) => (
                                                          <div
                                                            className="col-md-6 mb-1"
                                                            key={`options_${index}`}
                                                          >
                                                            <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                              <input
                                                                type="checkbox"
                                                                className="custom-control-input vdrSelected"
                                                                id={`question_checkbox_${question.id}_${index}`}
                                                                checked={
                                                                  formState[
                                                                    question.id
                                                                  ]?.includes(
                                                                    option,
                                                                  ) || false
                                                                }
                                                                onChange={(e) =>
                                                                  handleCheckboxChange(
                                                                    question.id,
                                                                    option,
                                                                    e.target
                                                                      .checked,
                                                                  )
                                                                }
                                                              />
                                                              <label
                                                                className="custom-control-label"
                                                                htmlFor={`question_checkbox_${question.id}_${index}`}
                                                              >
                                                                {option}
                                                              </label>
                                                            </div>
                                                            {formErrors[
                                                              question.id
                                                            ] && (
                                                              <FormHelperText
                                                                error
                                                              >
                                                                {
                                                                  formErrors[
                                                                    question.id
                                                                  ]
                                                                }
                                                              </FormHelperText>
                                                            )}
                                                          </div>
                                                        ),
                                                      )}
                                                    </div>
                                                  </div>
                                                </>
                                              )}

                                              {question.answerType ===
                                                "radio" && (
                                                <div className="form-pm-group">
                                                  <ul className="buysell-pm-list">
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <li
                                                          className="buysell-pm-item"
                                                          key={index}
                                                        >
                                                          <input
                                                            className="buysell-pm-control"
                                                            type="radio"
                                                            name={`radio_${question.id}`}
                                                            id={`radio_${question.id}_${index}`}
                                                            onChange={(e) =>
                                                              handleChange(
                                                                question.id,
                                                                option,
                                                              )
                                                            }
                                                            value={option}
                                                          />
                                                          <label
                                                            className="buysell-pm-label"
                                                            htmlFor={`radio_${question.id}_${index}`}
                                                          >
                                                            <span className="pm-name">
                                                              {option}
                                                            </span>
                                                            <span className="pm-icon">
                                                              {/*<em className="icon ni ni-question"></em>*/}
                                                            </span>
                                                          </label>
                                                        </li>
                                                      ),
                                                    )}
                                                  </ul>
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "image_input" && (
                                                <div className="form-group">
                                                  <div
                                                    className="form-control-group"
                                                    id="fileContainer"
                                                  >
                                                    <input
                                                      type="file"
                                                      id={`add_picture_${question.id}`}
                                                      className="file-block"
                                                      name="add_picture"
                                                      accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                      onChange={(e) =>
                                                        handleFileChange(
                                                          question.id,
                                                          e,
                                                        )
                                                      }
                                                    />
                                                    {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                    {formState[question.id] && (
                                                      <div className="uploaded-file-preview">
                                                        {formState[
                                                          question.id
                                                        ].match(
                                                          /\.(jpeg|jpg|png)$/i,
                                                        ) ? (
                                                          <>
                                                            <img
                                                              src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                                formState[
                                                                  question.id
                                                                ]
                                                              }`}
                                                              alt="Uploaded preview"
                                                              style={{
                                                                maxWidth:
                                                                  "100px",
                                                              }}
                                                            />
                                                            <a
                                                              onClick={() =>
                                                                removeUploadedFile(
                                                                  question.id,
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color: "red",
                                                                fontSize:
                                                                  "20px",
                                                                marginLeft:
                                                                  "5px",
                                                              }}
                                                              className="fs-20"
                                                              title="Delete"
                                                            >
                                                              <em className="icon ni ni-trash-fill"></em>
                                                            </a>
                                                          </>
                                                        ) : (
                                                          <p>
                                                            {formState[
                                                              question.id
                                                            ]
                                                              .split("/")
                                                              .pop()}
                                                            <a
                                                              onClick={() =>
                                                                removeUploadedFile(
                                                                  question.id,
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color: "red",
                                                                fontSize:
                                                                  "20px",
                                                                marginLeft:
                                                                  "5px",
                                                              }}
                                                              className="fs-20"
                                                              title="Delete"
                                                            >
                                                              <em className="icon ni ni-trash-fill"></em>
                                                            </a>
                                                          </p> // Display file name for non-images
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* CAPTCHA Section - Show on last step for multi-step forms or on single-step forms */}
                          {shouldShowCaptcha && (
                            <div
                              className="captcha-section"
                              style={{
                                marginTop: "20px",
                                marginBottom: "10px",
                              }}
                            >
                              <ReCAPTCHA
                                ref={captchaRef}
                                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                onChange={handleCaptchaChange}
                                onExpired={handleCaptchaExpired}
                              />
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              marginTop: "20px",
                            }}
                          >
                            {currentStep > 0 && (
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => setCurrentStep(currentStep - 1)}
                              >
                                Back
                              </Button>
                            )}
                            {currentStep < groups.length - 1 ? (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNextStep}
                                style={{ marginLeft: "10px" }}
                                disabled={loading || isFormInReviewMode}
                              >
                                Save & Continue
                              </Button>
                            ) : (
                              <>
                                {allow_submit === 1 && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    style={{ marginLeft: "10px" }}
                                    disabled={loading || isFormInReviewMode}
                                  >
                                    {loading ? "Loading..." : "Save & Finish"}
                                  </Button>
                                )}
                                {allow_submit === 0 && (
                                  <button
                                    type="button"
                                    className="btn btn-outline-warning"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    Submission is disabled for this form.
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            ) : (
              hasUngroupedQuestions && (
                <>
                  <div className="nk-block nk-block-lg">
                    <div className="card">
                      <form
                        autoComplete="off"
                        className="nk-stepper stepper-init is-alter nk-stepper-s1"
                        action="#"
                        id="stepper-create-project"
                        data-step-current="2"
                        noValidate
                        style={{ display: "block" }}
                      >
                        <div className="row g-0 col-sep col-sep-md col-sep-xl">
                          <div className="col-md-3 col-xl-3">
                            <div className="card-inner">
                              <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                                {groups.map((group, index) => (
                                  <li
                                    key={group.id}
                                    className={
                                      currentStep === index
                                        ? "current"
                                        : currentStep > index
                                          ? "done"
                                          : ""
                                    }
                                  >
                                    <div className="step-item">
                                      <div className="step-text">
                                        <div className="lead-text">
                                          {group.group_title}
                                        </div>
                                        <div
                                          className="sub-text"
                                          dangerouslySetInnerHTML={{
                                            __html: group.group_desc,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>

                          <div className="col-md-9 col-xl-9">
                            <div className="card-inner">
                              <div className="nk-stepper-content">
                                <div className="nk-stepper-steps stepper-steps">
                                  <div className="nk-kycfm">
                                    <div
                                      className="nk-kycfm-head"
                                      style={{ background: "#f5f6fa" }}
                                    >
                                      <div className="nk-kycfm-title">
                                        <h5 className="title">
                                          {formTitle || "Untitled Form"}
                                        </h5>
                                        <p className="sub-title">
                                          {formDescription || "Untitled Form"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="nk-kycfm-content">
                                      {responseMessage && (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: responseMessage,
                                          }}
                                        ></div>
                                      )}
                                      {errorMessage && (
                                        <div className="alert alert-danger alert-icon mb-3">
                                          <em className="icon ni ni-cross-circle"></em>{" "}
                                          Please fill out all the required
                                          questions!
                                        </div>
                                      )}
                                      <div className="row g-gs">
                                        {ungroupedQuestions.map((question) => (
                                          <div
                                            key={question.id}
                                            className="question-container col-sm-6"
                                          >
                                            <div className="form-group question-text mb-0">
                                              <label className="form-label">
                                                {question.questionText}{" "}
                                                {question.required && (
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                )}
                                                {question.tooltip &&
                                                  question.tooltip.trim() !==
                                                    "" && (
                                                    <div className="custom-tooltip-wrapper">
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                          marginLeft: "5px",
                                                          cursor: "pointer",
                                                          fontSize: "16px",
                                                        }}
                                                      ></em>

                                                      <div
                                                        className="custom-tooltip-box"
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            question.tooltip,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  )}
                                              </label>
                                            </div>
                                            {question.imageUrl && (
                                              <img
                                                src={question.imageUrl}
                                                alt="Admin Uploaded"
                                                className="question-image"
                                              />
                                            )}
                                            {question.answerType ===
                                              "input" && (
                                              <div className="form-group mb-0">
                                                <div className="form-control-wrap">
                                                  <input
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    type="text"
                                                    maxLength={100}
                                                  />
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "textarea" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <textarea
                                                    className={`form-control form-control-lg`}
                                                    style={{ height: "500px" }}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                        question.inputFormat,
                                                      )
                                                    }
                                                    placeholder=""
                                                    maxLength={
                                                      question.maxLength ||
                                                      20000
                                                    }
                                                  ></textarea>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "datetime" && (
                                              <div className="form-group">
                                                <DateTimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy hh:mm a"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "date" && (
                                              <div className="form-group">
                                                <DatePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "time" && (
                                              <div className="form-group">
                                                <TimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(time) =>
                                                    handleChange(
                                                      question.id,
                                                      time,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "dropdown" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <div className="form-control-select">
                                                    <select
                                                      className={`form-control form-control-lg`}
                                                      onChange={(e) =>
                                                        handleChange(
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                    >
                                                      <option value="">
                                                        Select an option
                                                      </option>
                                                      {question.options.map(
                                                        (option, index) => (
                                                          <option
                                                            key={index}
                                                            value={option}
                                                          >
                                                            {option}
                                                          </option>
                                                        ),
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "checkbox" && (
                                              <>
                                                <div className="mt-2 prettyprint ">
                                                  <div className="row">
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <div
                                                          className="col-md-6 mb-1"
                                                          key={`options_${index}`}
                                                        >
                                                          <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                            <input
                                                              type="checkbox"
                                                              className="custom-control-input vdrSelected"
                                                              id={`question_checkbox_${question.id}_${index}`}
                                                              checked={
                                                                formState[
                                                                  question.id
                                                                ]?.includes(
                                                                  option,
                                                                ) || false
                                                              }
                                                              onChange={(e) =>
                                                                handleCheckboxChange(
                                                                  question.id,
                                                                  option,
                                                                  e.target
                                                                    .checked,
                                                                )
                                                              }
                                                            />
                                                            <label
                                                              className="custom-control-label"
                                                              htmlFor={`question_checkbox_${question.id}_${index}`}
                                                            >
                                                              {option}
                                                            </label>
                                                          </div>
                                                          {formErrors[
                                                            question.id
                                                          ] && (
                                                            <FormHelperText
                                                              error
                                                            >
                                                              {
                                                                formErrors[
                                                                  question.id
                                                                ]
                                                              }
                                                            </FormHelperText>
                                                          )}
                                                        </div>
                                                      ),
                                                    )}
                                                  </div>
                                                </div>
                                              </>
                                            )}

                                            {question.answerType ===
                                              "radio" && (
                                              <div className="form-pm-group">
                                                <ul className="buysell-pm-list">
                                                  {question.options.map(
                                                    (option, index) => (
                                                      <li
                                                        className="buysell-pm-item"
                                                        key={index}
                                                      >
                                                        <input
                                                          className="buysell-pm-control"
                                                          type="radio"
                                                          name={`radio_${question.id}`}
                                                          id={`radio_${question.id}_${index}`}
                                                          onChange={(e) =>
                                                            handleChange(
                                                              question.id,
                                                              option,
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          className="buysell-pm-label"
                                                          htmlFor={`radio_${question.id}_${index}`}
                                                        >
                                                          <span className="pm-name">
                                                            {option}
                                                          </span>
                                                          <span className="pm-icon">
                                                            {/*<em className="icon ni ni-question"></em>*/}
                                                          </span>
                                                        </label>
                                                      </li>
                                                    ),
                                                  )}
                                                </ul>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "image_input" && (
                                              <div className="form-group">
                                                <div
                                                  className="form-control-group"
                                                  id="fileContainer"
                                                >
                                                  <input
                                                    type="file"
                                                    id={`add_picture_${question.id}`}
                                                    className="file-block"
                                                    name="add_picture"
                                                    accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                    onChange={(e) =>
                                                      handleFileChange(
                                                        question.id,
                                                        e,
                                                      )
                                                    }
                                                  />
                                                  {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                  {formState[question.id] && (
                                                    <div className="uploaded-file-preview">
                                                      {formState[
                                                        question.id
                                                      ].match(
                                                        /\.(jpeg|jpg|png)$/i,
                                                      ) ? (
                                                        <>
                                                          <img
                                                            src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                              formState[
                                                                question.id
                                                              ]
                                                            }`}
                                                            alt="Uploaded preview"
                                                            style={{
                                                              maxWidth: "100px",
                                                            }}
                                                          />
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </>
                                                      ) : (
                                                        <p>
                                                          {formState[
                                                            question.id
                                                          ]
                                                            .split("/")
                                                            .pop()}
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </p> // Display file name for non-images
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* CAPTCHA Section for single-step/ungrouped forms */}
                            {shouldShowCaptcha && (
                              <div
                                className="captcha-section"
                                style={{
                                  marginTop: "20px",
                                  marginBottom: "10px",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <ReCAPTCHA
                                  ref={captchaRef}
                                  sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                  onChange={handleCaptchaChange}
                                  onExpired={handleCaptchaExpired}
                                />
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "20px",
                              }}
                            >
                              {allowSkip === 1 &&
                                isOnboarding &&
                                isFilled !== 1 &&
                                isSkipped !== 1 && (
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={onSkipStep}
                                    style={{
                                      marginRight: "10px",
                                    }}
                                    className="skip-button-mobile"
                                  >
                                    <em className="icon ni ni-forward"></em>{" "}
                                    Skip This Step
                                  </Button>
                                )}
                              {(isFilled === 1 || isSkipped === 1) && (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={onNextStep}
                                  style={{
                                    marginRight: "10px",
                                  }}
                                  className="next-button-mobile"
                                >
                                  <em className="icon ni ni-forward"></em> Next
                                  Step
                                </Button>
                              )}
                              {allow_submit === 1 && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleSubmit}
                                  style={{ marginLeft: "10px" }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )
            )}
          </>
        ) : null}
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default FormRendererAgent;
